// ⛔ FIRST IMPORT, ON PURPOSE: ES modules evaluate in import order, so this installs the app's error handler
// (`AppErrorReport`) before any other module of the bundle runs. Pinned by `AppErrorReport.test.ts`.
import { AppErrorReporting } from "./AppErrorInstall";
import { AppSendPush } from "./AppSendPush";
import { AppAssistLogClick, AppEventTarget } from "./AppEventTarget";
import { getCoreUtils, nz } from "../../../Admin/kReusableCoreTS/kCoreHandler";
import { kHTMLCore } from "../../../Admin/kReusableCoreTS/kHTMLCore";
import { kViewportHeightVar } from "../../../Admin/ReUsableTS/kMobileLayout";
import { AppPush } from "./AppPush";
import { AppPhoneChat } from "./AppPhoneChat";
import { AppPhoneChatRun, AppPhoneChatTaskShow, AppPhoneTaskBadge } from "./AppPhoneChatRun";
import { kHashRouter } from "../../../Admin/ReUsableTS/kHashRouter";
import { AppContact, AppIndex, AppIndexReader, AppRow } from "./AppIndex";
import { AppLocalSource, AppSource } from "./AppSource";
import { AppDropboxSource } from "./AppDropboxSource";
import { AppArchiveStore } from "./AppArchiveStore";
import { AppOutbox, AppSendRequest } from "./AppOutbox";
import { AppAttachmentComposer } from "./AppAttachmentComposer";
import { AppMessageContext } from "./AppMessageContext";
import { AppMessageAnchors } from "./AppMessageAnchors";
import { AppViews } from "./AppViews";
import { AppThemeRules, AppThemeView } from "./AppTheme";
import { AppThemeRun } from "./AppThemeRun";
import { AppTokens } from "./AppTokens";
import { AppIcons } from "./AppIcons";
import { AppOverview } from "./AppOverview";
import { AppOverviewView } from "./AppOverviewView";
import { AppSignUp, SignUpState } from "./AppSignUp";
import { AppSendLine, AppSendVerdict, AppSignUpApi, SignUpAnswer } from "./AppSignUpApi";
import { AppSignUpPost } from "./AppSignUpPost";
import { ImportGate, PickedFile } from "./ImportGate";
import { AppUnlockRun } from "./AppUnlockRun";
import { AppPlainSniff } from "./AppPlainSniff";
import { ImportPlainRules, PlainVerdict } from "./ImportPlain";
import { AppDropboxUpload } from "./AppDropboxUpload";
import { AppOneDrivePending, AppOneDriveReturn, AppOneDriveRules } from "./AppOneDrive";
import { AppOneDrivePendingStore, AppOneDriveUpload } from "./AppOneDriveRun";
import { DropboxIoRules } from "./DropboxIoRules";
import { WAC_VERSION } from "./AppShared";
import { AppAccount, AppLeaveAnswer, AppLeaveState, AppRelinkState, AppSignInState } from "./AppAccount";
import { AppAccountPost } from "./AppAccountPost";
import { AppMoney } from "./AppMoney";
import { AppMoneyModel } from "./AppMoneyModel";
import { AppMoneyRun } from "./AppMoneyRun";
import { AppAccountViews } from "./AppAccountViews";
import { AppHistoryAnswer, AppSendHistory } from "./AppSendHistory";
import { AppMediaFill } from "./AppMediaFill";
import { AppMediaQuery } from "./AppMediaQuery";
import { AppAvatarLoader, AppAvatarRules } from "./AppAvatars";
import { AppClaudeAnswer, AppClaudeState, AppClaudeToken } from "./AppClaudeToken";
import { AppClaudeView } from "./AppClaudeView";
import { AppNotice } from "./AppNotice";
import { AppImportStatus, ImportShown } from "./AppImportStatus";
import { AppImportPanel } from "./AppImportRun";
import { AppSearchPanel } from "./AppSearchPanel";
import { AppAskAll, AppAskForm } from "./AppAskAll";
import { AppChatAppend, IChatFrame } from "./AppChatAppend";
import { AppLiveFeed, AppLivePost, AppLiveWho, AppLiveWindowClock, IAppLiveFrame } from "./AppLiveFeed";
import { AppEditMark } from "./AppLiveEvents";
import { AppLiveAnswer, AppLiveListItem, AppLiveRules } from "./AppLiveRules";
import { AppLiveList, AppLiveListRules, AppLiveListWho, IAppLiveListHost } from "./AppLiveList";
import { AppChatRules, AppChatWord } from "./AppChatRules";
import { AppAiChat } from "./AppAiChat";
import { AppAiOutcomeSend, AppAiPanelStore, IAiOutcomeHost } from "./AppAiOutcome";
import { AppAssistApi } from "./AppAssistApi";
import { AppAssistRules, AppAssistSession } from "./AppAssistRules";
import { AppFrameSheet } from "./AppFrameSheet";
import { AppFrameHeal, IHealFrame } from "./AppFrameHeal";
import { AppShellGuard } from "./AppShellGuard";
import { AppAssistView } from "./AppAssistView";
import { AppAssistDone, AppAssistPanel, AppAssistWho, IAssistCopied, IAssistDoc, IAssistHost, IAssistNode } from "./AppAssistPanel";
import { AppAssistCopyJob, AppAssistTools } from "./AppAssistTools";
import { AppAssistStreamPost } from "./AppAssistStreamPost";
import { AppAssistWarmer, AppAssistWarmRules } from "./AppAssistWarm";
import { AppComposerModeSent, AppComposer, AppComposerView, IComposerBox, IComposerForm, IComposerSender, IComposerSent } from "./AppComposer";
import { AppReactions, IRxFrame, IRxHost } from "./AppReactions";
import { AppMsgActionBar, AppMsgActionRules, AppMsgTickPaint, IMaBarHost, IMaDoc } from "./AppMsgActions";
import { AppMarkRead } from "./AppMarkRead";
import { AppDemo } from "./AppDemo";
import { AppDemoSource } from "./AppDemoSource";
import { AppForwardPicker, AppForwardTarget, IFwDoc, IFwHost } from "./AppForward";
import { AppSearchActOpts, AppSearchActRules } from "./AppSearchActions";
import { IAppSearchActHost } from "./AppSearchActRun";
import { AppSearch, AppSearchHit } from "./AppSearch";
import { IRxPending } from "./AppReactPoll";
import { AppReactPoll, AppWindowLater } from "./AppReactPoll";
import { AppTaskRules } from "./AppTaskRules";
import { AppTaskView } from "./AppTaskView";
import { AppTaskAdd, AppTaskApi } from "./AppTaskApi";
import { AppTaskActions, AppTaskDone, IAppTaskDecided, IAppTaskHeard, IAppTaskHost } from "./AppTaskActions";
import { AppTaskNotifier, AppTaskNotifyView, IAppNotifyHost } from "./AppTaskNotify";
import { AppTaskBoard, IAppTaskBoardHost, IAppTaskEl } from "./AppTaskBoard";
import { AppTaskFrame, ITfFrame, ITfHost } from "./AppTaskFrame";
import { AppPinFrame, IPfFrame, IPfHost } from "./AppPinFrame";
import { AppDayFold, IDfFrame } from "./AppDayFold";
import { AppDayFloat, IDflFrame } from "./AppDayFloat";
import { AppTabBus, AppTabBusRules, AppTabNotice, AppTabPageLink, AppTabParts, AppTabSync, IAppTabOwner } from "./AppTabBus";
import { AppExport, AppExportWho } from "./AppExport";
import { AppExportRules } from "./AppExportRules";
import { AppPageScript } from "./AppPageScript";
import { AppTranslateBrowserPost, AppTranslator, AppTrLocalMemory, AppTrWindowLater } from "./AppTranslator";
import { AppTranslateLink, IAppTrPage } from "./AppTranslateLink";
import { AppTrDomScreen } from "./AppTranslateChip";
import { AppTranslateView } from "./AppTranslateView";
import { AppTranslateBubble } from "./AppTranslateBubble";
import { AppTrClipboard, IAppTrResent, ITrFrame } from "./AppTranslateFrame";
import { AppTranslateRules } from "./AppTranslateRules";
import { AppTrSendGate, AppTrSendJob, IAppTrSendPort } from "./AppTranslateSend";
import { AppSendExtra } from "./AppSource";
import { AppKeyFacts, AppKeyHost, AppKeyRules, AppKeys } from "./AppKeys";
import { AppTopBarRules, AppTopBarView, AppTopLink } from "./AppTopBar";
import { AppWaLink, AppWaNow } from "./AppWaLink";
import { AppTopBarRun } from "./AppTopBarRun";
import { AppStandingNow } from "./AppStanding";
import { AppStandingRun } from "./AppStandingRun";
import { AppChatHead } from "./AppChatHead";
import { AppChatArchiveWho } from "./AppChatArchiveRules";
import { AppChatListRead } from "./AppChatListRead";
import { AppChatMarks } from "./AppChatMarks";
import { AppChatMarksRules } from "./AppChatMarksRules";
import { AppNewChatAnswer, AppNewChatRules } from "./AppNewChat";
import { AppChatListRules } from "./AppChatListRules";
import { AppChatSettingsDialog, IAppChatSettingsHost } from "./AppChatSettingsDialog";
import { AppChatSettingsView } from "./AppChatSettingsView";
import { AppChatQuickView } from "./AppChatQuickView";
import { AppReplyFocus, IReplyFocusBox, IReplyFocusFrame, IReplyFocusTarget } from "./AppReplyFocus";
import { AppMenuRules, AppMenus, IMenuDoc, IMenuEl } from "./AppMenu";
import { AppSkeleton } from "./AppSkeleton";
import { AppRailItem, AppRailView } from "./AppRail";
import { AppFrameWide } from "./AppFrameWide";
import { AppLayout, AppThreeCol, AppThreeColRules, AppThreeColView, AppThreeDoc, IThreeEl, IThreeHost } from "./AppLayout";
import { AppFocus, AppFocusKeep, AppFocusMark, IFocusEl } from "./AppFocus";
import { AppFrameA11y, IFa11yFrame, IFrameA11yDoc } from "./AppFrameA11y";
import { AppTipRules, AppTips } from "./AppTips";
import { AppChatPropsFold } from "./AppChatPropsFold";
import { AppUpdateEvery } from "./AppUpdateEvery";
import { AppBubbleKinds, AppKindsFrame, IKindsFrame } from "./AppBubbleKinds";
import { AppPhoneTaskAddRun } from "./AppPhoneTaskAdd";

// The WACommander app - Chats, Tasks, Revenue over the folder the bridge writes.
//
// ⚠ IT READS. IT DOES NOT WRITE. One writer (design rule 5, `design-drive-folder-store.md`): the
// service owns every file in the folder, and an app that also wrote would race it and lose the
// manifest's ability to tell a human edit from a generated one. Editing arrives later, through the
// service, which is a different piece of work and not a missing half of this one.
//
// ⚠ ROUTING IS THE HASH, so the whole app is ONE static file with no server rewrites. The Azure
// static website (https://wacappf58706.z1.web.core.windows.net, storage account `wacappf58706`,
// container `$web`) has no per-path rewrite to lean on, and `file://` would need none at all - a
// path-routed app would always be broken in one of the two.

export class AppMain implements IAppTabOwner {
    // ⛔ THE GOOGLE SIGN-IN AND DRIVE PATHS WERE DELETED (2026-09-24), NOT LEFT DORMANT. The hosted
    // page's `wacClientId` was "", nothing wired Google sign-in to a button, and the owner ruled
    // Google out twice ("nothing running in the google cloud", "storing on Google is out"). Dead
    // code that still compiles is code somebody wires back to a live path; the copies are in the
    // session scratchpad. The archive is read and written through Dropbox tickets only.

    /** The one route that works without a folder, because its visitor does not have one yet. */
    public static readonly SignUpRoute: string = "signup";

    private Source: AppSource = new AppSource();
    /** Lays the contacts' WhatsApp pictures on the list's discs - one per source (`Faces`). */
    private FaceLoader: AppAvatarLoader | null = null;
    /** The Revenue view's controller (money ON), made once per visit. */
    private MoneyRunNow: AppMoneyRun | null = null;
    private FaceSource: AppSource | null = null;
    private Index: AppIndex = new AppIndex();
    private Where: HTMLElement | null = null;
    private SignUp: SignUpState = new SignUpState();
    /**
     * What the Chats search box holds.
     *
     * ⚠ A FIELD, SO IT SURVIVES A RE-RENDER. Opening a contact and pressing "All chats" repaints the
     * list; a filter kept only in the input would be gone, and the reader would be dropped back into
     * the full list they had just narrowed.
     */
    private Filter: string = "";
    /**
     * The WACommander service's own address, for `/subscribe`.
     *
     * ⚠ BLANK IS A WORKING STATE for every route except sign-up, which says so before the button is
     * pressed rather than failing identically on every press.
     */
    private ServiceUrl: string = "";
    /**
     * The number typed in the box, held only until the service answers.
     *
     * ⚠ IT IS NOT `SignUp.Number`, WHICH MEANS "ENROLLED". See `OnEnrolled` - conflating the two
     * advances the wizard past a sign-up that was refused.
     */
    private Typed: string = "";

    /** ⛔ ONE ATTEMPT AT THE READ TICKET PER PAGE - see `OpenArchive` for why a second would spin. */
    private Opening: boolean = false;
    /** Quiet `/folder` re-asks spent on transient refusals (`AppAccount.FolderRetryMs`). */
    private FolderTries: number = 0;
    private OnFolderRetry = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Opening = false;
            this.OpenArchive();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnFolderRetry");
        }
    };

    /**
     * True while `#import` ("Import a backup") owns the import step, false for sign-up.
     *
     * ⚠ ONE SET OF IMPORT HANDLERS SERVES BOTH, so there is one way to bring a history. This decides
     * only two things: which card `ShowSignUp` paints, and that the upload is authorised by the
     * archive KEY - never by a sign-up secret this tab may still hold, which expires in two hours.
     */
    private ImportLater: boolean = false;

    /** The id of the message whose fate the line under the box is reporting, or "". */
    private Watching: string = "";
    private Polls: number = 0;
    private SendTimer: number = 0;

    /**
     * The session secret `/claim` handed back.
     *
     * ⛔ A FIELD, NEVER `localStorage`, A COOKIE OR THE URL. It authorises requesting a pairing
     * code against this number and - once the handset has proved it - pointing this subscriber's
     * entire archive at a Dropbox. Storage outlives the tab and is readable by anything that gets
     * script into this origin; a URL is in history, in a referrer and in anything pasted.
     *
     * ⚠ THE COST IS THAT A RELOAD LOSES THE SIGN-UP, and that is the correct trade: `ClaimGate`
     * lets the same person re-claim their own provisional number, so the recovery is one step.
     */
    private Secret: string = "";

    /** The pairing poll. ⛔ ONE AT A TIME - see `OnPairPoll`. */
    private PairTimer: number = 0;
    /** The waiting screen's one-second tick (`OnWaitTick`) and when the wait began. Paints only; asks nothing. */
    private WaitTimer: number = 0;
    private WaitSince: number = 0;
    /** The sign-up screen last painted (`AppSignUp.ScreenOf`), so the focus moves only when it CHANGES. */
    private SignUpScreen: string = "";
    /** The backup chosen on this device, held until the key arrives. */
    private Picked: PickedFile | null = null;
    /**
     * The unlocked database, between the unlock and the upload.
     *
     * ⛔ IT IS DROPPED THE MOMENT THE UPLOAD OWNS IT, AND ON EVERY FAILURE. This is every message
     * the subscriber has ever sent or received, in the clear, on a page that may sit open for
     * hours - the same reasoning that keeps the 64-digit key off this object, applied to what the
     * key opens. ⚠ The subscriber still has the file, so the cost of dropping it is one unlock.
     */
    private Plain: Uint8Array | Blob | null = null;

    /**
     * The archive key this page was handed IN THIS VISIT (sign-in, or the sign-up's early `/folder`),
     * and the number it belongs to.
     *
     * ⚠ HELD HERE AS WELL AS IN `AppArchiveStore`, because storage may be blocked (private browsing)
     * and a key the page cannot save must still open the archive and close the account for the rest
     * of this visit. `KeyNow` / `NumberNow` read this first and the store second.
     */
    private SessionKey: string = "";
    private SessionNumber: string = "";
    /** `#signin`. ⚠ The Dropbox page is asked for ONCE per page (`SignInAsking`). */
    private SignIn: AppSignInState = new AppSignInState();
    private SignInAsking: boolean = false;
    /** `#leave`. */
    private Leaving: AppLeaveState = new AppLeaveState();
    /**
     * `/folder` said this browser is the OWNER'S own (`owner: true`) - the only thing that shows the
     * "Claude analysis" link. ⚠ Memory only, re-learned on every visit's ticket; never stored.
     */
    private IsOwner: boolean = false;
    /** `#claude`. ⛔ Never holds the token - see `AppClaudeToken`. */
    private Claude: AppClaudeState = new AppClaudeState();
    /** The re-link banner. ⛔ Shown only on the service's own `linked: false` (`ShowRelink`). */
    private Relink: AppRelinkState = new AppRelinkState();
    /** The re-link poll. ⛔ ONE AT A TIME, `poll` only - the `PairTimer` rule. */
    private RelinkTimer: number = 0;
    /** Which Sent request is current, so a late answer to an older one is ignored. */
    private SentSeq: number = 0;
    /** The "that worked" line at the top of the main screen - see `BackToMain`. */
    private Notice: AppNotice = new AppNotice();
    private NoticeTimer: number = 0;
    /** ⭐ What became of the uploaded backup (`AppImportStatus`): the watch, its timers and its line. Made on first use. */
    private Imports: AppImportPanel | null = null;
    /** The upload in flight, kept so its Dropbox `rev` can be read when it finishes (`OnImportDone`). */
    private Uploading: AppDropboxUpload | null = null;
    /** ⭐ WAVE 3: the OneDrive upload (a pre-authenticated address, no token), when the archive lives there. */
    private UploadingOne: AppOneDriveUpload | null = null;
    /** ⭐ WAVE 3: the state this page put into the OneDrive address it was given ("" = none asked). */
    private OneDriveState: string = "";
    /** The "imported" sentence waiting for the index re-read before the page goes back to the main screen. */
    private ImportedSay: string = "";
    /** The message half of the search, and the source it reads - rebuilt when the source changes. */
    private Search: AppSearchPanel | null = null;
    /** ⭐ "Ask about everyone" under the search box (`AppAskAll`) - owner only; its session lives for the visit. */
    private AskAll: AppAskAll | null = null;
    private SearchOf: AppSource | null = null;
    /** Draws the owner's sent messages into the open frame (`AppChatAppend`); one per frame. */
    private Appender: AppChatAppend | null = null;
    /** New incoming messages in the open frame within seconds (`AppLiveFeed`, `/live`); one per frame. */
    private Live: AppLiveFeed | null = null;
    /**
     * ⭐ THE CHAT LIST KEEPS UP WITHIN SECONDS (`AppLiveList`, `/live` in its `list` mode; 2026-09-28) - one per source,
     * running while the tab is hidden too (the tab title's count). `Unread` = chat id -> their messages since the page
     * loaded that the owner has not opened; it outlives an index re-read (`AppLiveListRules.Adopt`).
     */
    private ListFeed: AppLiveList | null = null;
    /** ⭐ The top bar (design item 7): wordmark, the chat search, the connection line, settings and help. */
    private TopBar: AppTopBarRun = new AppTopBarRun();
    /** ⭐ The account warning under the top bar (`AppStanding`, 2026-10-01) - fed by the list feed, shown only when not ok. */
    private StandingBar: AppStandingRun = new AppStandingRun();
    private ListFeedOf: AppSource | null = null;
    private Unread: Record<string, number> = {};
    /** The page's own title, read once - the count goes in front of it. */
    private BaseTitle: string = "";
    /** ⭐ The open view is a chat with NO page yet (`#n/<chat>`, its provisional page): no AI panel, export or translation. */
    private NewChat: boolean = false;
    /** The provisional page's one request (`ShowNewChat`), dropped when the owner goes elsewhere. */
    private NewChatPost: AppLivePost | null = null;
    /** Reacting to a message in the open frame (`AppReactions`); one per frame, null where nothing can be sent. */
    private Reactor: AppReactions | null = null;
    /** What was pressed Send on, held from the press until the request is accepted. */
    private SendingText: string = "";
    private SendingId: string = "";
    /** ⭐ The request being queued asked to be translated - its bubble reads "Translating…" until the service moves on. */
    private SendingTranslate: boolean = false;
    /**
     * Who pressed Send on the request in flight - the composer box or a draft card - told once how
     * it went (`AppComposerSend`). ⛔ Non-null means a send is in flight; a second is refused.
     */
    private SendTicket: IComposerSent | null = null;
    private UnknownSendingId: string = "";
    /**
     * The AI panel's conversation per contact href. ⭐ Since 2026-09-26 the saved part comes from the
     * contact's `ai-chat.json` in the owner's own Dropbox (written by the service, read with the read
     * ticket on every contact open); this map only carries this visit's entries between repaints. ⛔ Never
     * `localStorage` - the questions and answers are the owner's private conversations.
     */
    private Assists: Record<string, AppAssistSession> = {};
    /** The panel on screen now, and the composer it fills. Rebuilt with every contact paint. */
    private Assist: AppAssistPanel | null = null;
    /** ⭐ The owner's warm-up sender (`AppAssistWarm`) - one per page. */
    private Warmer: AppAssistWarmer = new AppAssistWarmer(AppMain.NoWarmPost);
    private Compose: AppComposer | null = null;
    private Attachments: AppAttachmentComposer | null = null;
    /** Whether the AI panel is open: -1 until the first contact decides it by the window's width. */
    private AssistOpen: number = -1;
    /** Where the panel is a column rather than a sheet - THE one breakpoint (`AppLayout`), also where the app is three panes. */
    public static readonly AssistWideQuery: string = AppLayout.WideQuery;
    /** ⭐ THE THREE-PANE SHELL ON A WIDE SCREEN (design item 12, `AppLayout`): made once, then only the center is rewritten. */
    private Three: AppThreeCol = new AppThreeCol();
    private ThreeDoc: AppThreeDoc = new AppThreeDoc();

    // ⭐ TASKS AS A FIRST-CLASS FEATURE (2026-09-26). ⛔ All of it is behind `AppTaskRules.Enabled` -
    // an index without the new fields keeps today's Tasks view, no strip, no frame actions, no preset.
    /** THE one sender of task changes (`POST /tasks`), shared by the tab, the strip and the frame. */
    private TaskActions: AppTaskActions = new AppTaskActions(new AppTaskHost(this));
    /** The Tasks tab / Today strip over the index in hand - rebuilt when the index changes. */
    private Board: AppTaskBoard | null = null;
    private BoardOf: AppIndex | null = null;
    /** Task actions on the open contact page; one per frame, stopped when the frame is replaced. */
    private TaskFramer: AppTaskFrame | null = null;
    /** "Reply about this task": the question the AI panel asks once the contact is painted. */
    private PendingAsk: string = "";
    /**
     * ⭐ "LET <NAME> KNOW?" (owner, 2026-09-26: closing a task is two clicks - close, then Send the
     * AI-written update). One per page, like `TaskActions`: the cards survive a re-render of the list
     * and go on navigation (`OnHashChange`). ⛔ Its only way out is `NotifySend`, from a Send click.
     */
    private Notifier: AppTaskNotifier = new AppTaskNotifier(new AppTaskNotifyLink(this));
    /** Which cards the region on screen shows: "" all (Tasks tab, Today strip), else one chat's. */
    private NotesHref: string = "";
    /** A card's Edit: the draft to put into the box once that chat is painted. */
    private PendingFill: string = "";
    /** ⭐ (2026-10-22) A search hit's Reply / Forward, carried out once its chat is drawn (`Wire`). Sends nothing. */
    private PendingMsgKind: string = "";
    private PendingMsgId: string = "";
    private PendingMsgText: string = "";
    private PendingMsgHref: string = "";
    private PendingFillHref: string = "";
    /** A reply-owed task row was opened: focus this chat's message box when it is wired (`Wire`). */
    private PendingFocusHref: string = "";
    /** The guard that keeps the message box's focus while the conversation loads at a linked message (null when none). */
    private ReplyFocus: AppReplyFocus | null = null;
    /** The chat the request in flight is addressed to - its bubble is drawn only in that chat. */
    private SendingHref: string = "";
    /**
     * ⭐ SEVERAL TABS (2026-09-27): notices to and from this subscriber's other open tabs (`AppTabBus`).
     * ⛔ `TabSync` hears them and can only change what is shown - it holds no sender.
     */
    private TabBus: AppTabBus = new AppTabBus();
    private TabSync: AppTabSync = new AppTabSync(new AppTabPageLink(this), new AppWindowLater());

    /**
     * ⭐ TRANSLATION (2026-09-27, `documentation/design/translation.md`): the chip, the frame's flag / Copy / failed-send
     * buttons and the earlier link for the open chat, and the visit's `/translate` state - which also decides whether a
     * send carries `translate: true` (`QueueTo`). ⛔ Its only way to a sender is `TranslateResend` (a click).
     */
    private Translate: AppTranslateLink = new AppTranslateLink(new AppTranslator(new AppTranslateBrowserPost(), new AppTrLocalMemory(), new AppTrWindowLater()),
        new AppTrPageLink(this), new AppLiveWindowClock(), new AppTrClipboard());
    /** ⭐ Whether a send carries `translate: true` - decided, stamped and held in ONE tested place. */
    private SendGate: AppTrSendGate = new AppTrSendGate(this.Translate.Translator);
    private NativeChatList: AppChatListRead | null = null;
    /** ⭐ The phone's pinned / unread / locked / blocked marks on the list (`AppChatMarks`). */
    private PhoneMarks: AppChatMarks | null = null;
    /** ⭐ "New chat" (`AppNewChat`): what is typed, the line under it, and the one check in flight. */
    private NcTyped: string = "";
    private NcSay: string = "";
    private NcBusy: boolean = false;
    /**
     * ⭐ THE "CHAT SETTINGS" DIALOG (owner, 2026-10-13; `AppChatSettingsDialog`): archive, notifications, disappearing
     * messages, the star and translation for ONE chat - the open one (the header's "⋯" and translation chip) or any
     * chat of the list (the "⋯" beside it). Made on first use; closed by a route change. ⛔ It holds no sender.
     */
    private ChatSettingsBox: AppChatSettingsDialog | null = null;
    /** The route the dialog was opened on. */
    private ChatSettingsHash: string = "";
    /** It was opened from the "⋯" beside a chat in the list (the keyboard goes back there), not from the open chat's header. */
    private ChatSettingsFromList: boolean = false;

    /**
     * `ServiceUrl` is the WACommander service's address, or "" for a copy that only reads the
     * folder beside it.
     *
     * ⛔ THE SERVICE URL IS THE LAST ARGUMENT, WHATEVER THE COUNT. The shell used to call
     * `Start(wacClientId, wacApiKey, wacProjectNumber, wacServiceUrl)`; it now calls
     * `Start(wacServiceUrl)`. Hosting caches `index.html` for up to an hour, so for that hour after
     * a deploy an OLD shell can load the NEW bundle - and reading the FIRST argument would take the
     * blank client id as the service address and silently turn sign-up off for everyone in it.
     */
    public Start = (...Args: string[]): void => {
        // ⛔ THE ERROR HANDLER FIRST (idempotent - the import above already installed it); nothing else may run before it.
        AppErrorReporting.InstallInBrowser();
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            // ⛔ THIS BUNDLE IN ANOTHER BUILD'S SHELL (a restored tab's cached index.html): load the page once more.
            if (AppShellGuard.Run() === true) { return; }
            // ⭐ THE OWNER'S THEME (light / dark / the device's) on <html> before anything is painted (`AppThemeRun`).
            AppThemeRun.Shared.Boot();
            // ⭐ NOTIFICATIONS (`AppPush`, the shared kWebPushClient): the settings menu's item, before the top bar is drawn.
            AppTopBarView.PushItem = AppPush.Item;
            // ⭐ A PHONE (shared kMobileLayout / kHashRouter): `--k-vh` = the visible height, so an open chat's message box stays
            // above the on-screen keyboard (app.css `body.detail`); and the Back gesture closes the top open <dialog>
            // (Chat settings, the quick finder, Forward ...) instead of leaving the screen. Modals only - the app keeps its
            // own hash routes (`OnHashChange`), which kHashRouter.Start would rewrite.
            const Viewport: kViewportHeightVar = new kViewportHeightVar("--k-vh");
            Viewport.KeyboardClass = AppPhoneChat.KeyboardClass;
            Viewport.OnKeyboard = this.OnKeyboard;
            Viewport.Attach();
            AppPhoneChatRun.Install();
            AppPhoneChatRun.OnAddTask = this.OpenChatTaskAdd;
            kHashRouter.StartModalsOnly();
            kHashRouter.WatchDialogs(document);
            // ⭐ THE TOP BAR (its settings menu holds the theme control).
            this.TopBar.Mount(AppThemeRun.Shared.Chosen());
            window.addEventListener("offline", this.ShowStatus);
            window.addEventListener("online", this.ShowStatus);
            window.setInterval(this.ShowStatus, AppMain.StatusEveryMs);
            // ⭐ THE WINDOW CROSSED THE ONE BREAKPOINT: a list view is drawn again in its new shape (`OnWideChange`).
            if (typeof window.matchMedia === "function") { window.matchMedia(AppLayout.WideQuery).addEventListener("change", this.OnWideChange); }
            this.ServiceUrl = "";
            if (Args.length > 0) { this.ServiceUrl = nz(Args[Args.length - 1]); }
            this.Where = document.getElementById("wac-app");
            if (this.Where === null) { return; }
            // ⭐ Enter in a sign-up / account field presses that step's own button (`OnFieldKey`). ONE listener on
            // the app element, because every paint replaces the fields themselves.
            this.Where.addEventListener("keydown", this.OnFieldKey);
            this.Where.addEventListener("input", this.OnFieldInput);
            // ⭐ A backup file dragged onto the import step's box is taken like a chosen one (`OnPickDrop`).
            this.Where.addEventListener("dragover", this.OnPickDrag);
            this.Where.addEventListener("dragleave", this.OnPickDrag);
            this.Where.addEventListener("drop", this.OnPickDrop);
            this.Footer();
            window.addEventListener("hashchange", this.OnHashChange);
            // ⭐ KEYBOARD SHORTCUTS + THE Ctrl/Cmd+K PALETTE (`AppKeys`) - after our own hashchange listener, on purpose.
            AppKeys.Install(new AppKeyHost(this));
            // (2026-10-14) The settings menu's "Mark chats read on WhatsApp when I open them" (`AppMarkRead`).
            AppMarkRead.Install();
            // ⭐ Notifications on this device (`AppPush`): the worker is registered where the browser can receive pushes.
            AppPush.Install(this.ServiceUrl);
            // DEMO MODE (`AppDemo`): the settings switch and, while on, its two choices in the same menu.
            AppDemo.Install();
            // ⭐ A TOOLTIP A FINGER AND THE KEYBOARD CAN REACH (`AppTips`, audit 2026-10-01): every `title` on the page.
            // ⚠ A task's "both" / "theirs" chip in the contact frame answers a tap with its own note (`AppTaskFrame`).
            AppTips.Skip = ".tk .who";
            AppTips.Install(document);
            AppChatPropsFold.Install(document);
            this.TabBus.Listener = this.TabSync;
            document.addEventListener("visibilitychange", this.OnVisible);
            // ⭐ THE AI PANEL'S WARM-UP (`AppAssistWarm`): its sender, the tab being shown, the visible keep-alive.
            this.Warmer = new AppAssistWarmer(this.WarmPost);
            document.addEventListener("visibilitychange", this.OnVisibleAssist);
            document.addEventListener("visibilitychange", this.OnVisibleLive);
            document.addEventListener("click", this.OnNativeChatView);
            document.addEventListener("click", this.OnQuickChat);
            document.addEventListener("click", this.OnChatSettingsOpen);
            // ⭐ THE NETWORK CAME BACK: both live feeds ask at once instead of waiting out a backoff (2026-09-28).
            window.addEventListener("online", this.OnOnline);
            this.BaseTitle = document.title;
            window.setInterval(this.OnWarmTick, AppAssistWarmRules.EveryMs);
            this.Source = new AppLocalSource("");
            // ⭐ THE RETURNING SUBSCRIBER'S ENTRY POINT, AND IT HAS TO BE HERE RATHER THAN IN
            // `OnHash`. A cold load goes Start -> Load -> LoadIndex, which looks for an
            // `index.json` BESIDE the page; on the published site there is none, so it failed
            // into `OnNoFolder` and `OnHash`'s archive branch was never reached. That branch
            // only fires on a `hashchange`, which is the sign-up click and nothing else.
            // ⚠ SIGN-UP STILL WINS: a visitor at `#signup` is there to create an archive, and
            // opening a stale one instead would hijack the one route a stranger is sent to.
            // ⚠ AND SO DO `#signin` AND `#leave`: neither needs a folder, and opening the archive
            // first would paint "Opening your archive..." over the page the visitor asked for.
            // ⭐ WAVE 3: back from Microsoft's OneDrive page (`?code=&state=`) - finish that step first.
            if (this.OneDriveReturn() === true) { return; }
            if (AppMain.WantsPreFolder() === false && AppArchiveStore.Held() === true) {
                this.OpenArchive();
                return;
            }
            this.Load();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.Start");
        }
    };

    /** The shell's own footer sentence, read once - the footer is rebuilt from it on every paint. */
    private FootText: string | null = null;

    /**
     * The footer: the shell's sentence, the build number, and "Close my account" for a browser that
     * holds a key. Also the reference that keeps `AppShared` in the bundle: KBuild tree-shakes, and
     * a version constant nothing reads is a version constant nothing ships.
     *
     * ⚠ REBUILT ON EVERY PAINT, NOT STAMPED ONCE, because whether the link belongs there changes
     * mid-visit - a sign-in gives this browser a key, a closed account takes it away - and a link
     * left behind on a browser that can no longer prove anything is a dead control.
     */
    private Footer = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Foot: HTMLCollectionOf<Element> = document.getElementsByClassName("foot");
            if (Foot.length === 0) { return; }
            if (this.FootText === null) { this.FootText = nz(Foot[0].textContent).trim(); }
            // ⭐ "Import a backup" SITS BESIDE "Close my account" - both need only the key.
            const Held: boolean = this.KeyNow().length > 0 && this.NumberNow().length > 0;
            let Html: string = kHTMLCore.EscapeHtml(nz(this.FootText)) + "  &#183;  v" + WAC_VERSION
                + AppAccountViews.FootLinks(Held)
                + AppClaudeView.FootLink(AppClaudeToken.ShowLink(Held, this.IsOwner));
            // ⚠ THE THEME CONTROL MOVED TO THE TOP BAR'S SETTINGS MENU (2026-09-30); a page with no bar keeps it here.
            if (this.TopBar.Mounted === false) { Html = Html + AppThemeView.Control(AppThemeRun.Shared.Chosen()); }
            (Foot[0] as HTMLElement).innerHTML = Html;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.Footer");
        }
    };

    /** The archive key this browser can prove itself with right now, or "". */
    private KeyNow = (): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            return AppAccount.First(this.SessionKey, AppArchiveStore.Key());
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.KeyNow");
            return "";
        }
    };

    /**
     * The number this page is working for, or "".
     *
     * ⚠ THE SIGN-UP IN HAND FIRST, then a key from this visit, then the store - `OpenArchive`'s
     * original order, which keeps a fresh sign-up authoritative over a key left behind by a previous
     * subscriber on a shared browser.
     */
    private NumberNow = (): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            return AppAccount.First(this.SignUp.Number,
                AppAccount.First(this.SessionNumber, AppArchiveStore.Number()));
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.NumberNow");
            return "";
        }
    };

    // ── Loading ──────────────────────────────────────────────────────────────────────────────

    private Load = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            // ⛔ SIGN-UP IS ANSWERED BEFORE THE FOLDER IS EVEN LOOKED FOR. Everything below assumes
            // a folder; a visitor at `#signup` has none, which is the entire point of the route.
            // Reaching the folder first means this visitor gets "Reading..." and then a failure
            // about a folder they were never supposed to have.
            if (AppMain.WantsSignUp() === true) { this.EnterSignUp(); return; }
            if (AppMain.RouteIs(AppAccount.SignInRoute) === true) { this.ShowSignIn(); return; }
            if (AppMain.RouteIs(AppAccount.LeaveRoute) === true) { this.ShowLeave(); return; }
            if (AppMain.RouteIs(AppAccount.ImportRoute) === true) { this.ShowImportLater(); return; }
            if (AppMain.RouteIs(AppClaudeToken.Route) === true) { this.ShowClaude(); return; }
            // ⭐ A SKELETON OF THE LIST (design item 11a), its words in a visually hidden status line.
            this.Paint(AppSkeleton.List(8, "Reading " + this.Source.Describe() + "…"));
            this.Source.LoadIndex(this.OnIndex, this.OnNoFolder);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.Load");
        }
    };

    private OnIndex = (Text: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Index = AppIndexReader.Parse(Text);
            if (this.Index.Loaded === false) {
                this.Trouble(this.Index.Problem);
                return;
            }
            this.TabBus.Ensure(this.NumberNow());
            this.TabSync.IndexRead(Date.now());
            AppLiveListRules.Carry(this.Index, this.Unread);
            this.StartListFeed();
            this.StartMarks();
            this.OnHash();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnIndex");
        }
    };

    /**
     * ⭐ THE CHAT LIST'S LIVE FEED (`AppLiveList`): on the hosted page with a key, once per source (a new source - a
     * sign-in - stops the old one). From the index's built time, so a message the rebuild just missed still counts.
     */
    private StartListFeed = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.ListFeed !== null && this.ListFeedOf === this.Source) { return; }
            if (this.ListFeed !== null) { (this.ListFeed as AppLiveList).Stop(); this.ListFeed = null; }
            // DEMO MODE: the feed asks `/demo/live` (`AppSignUpApi.UrlFor`), which reads the INVENTED journal only.
            if (this.ServiceUrl.length === 0 || this.KeyNow().length === 0 || this.NumberNow().length === 0) { return; }
            const Who: AppLiveListWho = new AppLiveListWho();
            Who.ServiceUrl = this.ServiceUrl;
            Who.Phone = this.NumberNow();
            Who.Key = this.KeyNow();
            const Made: AppLiveList = new AppLiveList(new AppLiveListLink(this), Who, new AppLivePost(), new AppLiveWindowClock());
            this.ListFeed = Made;
            this.ListFeedOf = this.Source;
            Made.OnStanding = this.OnStanding;
            // ⭐ TRUTHFUL TOP BAR: the service's word for the subscriber's own WhatsApp link, and the feed's own health.
            Made.OnWa = this.OnWa;
            Made.OnHealth = this.ShowStatus;
            Made.Start(this.Index.BuiltIso);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.StartListFeed");
        }
    };

    /**
     * ⭐ The subscriber's own WhatsApp account standing changed (the list feed, `AppStanding`): the banner under the top
     * bar appears, changes or goes - no reload. ⛔ A status shown, never an error reported; nothing here can send.
     */
    public OnStanding = (Now: AppStandingNow): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.StandingBar.Show(Now, Date.now());
            // ⛔ The top bar's line must not say "Connected" beside a ban's band for the 15 s until its next tick.
            this.ShowStatus();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnStanding");
        }
    };

    /**
     * ⭐ The service's word for the subscriber's own WhatsApp link changed (the list feed, `AppWaLink`): the top bar's line
     * says it at once, and "not linked" brings the way to fix it - the "Link WhatsApp again" banner - without a reload
     * (`AppWaLink.RelinkMove`; a banner in the middle of a pairing is never touched). ⛔ A status shown, never an error
     * reported; nothing here sends, and nothing asks for a pairing code - only the subscriber's own press does.
     */
    public OnWa = (Now: AppWaNow | null): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.ShowStatus();
            if (Now === null) { return; }
            const InFlow: boolean = this.Relink.Busy === true || this.Relink.Waiting === true
                || nz(this.Relink.Code).length > 0 || this.RelinkTimer !== 0;
            const Move: string = AppWaLink.RelinkMove(Now.State, this.Relink.Show === true, InFlow, this.Relink.Linked === true);
            if (Move === AppWaLink.RelinkShow) { this.Relink = new AppRelinkState(); this.Relink.Show = true; this.PlaceRelink(); }
            if (Move === AppWaLink.RelinkHide) { this.Relink = new AppRelinkState(); this.DropRelink(); }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnWa");
        }
    };

    /**
     * The re-link banner put on the page NOW (it is otherwise drawn by the next view paint): first in the pane the views
     * paint into - `#wac-center` in three panes, the page otherwise - which is where each view puts it. Only on an archive
     * view (never over the sign-up, the import or the leave screen).
     */
    private PlaceRelink = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (document.getElementById(AppAccountViews.RelinkId) !== null) { this.PaintRelink(); return; }
            if (AppThreeColRules.Wanted(this.Index.Loaded, true, window.location.hash) === false) { return; }
            let Host: HTMLElement | null = this.Where;
            const Mid: HTMLElement | null = document.getElementById(AppThreeColView.CenterId);
            if (Mid !== null) { Host = Mid; }
            if (Host === null) { return; }
            Host.insertAdjacentHTML("afterbegin", AppAccountViews.Relink(this.Relink));
            this.WireRelink();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.PlaceRelink");
        }
    };

    /** The re-link banner taken away (WhatsApp is connected again and nothing was in progress). */
    private DropRelink = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const El: HTMLElement | null = document.getElementById(AppAccountViews.RelinkId);
            if (El !== null && El.parentNode !== null) { El.parentNode.removeChild(El); }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.DropRelink");
        }
    };

    /**
     * ⭐ New messages for the list (ids, times, chats - no words): the cards move, "N new", a card for a brand-new chat,
     * the tab title's count. Only the card list is redrawn (never the search box under the owner's caret); a newer
     * `built` re-reads `index.json` quietly (the rebuild has run - a new chat now has its page).
     */
    public OnLiveList = (Items: AppLiveListItem[], Names: Record<string, string>, Built: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            let Open: string = "";
            if (this.Open !== null && AppMain.IsDetail() === true) { Open = (this.Open as AppContact).ChatId; }
            const Tasks: number = this.Index.Tasks.length;
            const Changed: boolean = AppLiveListRules.Apply(this.Index, Items, Names, this.Unread, Open);
            this.ShowUnread();
            if (this.Index.Tasks.length !== Tasks) { this.BoardOf = null; }
            if (Changed === true) { this.RepaintCards(this.Index.Tasks.length !== Tasks); }
            this.ShowStatus();
            if (AppLiveListRules.Rebuilt(Built, this.Index.BuiltIso) === true) { this.Source.LoadIndex(this.OnRebuiltIndex, this.OnQuietFail); }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnLiveList");
        }
    };

    /** The tab title carries the count of new messages ("(3) WACommander"). */
    private ShowUnread = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.BaseTitle.length === 0) { this.BaseTitle = document.title; }
            document.title = AppLiveListRules.TitleWith(this.BaseTitle, AppLiveListRules.Total(this.Unread));
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.ShowUnread");
        }
    };

    /**
     * On the Chats view: only the cards (`#wac-chatlist`) are rewritten - the search box keeps focus and caret. When the
     * Today strip's tasks changed too, the whole view is repainted, unless the owner is typing in the search box.
     */
    private RepaintCards = (TasksChanged: boolean): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Typing: boolean = document.activeElement !== null && (document.activeElement as HTMLElement).id === AppViews.FindId;
            // ⭐ THE WIDE THREE-PANE SCREEN SHOWS THE LIST ON EVERY ROUTE, a chat open included: only the list is redrawn (its
            // scroll and a focused row kept - `AppThreeCol.RepaintList`); the center (conversation, composer) is never touched.
            if (this.Three.IsOn(this.ThreeDoc) === true) {
                this.RepaintList();
                if (TasksChanged === true && Typing === false && AppTabBusRules.IsListRoute(window.location.hash) === true) { this.OnHash(); }
                return;
            }
            if (AppTabBusRules.IsListRoute(window.location.hash) === false || AppMain.IsDetail() === true) { return; }
            if (TasksChanged === true && Typing === false) { this.OnHash(); return; }
            const List: HTMLElement | null = document.getElementById(AppViews.ListId);
            if (List === null) { return; }
            List.innerHTML = this.ChatRows();
            this.Faces().Fill(List);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.RepaintCards");
        }
    };

    // ── The three-pane shell on a wide screen (design item 12, `AppLayout`) ─────────────────────────────────────────

    /**
     * Is a chat open (the contact route's fixed-height shell)? ⚠ A CLASS TEST, NOT A COMPARISON OF THE WHOLE className: on the wide
     * screen the bar's search stays shown on a chat, so `<body>` also carries `wac-hasfind` there.
     */
    private static IsDetail = (): boolean => {
        if (getCoreUtils().KErrorMode === true) { return false; }
        try {
            return document.body.classList.contains("detail") === true;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.IsDetail");
            return false;
        }
    };

    /** Three panes for the route in the address now? (the archive loaded, a wide window, an archive route) */
    private ThreeNow = (): boolean => {
        if (getCoreUtils().KErrorMode === true) { return false; }
        try {
            return AppThreeColRules.Wanted(this.Index.Loaded, AppMain.Wide(), window.location.hash);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.ThreeNow");
            return false;
        }
    };

    /** The open chat's id (its list row is the current one), or "" on a list view. */
    private CurrentChat = (): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            if (this.Open === null || AppMain.IsDetail() === false) { return ""; }
            return (this.Open as AppContact).ChatId;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.CurrentChat");
            return "";
        }
    };

    /**
     * Paint a view: on the wide screen into the CENTER pane (the shell made once, the list kept - its scroll, the search's
     * caret, a focused row), else the whole page exactly as before (`Paint`). `Current` = the chat whose row is lit.
     */
    private PaintView = (Html: string, Current: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            // ⭐ THE KEYBOARD'S PLACE ACROSS THE PAINT (`FocusAfterPaint`): noted before the markup is replaced.
            const Kept: AppFocusMark = AppFocusKeep.Before(document, this.FocusRegion());
            const SameRoute: boolean = window.location.hash === this.PaintedHash;
            this.PaintedHash = window.location.hash;
            if (this.ThreeNow() === false || this.Where === null) { this.Paint(Html); this.FocusAfterPaint(Kept, SameRoute); return; }
            const Fresh: boolean = this.Three.IsOn(this.ThreeDoc) === false;
            this.Three.Show(this.ThreeDoc, this.Where as unknown as IThreeEl, new AppThreeHost(this), this.Index,
                AppThreeColRules.ListSig(this.Filter), AppThreeColRules.TabFor(window.location.hash), Current, Html);
            // ⭐ THE SEARCH STAYS IN THE BAR ON EVERY PANE VIEW - it filters the list on the left, which is always there.
            this.MarkRail();
            if (this.Index.Contacts.length > 0) { this.ShowBarSearch(); }
            const Box: HTMLElement | null = document.getElementById(AppViews.FindId);
            if (Box !== null) { Box.addEventListener("input", this.OnFind); }
            if (Fresh === true) { this.Searcher().Now(this.Filter); }
            this.Footer();
            this.ShowStatus();
            this.AttachNativeChatViews();
            this.FocusAfterPaint(Kept, SameRoute);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.PaintView");
        }
    };

    /** The route the last `PaintView` drew - a paint for the same route is a repaint in place. */
    private PaintedHash: string = "";

    /** What a view's paint replaces: the center pane on the wide screen, the whole app area otherwise. */
    private FocusRegion = (): IFocusEl | null => {
        if (getCoreUtils().KErrorMode === true) { return null; }
        try {
            const Center: HTMLElement | null = document.getElementById(AppThreeColView.CenterId);
            if (Center !== null) { return Center as unknown as IFocusEl; }
            return this.Where as unknown as IFocusEl | null;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.FocusRegion");
            return null;
        }
    };

    /**
     * ⭐ A PAINT NEVER DROPS THE KEYBOARD (audit 2026-10-01). When the control that had the focus was inside what was
     * just replaced: a repaint of the SAME route puts the focus back on the same control (or the one now in its place);
     * a NEW route keeps it on the control that was pressed when the new view has it too (the same tab), else gives it
     * to the view itself - a screen reader starts at the view, and the next Tab enters it. ⛔ A paint that did not take
     * the focus away moves nothing (a click in the list beside the chat, typing in the bar's search).
     * The views that place the focus themselves (a reply owed -> the message box) do so after this and win.
     */
    private FocusAfterPaint = (Kept: AppFocusMark, SameRoute: boolean): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (Kept.Had !== true) { return; }
            const Region: IFocusEl | null = this.FocusRegion();
            if (AppFocusKeep.After(Region, Kept, SameRoute) === true) { return; }
            AppFocus.Region(Region);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.FocusAfterPaint");
        }
    };

    /** The list on the left redrawn (live move, search, rows/cards, a rebuilt index) - never the center. */
    private RepaintList = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Three.RepaintList(this.ThreeDoc, new AppThreeHost(this), this.Index, AppThreeColRules.ListSig(this.Filter),
                this.CurrentChat());
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.RepaintList");
        }
    };

    /**
     * The window crossed the breakpoint. A LIST view is drawn again in its new shape (nothing typed is lost - the search
     * lives in the bar). ⚠ AN OPEN CHAT IS LEFT AS IT IS: redrawing it would reload the conversation and empty the
     * composer; app.css lays the same markup out for either width, and the next route takes the new shape.
     */
    /** The on-screen keyboard opened / closed (the shared kViewportHeightVar): the open chat's frame follows (`AppPhoneChat`). */
    private OnKeyboard = (Open: boolean): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Frame: HTMLIFrameElement | null = document.getElementById("wac-frame") as HTMLIFrameElement | null;
            if (Frame !== null && Frame.contentDocument !== null) { AppPhoneChat.Apply(Frame.contentDocument.documentElement, Open); }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnKeyboard");
        }
    };

    private OnWideChange = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            // ⭐ The open chat's frame is told (`AppFrameWide`): its phone rules stand down on the wide screen and come back below it.
            const Frame: HTMLIFrameElement | null = document.getElementById("wac-frame") as HTMLIFrameElement | null;
            if (Frame !== null && Frame.contentDocument !== null) { AppFrameWide.Apply(Frame.contentDocument.documentElement, AppMain.Wide()); }
            if (this.Index.Loaded === false || AppMain.IsDetail() === true) { return; }
            if (AppThreeColRules.IsShellRoute(window.location.hash) === false) { return; }
            this.OnHash();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnWideChange");
        }
    };

    /** The view tabs for a view's own page - "" on the wide screen, where they sit above the list on the left. */
    private CenterTabs = (At: string): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            if (this.ThreeNow() === true) { return ""; }
            return this.Tabs(At);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.CenterTabs");
            return "";
        }
    };

    /** For `AppThreeHost`: the tabs line. */
    public ThreeTabs = (At: string): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            return this.Tabs(At);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.ThreeTabs");
            return "";
        }
    };

    /** For `AppThreeHost`: the left pane under the tabs (switch, list, message hits; the search is in the bar). */
    public ThreeLeft = (Current: string): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            return AppViews.Chats(this.Index, this.Filter, "", this.TopBar.Mounted, Current);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.ThreeLeft");
            return "";
        }
    };

    /** For `AppThreeHost`: the list's rows only. */
    public ThreeList = (Current: string): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            return this.ChatRows(Current);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.ThreeList");
            return "";
        }
    };

    /** For `AppThreeHost`: one row's meta line (opened = read, so its "N new" goes in place). */
    public ThreeMeta = (ChatId: string): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            const Who: AppContact | null = AppLiveListRules.ContactOf(this.Index, ChatId);
            if (Who === null) { return ""; }
            return AppViews.Meta(Who as AppContact);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.ThreeMeta");
            return "";
        }
    };

    /** For `AppThreeHost`: the list was drawn - pictures laid on, and who is typing painted again at once. */
    public ThreeDrawn = (List: IThreeEl): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Faces().Fill(List as unknown as HTMLElement);
            if (this.ListFeed !== null) { (this.ListFeed as AppLiveList).ShowTyping((this.ListFeed as AppLiveList).TypingNow()); }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.ThreeDrawn");
        }
    };

    /** The rebuild ran: the new index replaces the old (new chats it lacks are kept, the counts carried); a list repaints. */
    private OnRebuiltIndex = (Text: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Fresh: AppIndex = AppIndexReader.Parse(Text);
            if (Fresh.Loaded === false) { return; }
            AppLiveListRules.Adopt(Fresh, this.Index, this.Unread);
            this.Index = Fresh;
            this.TabSync.IndexRead(Date.now());
            if (AppTabBusRules.IsListRoute(window.location.hash) === true && AppMain.IsDetail() === false) { this.OnHash(); }
            else if (this.Three.IsOn(this.ThreeDoc) === true) { this.RepaintList(); }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnRebuiltIndex");
        }
    };

    /** The network is back: both feeds ask now. */
    private OnOnline = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.ListFeed !== null) { (this.ListFeed as AppLiveList).Kick(); }
            if (this.Live !== null) { (this.Live as AppLiveFeed).Kick(); }
            this.ShowStatus();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnOnline");
        }
    };

    // ⚠ `NotBuiltYet` WAS DELETED RATHER THAN LEFT UNUSED (2026-09-24). It said "your archive is
    // being built and appears in your Dropbox", which had exactly two callers and both were wrong
    // by the time they ran: a browser with no key has no archive being built anywhere, and a
    // subscriber WITH a key whose folder is genuinely not built yet now gets
    // `DropboxReadRules.Why`'s `path/not_found` sentence, which says the same thing from the one
    // place that actually knows. **A sentence with no honest caller is a sentence that will be
    // wired back to the wrong one.**

    /**
     * Open the archive out of the subscriber's Dropbox.
     *
     * ⭐ THIS IS WHAT "OPEN WACOMMANDER" NOW DOES, AND IT USED TO DO NOTHING. The button is a link
     * to `#all`, and `OnHash` answered a page with no folder with a bare `return` - so the hash
     * changed, nothing painted, and a second press did not even fire `hashchange`.
     *
     * ⛔ IT IS TRIED ONCE PER PAGE, AND THE LATCH IS NOT TIDINESS. `Load` ends at `OnHash`, and
     * `OnHash` arrives here whenever the index is not loaded - so without `Opening` a refused
     * ticket would ask again, be refused again, and spin against the service for as long as the tab
     * stayed open. ⚠ The subscriber's way to retry is to reload, which is also what re-reads a
     * folder that has since been built.
     *
     * ⚠ NO SESSION MEANS THE SENTENCE, NOT A REQUEST. A page opened cold has no secret to prove
     * anything with, and `/folder` would answer the same refusal for a stranger and for them.
     */
    private OpenArchive = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            // ⚠ THE NUMBER COMES FROM THE SESSION FIRST AND THE STORE SECOND. `SignUp.Number` means
            // "enrolled in THIS session" and is "" on a cold page; the stored one is what a
            // returning visit has. Preferring the session keeps a fresh sign-up authoritative over
            // a key left behind by a previous subscriber on a shared browser.
            // ⚠ AND NO SECRET ONCE THIS VISIT ALREADY HOLDS A KEY - see `AppAccount.FolderSecret`.
            const Body: string = AppSignUpApi.FolderBody(this.NumberNow(),
                AppAccount.FolderSecret(this.Secret, this.SessionKey), this.KeyNow());
            const Url: string = AppSignUpApi.UrlFor(this.ServiceUrl, AppSignUpApi.Folder);
            // ⛔ ALREADY ASKED: SAY NOTHING AND LEAVE WHAT IS ON SCREEN. The request in flight paints
            // "Opening your archive..." and its answer paints the verdict; repainting over either
            // would replace a real sentence with a guess. ⚠ This is NOT the dead click that started
            // all this - the first press has already painted something.
            if (this.Opening === true) { return; }
            // ⛔ NO PROOF AT ALL IS "NOT SIGNED IN", NOT "STILL BUILDING". `NotBuiltYet` tells
            // somebody their archive is on its way, which for a browser holding no key and no
            // session is simply untrue - there is no archive of theirs anywhere.
            if (Body.length === 0 || Url.length === 0) {
                this.OfferSignUp(AppMain.NotSignedInWhy());
                return;
            }
            this.Opening = true;
            this.Paint(AppSkeleton.List(8, "Opening your archive…"));
            new AppSignUpPost(Url, Body, this.OnFolderTicket).Send();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OpenArchive");
        }
    };

    /**
     * ⛔ THE SOURCE IS REPLACED BEFORE THE LOAD, AND THE ORDER IS THE WHOLE METHOD. `Load` reads
     * `this.Source`, so setting it afterwards would re-read whatever was there before - which for a
     * subscriber who has just signed up is `AppLocalSource`, looking for an `index.json` beside a
     * static page that will never have one.
     *
     * ⚠ A REFUSAL IS THE SERVICE'S OWN SENTENCE, NEVER A GENERIC ONE. `FolderTicketRules` has three
     * that each say something different to do - expired session, no Dropbox yet, our end - and
     * replacing them with "could not open" would throw away the only part the subscriber can act
     * on.
     */
    private OnFolderTicket = (Answer: SignUpAnswer): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            // ⭐ WAVE 3: a OneDrive archive carries NO token (`storage: "onedrive"`); every read asks `/onedrive`.
            const OnOneDrive: boolean = Answer.Ok === true && Answer.Storage === "onedrive";
            if (Answer.Ok !== true || (nz(Answer.Token).length === 0 && OnOneDrive === false)) {
                this.OnFolderRefused(Answer);
                return;
            }
            // ⚠ STORED BEFORE THE SOURCE IS BUILT, so a later failure reading the folder cannot cost
            // the subscriber the key that got them in. `Save` ignores an empty one, which is what the
            // service sends on every visit that minted nothing.
            this.FolderTries = 0;
            const Phone: string = this.NumberNow();
            AppArchiveStore.Save(Phone, nz(Answer.Key));
            // ⚠ THE KEY FROM THE ANSWER FIRST, THEN THIS VISIT'S, THEN THE STORE. A browser whose
            // storage is blocked could not save the key it was just given, and must still be able to
            // send with it for the rest of this visit.
            if (nz(Answer.Key).length > 0) { this.SessionKey = nz(Answer.Key); this.SessionNumber = Phone; }
            const Reader: AppDropboxSource = new AppDropboxSource(nz(Answer.Token), nz(Answer.Path));
            Reader.SendAs(this.ServiceUrl, Phone, this.KeyNow());
            if (OnOneDrive === true) { Reader.UseOneDrive(); }
            // ⛔ `ShowRelink`, NEVER `!Answer.Linked` - a missing `linked` is "cannot tell", and
            // reading it as false would send somebody whose phone is fine off to re-link it.
            this.Relink = new AppRelinkState();
            this.Relink.Show = AppSignUpApi.ShowRelink(Answer);
            // ⛔ ONLY THE SERVICE'S OWN `owner: true` - never inferred, never stored.
            this.IsOwner = Answer.Owner === true;
            // ⭐ APP START: the owner's first warm-up goes now, whatever route is open - Claude is ready before
            // a contact is even picked (owner, 2026-09-27; `AppAssistWarm`).
            this.WarmAssist("");
            this.Source = Reader;
            // DEMO MODE: the subscriber is signed in as ever, but the archive shown is the INVENTED one - their own
            // folder is never read (`AppDemoSource`, `AppDemo`).
            if (AppDemo.On() === true) { this.Source = new AppDemoSource(this.ServiceUrl, this.NumberNow()); AppDemo.UseService(this.ServiceUrl); }
            this.Load();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnFolderTicket");
        }
    };

    /**
     * ⛔ A REFUSED KEY IS THROWN AWAY, OR IT IS RETRIED FOR EVER. An expired or revoked key would
     * otherwise cost a doomed round trip on every single visit, and the subscriber would never be
     * shown the sign-up that fixes it.
     * ⚠ ONLY WHEN A KEY WAS WHAT WE PRESENTED: a refusal on the SECRET path says nothing about a
     * stored key, and discarding one there would log out a working browser because somebody's
     * two-hour sign-up had aged out.
     */
    private OnFolderRefused = (Answer: SignUpAnswer): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            // ⭐ "NO DROPBOX YET" WITH A KEY IN HAND IS AN UNFINISHED SIGN-UP, NOT A DEAD END - and it
            // is checked BEFORE the key is forgotten below, which would otherwise throw away the one
            // proof that can finish it (`AppAccount.ResumesDropbox`).
            if (nz(Answer.Key).length > 0) { this.KeepKey(nz(Answer.Key)); }
            if (AppAccount.ResumesDropbox(Answer.NoStorage, this.KeyNow(), this.NumberNow()) === true) {
                this.ResumeDropbox();
                return;
            }
            const SecretUsed: string = AppAccount.FolderSecret(this.Secret, this.SessionKey);
            if (AppAccount.ForgetsFolderKey(Answer.Stale, SecretUsed) === true) {
                AppArchiveStore.Forget();
                this.SessionKey = "";
                this.SessionNumber = "";
            } else if (SecretUsed.length === 0 && Answer.Stale !== true && Answer.NoStorage !== true) {
                // ⭐ NOT A VERDICT ON THE KEY (lost connection, 5xx, restart window): keep it and ask again quietly.
                const Wait: number = AppAccount.FolderRetryMs(this.FolderTries);
                if (Wait >= 0) {
                    this.FolderTries++;
                    window.setTimeout(this.OnFolderRetry, Wait);
                    return;
                }
                this.FolderTries = 0;
                this.Opening = false;
                this.Trouble(nz(Answer.Why));
                return;
            }
            // ⚠ `OfferSignUp`, NOT `Trouble`: every refusal this endpoint sends ends in "sign up
            // again from your number", and until 2026-09-24 the page offered no way to do that.
            this.OfferSignUp(nz(Answer.Why));
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnFolderRefused");
        }
    };

    /**
     * A key the service minted and STORED on a refused answer - kept, or it is an orphan in one of
     * the five slots (`FolderTicketRules.Refused`'s reason).
     */
    private KeepKey = (Key: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Phone: string = this.NumberNow();
            if (Phone.length === 0 || nz(Key).length === 0) { return; }
            this.SessionKey = nz(Key);
            this.SessionNumber = Phone;
            AppArchiveStore.Save(Phone, nz(Key));
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.KeepKey");
        }
    };

    /**
     * Pick the sign-up up at the Dropbox step, with the archive key as the proof.
     *
     * ⭐ THE STUCK SIGN-UP (2026-09-24): linked, then a reload, and the secret was gone. The state is
     * rebuilt from FACTS the service has just confirmed - this key's number is linked (a `browser` key
     * is only ever minted for a paired session) and has no Dropbox - so `StepFor` lands on the Dropbox
     * step and everything after it (history, done) is the ordinary sign-up.
     * ⚠ `Opening` is cleared so "Open WACommander" at the end can ask again.
     */
    private ResumeDropbox = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Phone: string = this.NumberNow();
            this.Opening = false;
            this.ImportLater = false;
            this.SignUp = new SignUpState();
            this.SignUp.Number = Phone;
            this.SignUp.Linked = true;
            this.Shell(false);
            this.SignUpScreen = "";
            this.ShowSignUp(true);
            this.AskDropboxUrl();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.ResumeDropbox");
        }
    };

    /** A user-facing problem, NOT a defect. Law 1's split: this is the validation surface, and the
     *  error handler still owns anything that is actually broken. */
    private Trouble = (Why: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            // ⭐ ON THE WIDE SCREEN A CHAT THAT COULD NOT BE READ SAYS SO IN THE CENTER - the list stays to pick another.
            this.PaintView("<p class=\"trouble\">" + kHTMLCore.EscapeHtml(Why) + "</p>", this.CurrentChat());
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.Trouble");
        }
    };

    /**
     * A sentence AND the one control that can act on it.
     *
     * ⛔ EVERY DEAD END ON THIS PAGE USED TO SAY "SIGN UP AGAIN" AND OFFER NO WAY TO DO IT - measured
     * in a browser 2026-09-24, on all three routes a signed-out visitor can reach. The sentence was
     * true and the page was still a cul-de-sac: the only exit was knowing to type `#signup` into the
     * address bar.
     *
     * ⚠ IT IS A LINK, NOT A BUTTON, because `#signup` is a ROUTE - so it is middle-clickable,
     * bookmarkable, and works with no script attached to it.
     */
    private OfferSignUp = (Why: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            // ⚠ `signedout`, NOT `trouble`. Both sentences this carries - never signed in, and a
            // key that has lapsed - are VALIDATION (law 1), and the orange of `.trouble` reads as
            // breakage on the one page most first-time visitors land on.
            // ⚠ NO `class="row"` ON THE BUTTONS - `.row` is the LIST-ROW style (a three-column grid).
            // ⭐ SIGN IN SITS BESIDE SIGN UP: a subscriber on a new device, or one whose key lapsed,
            // is not a stranger, and "sign up" alone sent them round a claim their live number refuses.
            // ⭐ A CARD WITH A HEADING, LIKE EVERY OTHER ACCOUNT SCREEN (verifier, 2026-10-01): it was a bare paragraph
            // at the page's left edge - the first thing a stranger sees looked like an unstyled leftover.
            this.Paint(AppAccountViews.SignedOut(Why));
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OfferSignUp");
        }
    };

    // ── Routing ──────────────────────────────────────────────────────────────────────────────

    /**
     * The address changed - the owner went somewhere. ⚠ THE "LET <NAME> KNOW?" CARDS GO HERE, not in
     * `OnHash`: `OnHash` also repaints the same route after an index reload, and a card must survive that.
     */
    private OnHashChange = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Notifier.Clear();
            this.OnHash();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnHashChange");
        }
    };

    private OnHash = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            // ⭐ A ROUTE CHANGE CLOSES "CHAT SETTINGS" (browser Back, a notice's link): a modal about a chat is not left
            // standing over another view. ⚠ Only a CHANGE: `OnHash` also runs when the index is read again on the same
            // route, and that must not shut a dialog somebody is using.
            if (this.ChatSettingsBox !== null && window.location.hash !== this.ChatSettingsHash) { this.ChatSettingsBox.Close(); }
            const Parts: string[] = window.location.hash.replace("#", "").split("/");
            this.Notice.OnRoute(); // ⚠ a notice already SEEN goes; one not yet painted waits for the list
            // ⛔ SIGN-UP IS CHECKED BEFORE `Loaded`, AND THAT ORDER IS THE POINT. Every other route
            // needs a folder; this one is for the visitor who has NO folder, which is exactly the
            // state the guard below refuses to paint. Behind it, the one page a stranger is sent to
            // would render as a blank screen and there would be nothing on it to say why.
            if (Parts[0] === AppMain.SignUpRoute) { this.EnterSignUp(); return; }
            // ⚠ THE SAME FOR SIGN-IN AND LEAVING: a new device has no folder yet, and a subscriber
            // closing their account must be able to do it whether or not the archive opens.
            if (Parts[0] === AppAccount.SignInRoute) { this.ShowSignIn(); return; }
            if (Parts[0] === AppAccount.LeaveRoute) { this.ShowLeave(); return; }
            // ⚠ AND "IMPORT A BACKUP": the subscriber most likely to need it (skipped the import) may
            // have no folder built yet - see `AppAccount.ImportRoute`.
            if (Parts[0] === AppAccount.ImportRoute) { this.ShowImportLater(); return; }
            // ⚠ AND THE OWNER'S CLAUDE PANEL: it needs a key, not a folder.
            if (Parts[0] === AppClaudeToken.Route) { this.ShowClaude(); return; }
            // ⛔ A BARE `return` HERE WAS A DEAD CLICK, AND IT WAS MEASURED (2026-09-23). The last
            // step of sign-up links "Open WACommander" to `#all`; a subscriber who has just finished
            // has NO folder yet, so this answered with nothing at all - the hash changed, a second
            // press did not even fire `hashchange`. A dead button at the end of sign-up.
            // ⚠ IT IS VALIDATION, NOT AN ERROR (law 1): a folder that has not been built yet is
            // the product working, so it is SHOWN and never routed to the handler.
            if (this.Index.Loaded === false) { this.OpenArchive(); return; }
            if (Parts[0] === "c" && Parts.length > 1) {
                this.Contact(decodeURIComponent(Parts[1]), AppMain.Third(Parts));
                return;
            }
            // ⭐ A CHAT WITH NO PAGE YET (`AppLiveList`'s new-chat card): its provisional page, live.
            if (Parts[0] === AppViews.NewRoute && Parts.length > 1) {
                this.ShowNewChat(decodeURIComponent(Parts[1]));
                return;
            }
            // ⚠ ONLY A SOURCE THAT CAN ASK THE SENDER HAS A SENT TAB; elsewhere `#sent` is the list.
            if (Parts[0] === AppAccount.SentRoute && this.Source.CanHistory() === true) {
                this.ShowSent();
                return;
            }
            // ⭐ "NEW CHAT" (`AppNewChat`): a number typed, checked with WhatsApp, then the provisional chat `#n/<chat id>`.
            if (Parts[0] === AppNewChatRules.Route) { this.ShowNewChatForm(); return; }
            this.List(Parts[0]);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnHash");
        }
    };

    private static Third = (Parts: string[]): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            if (Parts.length < 3) { return ""; }
            return decodeURIComponent(Parts[2]);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.Third");
            return "";
        }
    };

    /**
     * ⚠ ONE SCROLLBAR PER JOB. The contact view nests three scrollable boxes - the app page, the
     * frame, and the conversation pane inside it - and the outer two scroll the SAME content, so
     * the reader gets two bars that both move the page and neither of which reaches the end.
     *
     * `detail` makes the app a fixed-height shell: the window does not scroll, the frame takes the
     * space that is left, and the only bars are the frame's (the contact page) and the pane's (the
     * conversation) - exactly what the page has when opened on its own.
     */
    private Shell = (Detail: boolean): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            let Cls: string = "";
            if (Detail === true) { Cls = "detail"; }
            document.body.className = Cls;
            // ⚠ LEAVING THE CONTACT DROPS ITS PANEL, so a late answer cannot paint into a page that is
            // gone. The conversation itself stays in `Assists` for the rest of the visit.
            if (Detail === false) { this.Assist = null; this.Compose = null; this.DropNewChatPost(); }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.Shell");
        }
    };

    private List = (Which: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Shell(false);
            let At: string = "chats";
            if (Which === "tasks") { At = "tasks"; }
            if (Which === "money") { At = "money"; }
            // ⭐ THE OVERVIEW (2026-09-27): its own tab, so the chat list stays the main screen's first view.
            // ⛔ NOT ON A PHONE (owner 2026-11-02: "Remove the whole overview feature on mobile"): below the breakpoint #overview is the chat list.
            if (Which === AppOverview.Route && AppMain.Wide() === true) { this.ShowOverview(); return; }
            // ⭐ THE SEARCH BOX IS ABOVE THE TABS on the main screen - after the banner and the notice.
            // ⭐ THE TODAY STRIP (chats only) sits under the tabs; "" for an old index or nothing due.
            let Strip: string = "";
            if (At === "chats" && this.ThreeNow() === true) { Strip = this.Tasks().StripHtml(); }
            // ⭐ OVERDUE MONEY joins the Today strip (money ON only; "" otherwise - the old page byte for byte).
            if (At === "chats" && this.ThreeNow() === true && AppMoneyModel.Enabled(this.Index) === true) { Strip = Strip + this.MoneyTab().OverdueHtml(); }
            // ⭐ THE "LET <NAME> KNOW?" CARDS: under the strip on Chats, under the tabs on Tasks - never on
            // an old index (no ticks, so no cards).
            let Notes: string = "";
            if ((At === "chats" || At === "tasks") && AppTaskRules.Enabled(this.Index) === true) { Notes = AppTaskNotifyView.Region(); }
            this.NotesHref = "";
            // ⭐ "ASK ABOUT EVERYONE" RIGHT UNDER THE SEARCH BOX (chats only) - "" unless `/folder` said `owner: true`.
            let AskAll: string = "";
            // ⭐ (owner 2026-11-01 "Redesign the first page - focus on latest and pinned chats"): below the panes the first
            // page is the chats alone - the box moves to the Tasks view; on the wide screen it stays in "Choose a chat".
            let AskAt: string = "tasks";
            if (this.ThreeNow() === true) { AskAt = "chats"; }
            if (At === AskAt && this.Index.Contacts.length > 0) { AskAll = this.AskAllBox().Html(this.IsOwner === true && this.ServiceUrl.length > 0, this.NumberNow(), this.KeyNow(), this.Index.Contacts, AppMoneyModel.Enabled(this.Index)); }
            this.PaintView(AppAccountViews.Relink(this.Relink) + this.Notice.Html() + this.ListBody(At, AskAll, Strip, Notes), "");
            // ⭐ THE SEARCH BOX IN THE TOP BAR (chats only; `Paint` hid it): made once, then only shown again - with the
            // count brought up to date, and never re-drawn under the owner's caret.
            if (At === "chats" && this.Index.Contacts.length > 0) { this.ShowBarSearch(); }
            // ⚠ WIRED AFTER EVERY PAINT, like `WireSignUp`: `Paint` replaces the input, and a
            // listener bound once would work until the first re-render and then silently stop.
            // (The same function added twice to the bar's input is ONE listener - `addEventListener` de-duplicates.)
            const Box: HTMLElement | null = document.getElementById(AppViews.FindId);
            if (Box !== null) { Box.addEventListener("input", this.OnFind); }
            // ⚠ BOTH WIRES DO NOTHING FOR AN OLD INDEX (and for an element that was not drawn).
            if (At === "tasks") { this.Tasks().WireTab(document.getElementById(AppTaskView.TabId) as unknown as IAppTaskEl | null); }
            if (At === "chats") { this.Tasks().WireStrip(document.getElementById(AppTaskView.StripId) as unknown as IAppTaskEl | null); }
            if (At === "chats" || At === "tasks") { this.Faces().Fill(document.body); }
            this.WireNotes();
            // ⚠ A FILTER KEPT ACROSS THE REPAINT SEARCHES THE MESSAGES AGAIN, or the hits would vanish.
            if (At === "chats") { this.Searcher().Now(this.Filter); }
            if (AskAll.length > 0) { this.AskAllBox().Wire(); }
            if (At === "money" && AppMoneyModel.Enabled(this.Index) === true) { this.MoneyTab().Wire(); }
            this.FadeNotice();
            this.WireRelink();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.List");
        }
    };

    /**
     * A list view's page. ⭐ ON THE WIDE SCREEN (`AppLayout`) the list and the tabs are on the left, so the center gets:
     * Chats = "Choose a chat" (+ the Today strip, "Ask about everyone", the task-close cards, the coverage line); Tasks /
     * Revenue = the view itself. Narrow: exactly the page it always was.
     */
    private ListBody = (At: string, AskAll: string, Strip: string, Notes: string): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            // ⭐ THE VIEW'S `<h1>` (`AppViews.ViewHead`, for a screen reader) comes first - except where "Choose a chat" is it.
            const Head: string = AppViews.ViewHead(AppViews.ViewName(At));
            if (this.ThreeNow() === true) {
                if (At === "tasks") { return Head + Notes + this.Coverage() + this.Tasks().TabHtml(); }
                if (At === "money") { this.CheckAnalysed(); return Head + this.MoneyHtml(); }
                return AppThreeColView.Empty(AppKeyRules.IsMac(nz(navigator.platform)), Strip + AskAll + Notes + this.Coverage());
            }
            // ⭐ THE FIRST PAGE IS PINNED + LATEST CHATS (owner 2026-11-01): only the task-close cards stay above the list (they
            // wait on the owner's click); "Ask about everyone" and the coverage line are on the Tasks view, Today is its groups.
            const Between: string = AskAll + Strip + Notes + this.Coverage();
            // ⭐ THE RAIL COMES LAST IN THE PAGE (wave B): below the panes it is the bar at the bottom of the window, so the
            // keyboard reaches it after the view - the order the eye sees.
            const Rail: string = this.Tabs(At);
            // ⛔ `TabHtml` IS `AppViews.Tasks(Index)` FOR AN OLD INDEX - the switch lives in the board.
            if (At === "tasks") { return Head + Between + this.Tasks().TabHtml() + Rail; }
            // ⛔ NO COVERAGE LINE ON REVENUE (owner review 2026-11-01): an unanalysed chat there is a fault, reported (`CheckAnalysed`).
            if (At === "money") { this.CheckAnalysed(); return Head + AskAll + Strip + Notes + this.MoneyHtml() + Rail; }
            return Head + AppViews.Chats(this.Index, this.Filter, Notes, this.TopBar.Mounted) + Rail;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.ListBody");
            return "";
        }
    };

    /**
     * ⭐ The Overview tab (`AppOverviewView`): tabs, then the three lists. No search box and no coverage
     * line - the numbers are counted from every message, analysed or not. Nothing to wire: its 30/90
     * switch is CSS, its rows are links.
     */
    private ShowOverview = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.PaintView(AppAccountViews.Relink(this.Relink) + this.Notice.Html() + AppViews.ViewHead(AppViews.ViewName(AppOverview.Route))
                + AppOverviewView.Tab(this.Index, AppTaskRules.TodayLocal(new Date())) + this.CenterTabs(AppOverview.Route), "");
            this.Faces().Fill(document.body);
            this.FadeNotice();
            this.WireRelink();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.ShowOverview");
        }
    };

    /**
     * The picture loader for the source in hand. ⚠ A NEW SOURCE (a sign-in, another archive) GETS A NEW
     * LOADER, so one account's pictures can never be painted on another's list.
     */
    private Faces = (): AppAvatarLoader => {
        if (getCoreUtils().KErrorMode === true) { return new AppAvatarLoader(this.Source); }
        try {
            if (this.FaceLoader !== null && this.FaceSource === this.Source) { return this.FaceLoader as AppAvatarLoader; }
            this.FaceLoader = new AppAvatarLoader(this.Source);
            this.FaceSource = this.Source;
            return this.FaceLoader;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.Faces");
            return new AppAvatarLoader(this.Source);
        }
    };

    /**
     * The task board over the index in hand. ⚠ A NEW INDEX GETS A NEW BOARD (a sign-in, a reload of
     * the archive): the old one's rows belong to the index that went away. The filter and search are
     * carried over, so a re-read does not throw away what the owner had narrowed to.
     */
    private Tasks = (): AppTaskBoard => {
        if (getCoreUtils().KErrorMode === true) { return new AppTaskBoard(this.Index, this.TaskActions, new AppTaskBoardLink(this)); }
        try {
            if (this.Board !== null && this.BoardOf === this.Index) { return this.Board as AppTaskBoard; }
            const Made: AppTaskBoard = new AppTaskBoard(this.Index, this.TaskActions, new AppTaskBoardLink(this));
            Made.Decided = new AppTaskDecidedLink(this);
            if (this.Board !== null) { Made.Who = (this.Board as AppTaskBoard).Who; Made.Search = (this.Board as AppTaskBoard).Search; }
            this.Board = Made;
            this.BoardOf = this.Index;
            return Made;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.Tasks");
            return new AppTaskBoard(this.Index, this.TaskActions, new AppTaskBoardLink(this));
        }
    };

    /**
     * "Reply about this task": open the task's chat (at its message) with the AI panel asked "Help me
     * reply about: <task>". ⛔ ASKING ONLY - the draft card's Send button is still the only sender.
     * ⚠ WITHOUT AI HELP (not the hosted page, not the owner) the chat simply opens.
     */
    public ReplyAbout = (Row: AppRow): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Link: string = AppTaskRules.LinkOf(Row);
            if (Link.length === 0) { return; }
            this.PendingAsk = AppTaskRules.ReplyAsk(Row);
            this.AssistOpen = 1;
            if (window.location.hash === Link) { this.OnHash(); return; }
            window.location.hash = Link;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.ReplyAbout");
        }
    };

    /**
     * A reply-owed task row was clicked (`AppTaskBoard.Opened`); the browser follows its link, and
     * `Wire` focuses the message box when that chat is drawn. ⛔ Focus only - nothing is sent.
     */
    public FocusReply = (Href: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.PendingFocusHref = nz(Href);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.FocusReply");
        }
    };

    /**
     * The Tasks tab's number, rewritten in place after a tick, snooze or add (`AppTaskBoard.Refresh`).
     * ⚠ FOUND BY ITS LINK, NOT A NEW ID - the tab's markup stays exactly as an old index draws it.
     */
    public OnTaskCount = (Count: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Tally: Element | null = document.querySelector("nav.tabs a.tab[href=\"#tasks\"] i");
            if (Tally !== null) { Tally.textContent = Count; }
            // ⭐ THE CARDS' "N to do" FOLLOW TOO (verifier 2026-09-30): on the wide screen the list is beside the open chat, and a
            // tick in the chat's strip left its row saying "3 to do" next to "2 open". Only the list is redrawn, never the center.
            if (AppTaskRules.RecountOpen(this.Index, AppTaskRules.TodayLocal(new Date())) === true) { this.RepaintCards(false); this.RefreshHeadProps(); }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnTaskCount");
        }
    };

    // ── "Let <name> know?" - closing a task is two clicks (owner, 2026-09-26) ────────────────

    /**
     * Whether a closed task may offer a card: the hosted page (a service to ask), the OWNER's browser
     * (`/folder` said `owner: true` - AI help is owner-only), a source that can ask the sender how a
     * send went, and an index with the new task fields. Anyone else: no card, nothing asked.
     */
    public NotifyAllowed = (): boolean => {
        if (getCoreUtils().KErrorMode === true) { return false; }
        try {
            if (this.ServiceUrl.length === 0 || this.IsOwner !== true) { return false; }
            return this.Source.CanCheck() === true && AppTaskRules.Enabled(this.Index) === true;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.NotifyAllowed");
            return false;
        }
    };

    /** `IAppTaskDecided.Closed` - `/tasks` confirmed a close (tab, strip, contact page, bubble). */
    public TaskClosed = (Row: AppRow): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Offered: boolean = this.Notifier.Closed(Row, AppTaskBoard.ContactOf(this.Index, Row.Href), this.NotifyAllowed());
            // ⭐ THE CARD IS IN THE AI PANEL NOW, so a close on the open chat opens the panel (a sheet on a
            // phone) to show it. ⛔ Opening it sends nothing - the card's own Send is still the only way.
            if (Offered === true && this.Assist !== null && Row.Href === this.OpenHref) {
                this.AssistOpen = 1;
                this.ShowAssist();
            }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.TaskClosed");
        }
    };

    /** `IAppTaskDecided.Reopened` - Undo: the card for that task goes. */
    public TaskReopened = (Id: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Notifier.Reopened(Id);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.TaskReopened");
        }
    };

    /** The region in the AI panel on a contact page - "" where tasks are off or nothing can be sent. */
    private NotesMarkup = (): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            if (AppTaskRules.Enabled(this.Index) === false || this.Open === null) { return ""; }
            return AppTaskNotifyView.Region();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.NotesMarkup");
            return "";
        }
    };

    /** After a paint: the region (if drawn) gets its cards and its one click listener. */
    private WireNotes = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Region: HTMLElement | null = document.getElementById(AppTaskNotifyView.RegionId);
            if (Region === null) { return; }
            Region.addEventListener("click", this.OnNoteClick);
            this.PaintNotes();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.WireNotes");
        }
    };

    /** `IAppNotifyHost.Changed` - redraw the cards in the region on screen (none drawn = nothing to do). */
    public PaintNotes = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Region: HTMLElement | null = document.getElementById(AppTaskNotifyView.RegionId);
            if (Region === null) { return; }
            const Kept: AppFocusMark = AppFocusKeep.Before(document, Region as unknown as IFocusEl);
            Region.innerHTML = AppTaskNotifyView.Cards(this.Notifier.For(this.NotesHref), new Date(),
                Region.closest(".assist") !== null);
            if (Kept.Had === true && AppFocusKeep.After(Region as unknown as IFocusEl, Kept) === false) { this.FocusPastNotes(); }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.PaintNotes");
        }
    };

    /**
     * The last card went (Skip, Send) while the keyboard was on it: the focus goes to what the owner was doing before the
     * card came - the AI panel's ask box beside a chat, else the task list or the Today strip, else the view itself.
     * ⛔ Focus only (decision 9).
     */
    private FocusPastNotes = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (AppFocus.To(document, AppAssistView.AskBoxId) === true && AppFocus.Lost(document) === false) { return; }
            for (const Id of [AppTaskView.ListId, AppTaskView.StripListId]) {
                if (AppFocus.ToFirst(document.getElementById(Id) as unknown as IFocusEl | null) === true) { return; }
            }
            AppFocus.Region(this.FocusRegion());
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.FocusPastNotes");
        }
    };

    /** A card's button. ⛔ Only `send` sends, and only through `NotifySend`. */
    private OnNoteClick = (Ev: Event): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Button: Element | null = AppEventTarget.Closest(Ev, "[" + AppTaskNotifyView.ActAttr + "]", "AppMain.Closest");
            if (Button === null || (Button as HTMLButtonElement).disabled === true) { return; }
            Ev.preventDefault();
            this.Notifier.Act(nz(Button.getAttribute(AppTaskNotifyView.IdAttr)), nz(Button.getAttribute(AppTaskNotifyView.ActAttr)));
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnNoteClick");
        }
    };

    /**
     * `IAppNotifyHost.Send` - a card's Send click. ⛔ THROUGH `AppComposer.SendText`, NEVER BESIDE IT:
     * the open chat's own composer when the card is for that chat (its bubble appears in the chat), else
     * a composer made for the task's contact - no box on screen, the same `QueueTo`, validation and
     * page-wide `SendTicket` latch.
     */
    public NotifySend = (Href: string, Text: string, Then: IComposerSent): string => {
        if (getCoreUtils().KErrorMode === true) { return AppComposer.NoSendWhy(); }
        try {
            const Who: AppContact | null = AppTaskBoard.ContactOf(this.Index, Href);
            if (Who === null) { return AppComposer.NoSendWhy(); }
            if (this.Compose !== null && this.OpenHref === Href) {
                const Why: string = (this.Compose as AppComposer).SendText(Text, Then);
                // ⚠ ON A PHONE THE SHEET CLOSES once the request went, so the bubble is what shows next
                // (the same as a panel draft's Send, `AssistSend`).
                if (Why.length === 0 && AppMain.Wide() === false) { this.AssistOpen = 0; this.ShowAssist(); }
                return Why;
            }
            const Loose: AppComposer = new AppComposer(document.createElement("textarea") as unknown as IComposerBox,
                document.createElement("form") as unknown as IComposerForm, true, new AppSendToDoor(this, Who as AppContact));
            return Loose.SendText(Text, Then);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.NotifySend");
            return AppComposer.NoSendWhy();
        }
    };

    /** `IAppNotifyHost.Edit` - open the chat with the draft in its box. ⛔ Sends nothing. */
    public NotifyEdit = (Href: string, Text: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.Compose !== null && this.OpenHref === Href) {
                // ⚠ On a phone the sheet closes, so the box and its Send are what the owner sees (`AssistFill`).
                if (AppMain.Wide() === false) { this.AssistOpen = 0; this.ShowAssist(); }
                if (nz(Text).length > 0) { (this.Compose as AppComposer).Fill(Text); }
                return;
            }
            this.PendingFill = nz(Text);
            this.PendingFillHref = Href;
            const Link: string = "#c/" + encodeURIComponent(Href);
            if (window.location.hash === Link) { this.OnHash(); return; }
            window.location.hash = Link;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.NotifyEdit");
        }
    };

    /** `IAppTaskHost` - the archive proof `/send` uses. */
    public TaskPhone = (): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            return this.NumberNow();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.TaskPhone");
            return "";
        }
    };

    public TaskKey = (): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            return this.KeyNow();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.TaskKey");
            return "";
        }
    };

    /** `IAppTaskHost.Post` - one POST to `/tasks`, answered once. No service: a sentence, not a request. */
    // REUSE-JUSTIFIED: the address lookup and no-service answer are shared (`RouteUrl`). `AssistPost` cannot be the
    // shared member: `AppAssistExport.test.ts` reads ITS OWN body for `new AppAccountPost(Url, Body, Done).Send()`, and
    // a third member holding the same three lines for both would only move the copy. This is `IAppTaskHost.Post`.
    public TaskPost = (Body: string, Done: AppTaskDone): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        const Route: string = AppTaskApi.Route;
        try {
            const Url: string = this.RouteUrl(Route, Done);
            if (Url.length > 0) { new AppAccountPost(Url, Body, Done).Send(); }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.TaskPost");
        }
    };

    // ── ⭐ THE REVENUE UPGRADE (2026-10-14, `WAC_MONEY`) - `IAppMoneyHost`. An old index keeps `AppViews.Money`. ──

    /** The Revenue view's markup: the new view on a money-on index, else the old list byte for byte. */
    private MoneyHtml = (): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            if (AppMoneyModel.Enabled(this.Index) === false) { return AppViews.Money(this.Index); }
            return this.MoneyTab().Html(this.ServiceUrl.length > 0 && this.KeyNow().length > 0);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.MoneyHtml");
            return "";
        }
    };

    private MoneyTab = (): AppMoneyRun => {
        if (getCoreUtils().KErrorMode === true) { return new AppMoneyRun(this); }
        try {
            if (this.MoneyRunNow === null) { this.MoneyRunNow = new AppMoneyRun(this); }
            return this.MoneyRunNow as AppMoneyRun;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.MoneyTab");
            return new AppMoneyRun(this);
        }
    };

    /** The open chat's unsettled balance for the header ("" = none, or money off). */
    private MoneyBalance = (): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            if (this.Open === null || AppMoneyModel.Enabled(this.Index) === false) { return ""; }
            return this.MoneyTab().BalanceWords((this.Open as AppContact).Href);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.MoneyBalance");
            return "";
        }
    };

    /** `IAppMoneyHost.MoneyPost` - one POST to `/money`. */
    public MoneyPost = (Body: string, Done: (Status: number, Text: string) => void): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        const Route: string = AppMoney.Route;
        try {
            const Url: string = this.RouteUrl(Route, Done);
            if (Url.length === 0) { return; }
            const Post = new AppAccountPost(Url, Body, Done);
            Post.Send();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.MoneyPost");
        }
    };

    /** DOCUMENTED EXCEPTION: accessor for `IAppMoneyHost`. */
    public MoneyIndex = (): AppIndex => {
        return this.Index;
    };

    /** `IAppMoneyHost.MoneyRepaint` - the Revenue view again, only while it is the view on screen. */
    public MoneyRepaint = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (window.location.hash !== "#money") { return; }
            this.List("money");
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.MoneyRepaint");
        }
    };

    /** The CSV separator for this browser's locale (`AppExportRules.SepFor`, `/export`'s rule). */
    public MoneyCsvSep = (): string => {
        if (getCoreUtils().KErrorMode === true) { return ","; }
        try {
            return AppExportRules.SepFor(nz(navigator.language));
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.MoneyCsvSep");
            return ",";
        }
    };

    /** A file to the browser's downloads (a `blob:` link, revoked after a minute). */
    public MoneyDownload = (Name: string, Text: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Url: string = URL.createObjectURL(new Blob([Text], { type: "text/csv;charset=utf-8" }));
            const A: HTMLAnchorElement = document.createElement("a");
            A.href = Url;
            A.download = Name;
            A.hidden = true;
            document.body.appendChild(A);
            A.click();
            A.remove();
            window.setTimeout(this.MoneyRevoke, 60000, Url);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.MoneyDownload");
        }
    };

    private MoneyRevoke = (Url: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            URL.revokeObjectURL(Url);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.MoneyRevoke");
        }
    };

    /**
     * The service address of `Route` for a POST answered through `Done` (`TaskPost`, `AssistPost`,
     * `AssistPostStream`). No service: `Done` hears the no-service sentence HERE and "" comes back, so the caller
     * sends nothing.
     */
    private RouteUrl = (Route: string, Done: (Status: number, Text: string) => void): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            const Url: string = AppSignUpApi.UrlFor(this.ServiceUrl, Route);
            if (Url.length === 0) { Done(200, JSON.stringify({ ok: false, why: AppSignUpApi.NoServiceWhy() })); }
            return Url;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.RouteUrl");
            return "";
        }
    };

    // ── Several open tabs (2026-09-27) - `AppTabBus` ─────────────────────────────────────────

    /** `IAppTabOwner` - what is on screen now, for a notice from another tab. ⛔ No sender is handed over. */
    public TabParts = (): AppTabParts => {
        const Out: AppTabParts = new AppTabParts();
        if (getCoreUtils().KErrorMode === true) { return Out; }
        try {
            Out.Index = this.Index;
            Out.Actions = this.TaskActions;
            Out.Board = this.Board;
            Out.Frame = this.TaskFramer;
            Out.Notifier = this.Notifier;
            Out.Appender = this.Appender;
            Out.Sessions = this.Assists;
            Out.Panel = this.Assist;
            Out.OpenHref = this.OpenHref;
            Out.IsOwner = this.IsOwner;
            Out.Translate = this.Translate.Current();
            if (this.ChatSettingsBox !== null) { Out.TranslateEditor = this.ChatSettingsBox.Translation(); }
            Out.Translator = this.Translate.Translator;
            return Out;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.TabParts");
            return Out;
        }
    };

    /** Tell this subscriber's other tabs. A notice only - see `AppTabBus`. */
    private TellTabs = (Kind: string, Href: string, TaskId: string, State: string, Until: string,
                        Outcome: string, Id: string, ChatId: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.TabBus.Ensure(this.NumberNow());
            const N: AppTabNotice = new AppTabNotice();
            N.Kind = Kind; N.Href = nz(Href); N.TaskId = nz(TaskId); N.State = nz(State); N.Until = nz(Until);
            N.Outcome = nz(Outcome); N.Id = nz(Id); N.ChatId = nz(ChatId);
            this.TabBus.Tell(N);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.TellTabs");
        }
    };

    /** `IAppTaskHost.Confirmed` - `/tasks` confirmed a change: the other tabs update that row. */
    public TaskConfirmed = (Page: string, Row: AppRow): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            let Until: string = "";
            if (Row.State === "snoozed") { Until = Row.Until; }
            this.TellTabs("task", Page, Row.Id, Row.State, Until, "", "", "");
            // ⭐ THE LIST'S "N to do" beside the open chat (the tick in the chat's strip reaches no board refresh).
            if (AppTaskRules.RecountOpen(this.Index, AppTaskRules.TodayLocal(new Date())) === true) { this.RepaintCards(false); this.RefreshHeadProps(); }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.TaskConfirmed");
        }
    };

    /** A message was queued: the other tabs showing that chat draw its bubble (from the sent history). */
    private TellSent = (Answered: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Who: AppContact | null = AppMain.Found(this.Index, this.SendingHref);
            if (Who === null) { return; }
            let Id: string = nz(Answered);
            if (AppTabBusRules.RequestIdPattern.test(Id) === false) { Id = this.SendingId; }
            this.TellTabs("sent", "", "", "", "", "", Id, (Who as AppContact).ChatId);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.TellSent");
        }
    };

    /** An AI answer came back SAVED in the chat's history: the other tabs showing that chat re-read it. */
    private TellSaved = (Session: AppAssistSession): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.IsOwner !== true || Session.Entries.length === 0) { return; }
            // ⛔ ONLY WHEN SOMETHING WAS SAVED SINCE THE LAST LOOK - never after a mere repaint or a history read
            // (`AppAssistRules.NewlySaved`: that echo used to swallow the real notice that followed it).
            if (AppAssistRules.NewlySaved(Session) !== true) { return; }
            for (const Href of Object.keys(this.Assists)) {
                if (this.Assists[Href] === Session) { this.TellTabs("aichat", Href, "", "", "", "", "", ""); }
            }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.TellSaved");
        }
    };

    /** `IAppNotifyHost.Acted` - a card was sent, edited or skipped: the other tabs take theirs down. */
    public NoteActed = (Id: string, Outcome: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.TellTabs("acted", "", Id, "", "", Outcome, "", "");
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.NoteActed");
        }
    };

    /**
     * The tab is shown again: the board re-counts, the open chat's AI history is re-read (at most every
     * 30 s), and on a list view an index older than a minute is re-read quietly. ⛔ Reads only.
     */
    private OnVisible = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (document.visibilityState !== "visible" || this.Index.Loaded === false) { return; }
            if (this.PhoneMarks !== null) { this.PhoneMarks.Load(); }
            const OnList: boolean = AppTabBusRules.IsListRoute(window.location.hash);
            if (this.TabSync.Visible(Date.now(), OnList) === false) { return; }
            this.TabSync.IndexRead(Date.now());
            this.Source.LoadIndex(this.OnQuietIndex, this.OnQuietFail);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnVisible");
        }
    };

    /** The quiet re-read landed: a readable index replaces the old one, and a list view repaints. */
    private OnQuietIndex = (Text: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Fresh: AppIndex = AppIndexReader.Parse(Text);
            if (Fresh.Loaded === false || AppTabBusRules.IsListRoute(window.location.hash) === false) { return; }
            AppLiveListRules.Adopt(Fresh, this.Index, this.Unread);
            this.Index = Fresh;
            this.OnHash();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnQuietIndex");
        }
    };

    /**
     * The quiet re-read failed: the index in hand stays on screen, and the next time the tab is shown tries
     * again. ERROR-SUPPRESSED-JUSTIFIED: a background refresh the owner did not ask for is not a failure to
     * show - the page they are looking at is still complete (law 1).
     */
    private OnQuietFail = (Why: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.TabSync.IndexRead(1);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnQuietFail");
        }
    };

    /**
     * The search box changed: filter the cards, live.
     *
     * ⛔ ONLY THE LIST AND THE COUNT ARE REWRITTEN, NEVER THE BOX. Repainting the view would destroy
     * the input under the caret on every keystroke - focus lost after one letter, and on a phone
     * the keyboard closing each time.
     */
    private OnFind = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Box: HTMLInputElement | null =
                document.getElementById(AppViews.FindId) as HTMLInputElement | null;
            if (Box === null) { return; }
            this.Filter = nz(Box.value);
            const List: HTMLElement | null = document.getElementById(AppViews.ListId);
            // ⭐ WIDE SCREEN: the list on the left, its open row still lit (`RepaintList`) - the center is left alone.
            if (this.Three.IsOn(this.ThreeDoc) === true) { this.RepaintList(); }
            else if (List !== null) { List.innerHTML = this.ChatRows(); this.Faces().Fill(List); }
            const Found: HTMLElement | null = document.getElementById(AppViews.FoundId);
            if (Found !== null) { Found.textContent = AppViews.FoundText(this.Index, this.Filter, this.IncludeNativeChat); }
            // ⚠ NAMES ARE IMMEDIATE; THE MESSAGES WAIT FOR A PAUSE (`AppSearchPanel.DebounceMs`).
            this.Searcher().Typed(this.Filter);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnFind");
        }
    };

    /** "Ask about everyone" (`AppAskAll`) - one per page; it keeps its session across every repaint. */
    private AskAllBox = (): AppAskAll => {
        if (getCoreUtils().KErrorMode === true) { return new AppAskAll(this); }
        try {
            if (this.AskAll === null) { this.AskAll = new AppAskAll(this); }
            return this.AskAll as AppAskAll;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.AskAllBox");
            return new AppAskAll(this);
        }
    };

    /**
     * The message search for the source in hand. ⚠ A NEW SOURCE (a sign-in, a new ticket) GETS A NEW
     * PANEL, and the old one is stopped - its `search.json` belongs to the archive that went away.
     */
    private Searcher = (): AppSearchPanel => {
        if (getCoreUtils().KErrorMode === true) { return new AppSearchPanel(this.Source); }
        try {
            if (this.Search !== null && this.SearchOf === this.Source) { return this.Search as AppSearchPanel; }
            if (this.Search !== null) { (this.Search as AppSearchPanel).Stop(); }
            const Made: AppSearchPanel = new AppSearchPanel(this.Source, new AppSearchActHost(this));
            this.Search = Made;
            this.SearchOf = this.Source;
            return Made;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.Searcher");
            return new AppSearchPanel(this.Source);
        }
    };

    /**
     * Leave the task that just finished and go to the main screen, saying so there.
     *
     * ⭐ OWNER, 2026-09-25: "A successful save should bring me back to the main screen."
     * ⚠ `Opening` IS CLEARED WHEN NO ARCHIVE IS OPEN: a cold load straight onto `#claude` or
     * `#import` never opened it, and a latch left from an earlier refusal would swallow this one -
     * the address would say `#chats` over a panel that never went away.
     * ⚠ ALREADY ON `#chats` FIRES NO `hashchange`, so the route is taken here.
     */
    private BackToMain = (Say: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Notice.Set(Say);
            if (this.Index.Loaded === false) { this.Opening = false; }
            if (AppMain.RouteIs("chats") === true) { this.OnHash(); return; }
            window.location.hash = "#chats";
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.BackToMain");
        }
    };

    /** A notice on screen takes itself away after `AppNotice.FadeMs` - the element only, no repaint. */
    private FadeNotice = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (document.getElementById(AppNotice.Id) === null) { return; }
            if (this.NoticeTimer !== 0) { window.clearTimeout(this.NoticeTimer); }
            this.NoticeTimer = window.setTimeout(this.OnNoticeFade, AppNotice.FadeMs);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.FadeNotice");
        }
    };

    private OnNoticeFade = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.NoticeTimer = 0;
            this.Notice.Clear();
            const El: HTMLElement | null = document.getElementById(AppNotice.Id);
            if (El !== null) { El.remove(); }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnNoticeFade");
        }
    };

    private Tabs = (At: string): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            // ⭐ THE NAVIGATION RAIL (`AppRail`, business look wave B): the same five routes and the same counts the tabs had,
            // as ONE named landmark ("Views") - a column at the far left on the wide screen, a bar at the bottom below it.
            const Items: AppRailItem[] = [AppRailView.Item("chats", "Chats", String(this.Index.Contacts.length)),
                AppRailView.Item(AppOverview.Route, "Overview", ""),
                // ⚠ OLD INDEX: `Tasks.length`, exactly as before. New index: the OPEN tasks only.
                AppRailView.Item("tasks", "Tasks", AppTaskRules.TabCount(this.Index, AppTaskRules.TodayLocal(new Date()))),
                AppRailView.Item("money", "Revenue", String(this.Index.Money.length))];
            // ⚠ NO COUNT: the list is asked for when the tab opens, not when the index loads.
            if (this.Source.CanHistory() === true) { Items.push(AppRailView.Item(AppAccount.SentRoute, "Sent", "")); }
            return AppRailView.Html(Items, At);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.Tabs");
            return "";
        }
    };

    /**
     * The open chat's property row redrawn in place when its numbers moved (a task ticked: "Open tasks" follows the strip's
     * "N open" - the two must never disagree). ⛔ Written only when the markup differs; the rest of the header (the "⋯"
     * menu, its focus) is untouched.
     */
    private RefreshHeadProps = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.Open === null || AppMain.IsDetail() === false) { return; }
            const Row: HTMLElement | null = document.getElementById(AppChatHead.PropsId);
            if (Row === null) { return; }
            const Fresh: string = AppChatHead.Props(AppChatHead.Fields(this.Open, this.NewChat, this.MoneyBalance()), Row.hasAttribute("hidden") === false);
            if (Fresh.length === 0 || Row.outerHTML === Fresh) { return; }
            Row.outerHTML = Fresh;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.RefreshHeadProps");
        }
    };

    /**
     * `<html>` says whether a rail is on the page (`AppRailView.HtmlClass`): below the wide breakpoint the page then keeps
     * room for the bottom bar. Read off the markup just painted, so sign-up, sign-in and every refusal - which draw no
     * rail - never reserve the room.
     */
    private MarkRail = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            document.documentElement.classList.toggle(AppRailView.HtmlClass, document.querySelector("nav." + AppRailView.NavClass) !== null);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.MarkRail");
        }
    };

    /**
     * ⚠ THE COVERAGE LINE IS NOT DECORATION. Every number on every screen is drawn from the
     * conversations that have been analysed, and while that is 1 of 82 the Tasks view is not "your
     * tasks" - it is "the tasks found in one chat". A product that does not say so is lying by
     * omission, and it disappears by itself the moment coverage is complete.
     */
    private Coverage = (): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            return AppViews.CoverageLine(this.Index);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.Coverage");
            return "";
        }
    };

    // ── One contact ──────────────────────────────────────────────────────────────────────────

    /**
     * The contact page itself, in a frame.
     *
     * ⚠ THE PAGE IS SHOWN, NOT RE-IMPLEMENTED. It already renders the identity, the blocks, the
     * icons and the whole conversation with working in-chat anchors - and it is the artifact the
     * owner also sees in Drive. Rebuilding that here would give the owner two things that look
     * different and claim to be the same, and the copy would drift.
     */
    private Contact = (Href: string, Anchor: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Shell(true);
            this.NewChat = false;
            this.DropNewChatPost();
            this.Open = AppMain.Found(this.Index, Href);
            this.OpenHref = Href;
            // ⭐ OPENED = READ: its "N new" goes, and the tab title's count with it - on the wide screen in the list's row
            // too, at once and in place (the skeleton's paint below lights the row; the list is not redrawn).
            if (this.Open !== null) { AppLiveListRules.Read(this.Index, this.Unread, (this.Open as AppContact).ChatId); this.ShowUnread(); }
            this.PaintView(AppSkeleton.Chat("Opening the chat…") + this.CenterTabs("chats"), this.CurrentChat());
            const Show = (Html: string): void => {
                this.Frame(Html, Anchor);
            };
            this.Source.LoadPage(Href, Show, this.Trouble);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.Contact");
        }
    };

    /**
     * ⭐ A CHAT THAT BEGAN AFTER THE LAST REBUILD (`#n/<chat>`, 2026-09-28): the service draws its PROVISIONAL page from
     * the journal (`/live` `mode: "page"`, `LivePage` - the rebuild's own generator), and from there it is an ordinary
     * chat view: the live feed follows it by chat id, the composer sends to it. No AI panel, export or translation (they
     * need the page the rebuild writes). A chat that has its page by now goes to it.
     */
    private ShowNewChat = (Chat: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Known: AppContact | null = AppLiveListRules.ContactOf(this.Index, Chat);
            if (Known !== null && (Known as AppContact).IsNew === false && (Known as AppContact).Href.length > 0) {
                window.location.replace("#c/" + encodeURIComponent((Known as AppContact).Href));
                return;
            }
            this.Shell(true);
            this.NewChat = true;
            this.DropNewChatPost();
            this.Open = AppMain.Newcomer(Known, Chat);
            this.OpenHref = "";
            AppLiveListRules.Read(this.Index, this.Unread, Chat);
            this.ShowUnread();
            this.PaintView(AppSkeleton.Chat("Opening the chat…") + this.CenterTabs("chats"), Chat);
            const Url: string = AppSignUpApi.UrlFor(this.ServiceUrl, AppLiveRules.Route);
            if (Url.length === 0 || AppLiveRules.ChatIdOk(Chat) === false || this.KeyNow().length === 0) { this.Trouble(AppMain.NewChatWhy()); return; }
            const Post: AppLivePost = new AppLivePost();
            this.NewChatPost = Post;
            Post.Post(Url, AppLiveRules.BodyOf(this.NumberNow(), this.KeyNow(), "", "", [], AppLiveRules.PageMode, Chat, [], -1), this.OnNewChatPage);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.ShowNewChat");
        }
    };

    /** The row for a new chat: the list's card when there is one, else a bare one (its title from the chat id). */
    private static Newcomer = (Known: AppContact | null, Chat: string): AppContact => {
        if (getCoreUtils().KErrorMode === true) { return new AppContact(); }
        try {
            if (Known !== null) { return Known as AppContact; }
            const Made: AppContact = new AppContact();
            Made.ChatId = Chat;
            Made.Title = AppLiveListRules.TitleOf(Chat, {});
            Made.IsNew = true;
            return Made;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.Newcomer");
            return new AppContact();
        }
    };

    /** The provisional page came: drawn like any page. Refused or lost: the honest sentence (the rebuild makes it). */
    private OnNewChatPage = (Status: number, Text: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.NewChatPost = null;
            if (this.NewChat === false || this.Open === null) { return; }
            if (window.location.hash !== "#" + AppViews.NewRoute + "/" + encodeURIComponent((this.Open as AppContact).ChatId)) { return; }
            const Got: AppLiveAnswer = AppLiveRules.Parse(Status, Text);
            if (Got.Ok === true && Got.Page.length > 0) {
                if (Got.Title.length > 0 && (this.Open as AppContact).Href.length === 0) { (this.Open as AppContact).Title = Got.Title; }
                this.Frame(Got.Page, "");
                return;
            }
            // ⭐ A chat started from "New chat" may have no message at all yet: an empty conversation with the composer.
            if (AppNewChatRules.Started.has((this.Open as AppContact).ChatId) === true) { this.Frame(AppNewChatRules.EmptyPage((this.Open as AppContact).Title), ""); return; }
            // ⚠ VALIDATION, NOT AN ERROR (law 1): the chat is real and its page comes with the next rebuild.
            this.Trouble(AppMain.NewChatWhy());
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnNewChatPage");
        }
    };

    /** The provisional page's request, dropped (the owner went elsewhere). */
    private DropNewChatPost = (): void => {
        // ERROR-SUPPRESSED-JUSTIFIED: no KErrorMode guard - dropping a request must work whatever the gate says.
        try {
            if (this.NewChatPost !== null) { (this.NewChatPost as AppLivePost).Abort(); this.NewChatPost = null; }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.DropNewChatPost");
        }
    };

    /** DOCUMENTED EXCEPTION: pure constant sentence. ERROR-SUPPRESSED-JUSTIFIED: returns a literal. */
    private static NewChatWhy = (): string => {
        return "This is a new chat. Its page is made with the next update of your archive, " + AppUpdateEvery.Within + " - open it again then.";
    };

    /** Installs the app's tooltips (`AppTips`) on the contact frame's document; handed to `AppFrameA11y.Tips`. */
    private static FrameTips = (Doc: IFrameA11yDoc): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            AppTips.Install(Doc as unknown as Document);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.FrameTips");
        }
    };

    /** The contact this route is showing. Needed for the chat id a send is addressed with -
     *  `Href` alone is a file path and says nothing about where a message would go. */
    private Open: AppContact | null = null;

    private static Found = (Index: AppIndex, Href: string): AppContact | null => {
        if (getCoreUtils().KErrorMode === true) { return null; }
        try {
            for (const One of Index.Contacts) {
                if (One.Href === Href) { return One; }
            }
            return null;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.Found");
            return null;
        }
    };

    /** The blob URL currently in the frame. Revoked when replaced - each one pins its Blob in
     *  memory until it is, and a session browsing fifty contacts would pin fifty pages. */
    private Blob: string = "";

    /** ⛔ The frame's styles as `blob:` sheets (`AppFrameStyle` says why: no inline style may run). */
    private Sheet: AppFrameSheet = new AppFrameSheet();

    /** The href of the page in the frame - `AppMediaFill` resolves each photo against it. */
    private OpenHref: string = "";

    /** The index `CheckAnalysed` last looked at (one report per index, never one per repaint). */
    private AnalysedChecked: AppIndex | null = null;

    /**
     * ⛔ A CHAT LEFT UNANALYSED IS A FAULT, NOT A LINE OF THE SCREEN (owner review 2026-11-01: "Not analysed" in Revenue is an
     * error). The service analyses every stale chat within a few cycles (`EnrichQueue`, fixed so a cursor without its
     * `facts.json` is never "fresh"), so a chat still unanalysed `AppViews.StaleAfterDays` after its last message is a
     * reachable bug: reported once per index through the global handler, never drawn. A new chat inside that window is normal.
     */
    private CheckAnalysed = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.AnalysedChecked === this.Index) { return; }
            this.AnalysedChecked = this.Index;
            const Stale: number = AppViews.StaleUnanalysed(this.Index);
            if (Stale > 0) {
                getCoreUtils().KGlobalErrorHandler(new Error(String(Stale) + " chat(s) still not analysed "
                    + String(AppViews.StaleAfterDays) + "+ days after their last message"), "AppMain.CheckAnalysed");
            }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.CheckAnalysed");
        }
    };

    /** The phone chat header's "Add task": a task for the OPEN chat (`AppPhoneTaskAdd`; owner review 2026-11-01). */
    private OpenChatTaskAdd = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.OpenHref.length === 0) { return; }
            new AppPhoneTaskAddRun(this.Index, this.Tasks()).Open(this.OpenHref);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OpenChatTaskAdd");
        }
    };

    /** Fills the frame's photos and voice notes; released (every blob URL revoked) on replace. */
    private Filler: AppMediaFill | null = null;

    /**
     * ⚠ A BLOB URL, NOT `srcdoc`. FRAGMENT NAVIGATION DOES NOT WORK IN A `srcdoc` FRAME.
     *
     * Measured in Chrome: the document's URL is `about:srcdoc`, clicking `#m-...` leaves
     * `location.hash` empty, `:target` never matches, and the collapsed day never opens. Nothing
     * errors - the link is a perfectly formed `<a>` pointing at an id that genuinely exists on the
     * page, and it simply does nothing. That killed EVERY "in chat" action on EVERY contact inside
     * the app, which is the whole evidence mechanism the block engine exists to provide.
     *
     * The parent's own `scrollIntoView` was not a fix either, and for a second reason: the target
     * usually sits inside a COLLAPSED day, so its box is 0x0 and scrolling to it goes nowhere. Only
     * `:target` opens that day, and only real fragment navigation sets `:target`.
     *
     * A `blob:` URL has a real origin (inherited from this page, so `contentDocument` still works),
     * so `#anchor` in the URL does what it does anywhere else: opens the day, scrolls to the
     * message, highlights it. ONE code path for every source - the Dropbox reader has text, and so
     * does the local one.
     */
    private Frame = (Html: string, Anchor: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            // ⚠ THE BANNER RIDES HERE TOO: this is the screen where a dead link bites - the Send
            // button under the conversation cannot work until WhatsApp is linked again.
            // ⭐ ONE CHAT CARD (owner, 2026-09-25): the frame and the composer are a single unit, the
            // way WhatsApp draws a chat, and the AI panel sits beside it (a sheet on a phone).
            this.PaintView(AppAccountViews.Relink(this.Relink)
                + AppChatHead.Html(this.Open, this.NewChat, this.ExportOn(), this.ChatSettingsOn(this.Open), this.MoneyBalance())
                + AppTranslateView.Below()
                + "<div class=\"contact\" id=\"wac-contact\"><section class=\"chatcard\">"
                + "<iframe id=\"wac-frame\" title=\"Contact\"></iframe>" + this.Composer() + "</section>"
                // ⭐ THE RAIL UNDER AN OPEN CHAT below the wide breakpoint (the bottom bar; "" in the panes, where it is the column).
                + this.AssistMarkup() + "</div>" + this.CenterTabs("chats"), this.CurrentChat());
            this.NotesHref = this.OpenHref;
            this.Wire();
            this.WireNotes();
            this.WireAssist();
            this.WireRelink();
            AppExport.Wire(this.ExportWho);
            // ⭐ THE AI PANEL'S HEADER DISC: the SAME loader as the chat list, so a picture the list already
            // fetched is painted from its blob URL at once (`AppAvatarLoader.Shown`) and is never downloaded twice.
            this.Faces().Fill(document.getElementById(AppAssistView.RootId));
            // ⭐ THE CHAT HEADER'S DISC (design item 9): the same loader, so the list's picture is reused, never fetched again.
            this.Faces().Fill(document.getElementById(AppChatHead.Id));
            const Frame: HTMLIFrameElement =
                document.getElementById("wac-frame") as HTMLIFrameElement;
            if (Frame === null) { return; }
            if (this.ReplyFocus !== null) { this.ReplyFocus.Watch(Frame as unknown as IReplyFocusFrame); }
            new AppMessageAnchors().Attach(Frame);
            if (this.Blob.length > 0) { URL.revokeObjectURL(this.Blob); }
            // ⛔ NO INLINE STYLE REACHES THE FRAME (the CSP has no 'unsafe-inline'): the page's `<style>` and
            // `style=` become linked `blob:` sheets, with the app's own frame CSS (reactions, task actions).
            // ⛔ THE PAGE'S STANDALONE SCRIPT (translation's flag/Copy for a file opened on its own) is REMOVED before the
            // frame is built - the app attaches the same behaviour from outside (`AppTranslateFrame`).
            // ⭐ `AppFrameWide.Mark`: on the wide screen the frame's phone rules (decided from the FRAME's width) stand down.
            const Page: string = this.Sheet.Page(AppThemeRules.Mark(AppFrameWide.Mark(AppAssistRules.Embedded(AppPageScript.Strip(Html)), AppMain.Wide()),
                AppThemeRun.Shared.Chosen()), AppTokens.FrameCss() + AppChatHead.FrameCss() + AppPhoneChat.FrameCss() + AppReactions.Css() + AppMsgTickPaint.Css() + AppTaskFrame.Css()
                // (wac-liverx) `AppEditMark.Css` = the "edited" mark of a bubble edited live. Its rules out-rank the
                // translation's and the waiting word's by specificity (an extra `[data-ed]`), so their order is free.
                // (verifier 2026-10-12) `AppTipRules.Css`: the frame's own tooltip (`AppTips.Install` below) had NO rule - it
                // was an unstyled block under the conversation, out of sight. Pinned by `AppAuditVerify.test.ts`.
                + AppChatAppend.Css() + AppPinFrame.Css() + AppLiveRules.Css() + AppEditMark.Css() + AppTipRules.Css()
                // (wac-audit) `AppFrameA11y.Css` LAST: the frame's focus ring, contrast and phone tap targets have the final word.
                + AppTranslateBubble.Css() + AppBubbleKinds.Css() + AppDayFloat.Css() + AppFrameA11y.Css());
            this.Blob = URL.createObjectURL(new Blob([Page], { type: "text/html" }));
            // ⭐ PHOTOS AND VOICE NOTES: the page cannot load them itself inside a `blob:` frame
            // (`AppMediaRules` says why), so they are read with the ticket once the frame loads.
            // Attached BEFORE `src` is set, so the `load` cannot be missed.
            if (this.Filler !== null) { this.Filler.Release(); }
            let MediaChat: string = "";
            if (this.Open !== null) { MediaChat = (this.Open as AppContact).ChatId; }
            this.Filler = new AppMediaFill(this.Source, this.OpenHref, MediaChat);
            this.Filler.Attach(Frame);
            this.AttachAppender(Frame);
            this.AttachReactions(Frame);
            this.AttachTasks(Frame);
            this.AttachPins(Frame);
            new AppKindsFrame(this.CardLookup()).Attach(Frame as unknown as IKindsFrame);
            AppPhoneChatRun.Attach(Frame as HTMLIFrameElement);
            this.AttachTranslate(Frame);
            // ⭐ DAY FOLDING (2026-09-28): the clicked day label stays under the pointer, a linked message's day is
            // ticked, and the owner's opened/folded days survive a repaint of this contact.
            new AppDayFold(this.OpenHref).Attach(Frame as unknown as IDfFrame);
            // ⛔ THE DAY LABEL PINS ONLY WHILE THE OWNER SCROLLS (P0 2026-09-28): pinned at rest it covered a bubble's words
            // and read as the start of the day, hiding that the day's first message was above the view.
            new AppDayFloat().Attach(Frame as unknown as IDflFrame);
            // ⭐ THE PAGE'S OWN BUTTONS WORK FROM THE KEYBOARD AND SAY THEIR STATE (`AppFrameA11y`, audit 2026-10-01).
            const FrameA11y: AppFrameA11y = new AppFrameA11y();
            FrameA11y.Tips = AppMain.FrameTips;
            FrameA11y.Attach(Frame as unknown as IFa11yFrame);
            // ⛔ A SHEET THAT DID NOT APPLY IS PUT BACK THROUGH THE CSSOM (`AppFrameHeal`): a policy from another build, a
            // revoked or refused `blob:` - the owner's page was drawn with no CSS at all (P0, 2026-09-28).
            new AppFrameHeal(this.Sheet.Texts(), this.Sheet.Hrefs()).Attach(Frame as unknown as IHealFrame);
            let At: string = this.Blob;
            if (Anchor.length > 0) { At = At + "#" + Anchor; }
            Frame.src = At;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.Frame");
        }
    };

    /**
     * ⭐ THE OWNER'S OWN SENT MESSAGES APPEAR IN THE CONVERSATION BEFORE THE REBUILD (2026-09-25) -
     * the ones this visit sends (`AppendSent`) and, once the page loads, the ones `/send` remembers
     * that the page does not have yet. One appender per frame; the old one is stopped so a late
     * history answer cannot draw into the next contact's page.
     * ⚠ THE CAST: the iframe satisfies `IChatFrame` at run time; the interface is narrowed so the
     * suite can drive it with a fake document, and `Node`'s generic signatures do not line up.
     */
    private AttachAppender = (Frame: HTMLIFrameElement): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.Appender !== null) { (this.Appender as AppChatAppend).Stop(); }
            let Chat: string = "";
            if (this.Open !== null) { Chat = (this.Open as AppContact).ChatId; }
            const Made: AppChatAppend = new AppChatAppend(this.Source, Chat);
            Made.Attach(Frame as unknown as IChatFrame);
            // ⭐ (2026-10-22) A live photo / voice note is fetched by itself - the frame's `AppMediaFill` presses its button.
            if (this.Filler !== null) { Made.OnLiveMedia = (this.Filler as AppMediaFill).FetchLive; }
            this.Appender = Made;
            this.AttachLive(Frame, Made);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.AttachAppender");
        }
    };

    /**
     * ⭐ NEW INCOMING MESSAGES IN THE OPEN CHAT WITHIN SECONDS (translation step 1): one long-poll feed per frame,
     * the old one stopped. Only on the hosted page with a key, on a one-to-one chat (the service proves the
     * `browser` key and refuses groups too). ⛔ Read-only: the feed is handed the appender, never a sender.
     */
    private AttachLive = (Frame: HTMLIFrameElement, Appender: AppChatAppend): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.Live !== null) { (this.Live as AppLiveFeed).Stop(); this.Live = null; }
            // DEMO MODE: the feed asks `/demo/live` (`AppSignUpApi.UrlFor`) - typing, ticks and replies of the invented chats.
            if (this.ServiceUrl.length === 0 || this.Open === null || this.KeyNow().length === 0) { return; }
            if ((this.Open as AppContact).IsGroup === true || (this.Open as AppContact).ChatId.length === 0) { return; }
            const Who: AppLiveWho = new AppLiveWho();
            Who.ServiceUrl = this.ServiceUrl;
            Who.Phone = this.NumberNow();
            Who.Key = this.KeyNow();
            Who.Page = this.OpenHref;
            // ⭐ A CHAT WITH NO PAGE YET is followed by its chat id (`/live` `mode: "chat"`), not by a page of the index.
            if (this.NewChat === true) { Who.Mode = AppLiveRules.ChatMode; Who.Chat = (this.Open as AppContact).ChatId; Who.Page = ""; }
            const Made: AppLiveFeed = new AppLiveFeed(Appender, Who, new AppLivePost(), new AppLiveWindowClock());
            Made.OnSends = this.OnSendsPushed;
            // (wac-liverx) ⚠ The frame's REACTOR is made AFTER this feed (`Frame`: `AttachAppender` -> here, then
            // `AttachReactions`), so it is handed over there (`UseReactor`) - `this.Reactor` is still the previous frame's here.
            Made.Attach(Frame as unknown as IAppLiveFrame);
            Made.Visible(document.visibilityState === "visible");
            this.Live = Made;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.AttachLive");
        }
    };

    /** The tab was shown or hidden: the live feed pauses while hidden (no request out) and resumes when shown. */
    private OnVisibleLive = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.NativeChatList !== null) { this.NativeChatList.Visible(document.visibilityState === "visible" && document.getElementById(AppViews.ListId) !== null); }
            if (this.Live !== null) { (this.Live as AppLiveFeed).Visible(document.visibilityState === "visible"); }
            // ⭐ The list's feed never pauses, but a background tab may have slowed its timer - shown = ask now.
            if (this.ListFeed !== null && document.visibilityState === "visible") { (this.ListFeed as AppLiveList).Kick(); }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnVisibleLive");
        }
    };

    /**
     * ⭐ REACTING TO A MESSAGE (2026-09-25). One controller per frame, the old one stopped so a late
     * receipt cannot touch the next contact's page. ⚠ ONLY WHERE A SEND CAN GO: a composer for this
     * chat, on a source that can ask the sender how it went (`CanCheck` - the hosted page).
     */
    private AttachReactions = (Frame: HTMLIFrameElement): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.Reactor !== null) { (this.Reactor as AppReactions).Stop(); }
            this.Reactor = null;
            if (this.Compose === null || this.Source.CanCheck() === false) { return; }
            const Made: AppReactions = new AppReactions(new AppReactHost(this), AppMain.Coarse(), new AppWindowLater());
            Made.Attach(Frame as unknown as IRxFrame);
            this.Reactor = Made;
            // (wac-liverx) ⭐ LIVE REACTIONS fold onto the pills THIS reactor draws, and the echo of the owner's own
            // optimistic reaction confirms it (`AppLiveReact`). The feed was made just before (see `AttachLive`); with
            // no reactor (nothing can be sent from this frame) live reactions are simply drawn. ⛔ It reads; never sends.
            if (this.Live !== null) { (this.Live as AppLiveFeed).UseReactor(Made); }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.AttachReactions");
        }
    };

    /**
     * ⭐ TASK ACTIONS ON THE CONTACT PAGE (2026-09-26): a tick and a snooze menu on the page's task
     * strip, "Mark done" on the bubbles that are a task's evidence. ⛔ ONLY FOR AN INDEX WITH THE NEW
     * FIELDS, and only where a service can take the change. One per frame; the old one is stopped so
     * a late answer cannot touch the next contact's page.
     */
    /**
     * ⭐ "REMOVE" ON A KEPT TABLE OR CHART (`AppPinFrame`, 2026-09-27): a button on each item of the page's Insights
     * "Kept from AI". ⛔ OWNER ONLY (the service refuses anyone else anyway) and only where a service can take it.
     */
    /** ⭐ (2026-10-14) E.164 -> this app's own `#c/...` address for every 1:1 chat in the index ("Open chat" on a contact card). */
    private CardLookup = (): Record<string, string> => {
        const Out: Record<string, string> = {};
        if (getCoreUtils().KErrorMode === true) { return Out; }
        try {
            const Base: string = window.location.href.split("#")[0];
            for (const C of this.Index.Contacts) {
                if (C.IsGroup === false && /^\+[0-9]{6,15}$/.test(C.PersonKey) && C.Href.length > 0) { Out[C.PersonKey] = Base + "#c/" + encodeURIComponent(C.Href); }
            }
            return Out;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.CardLookup");
            return Out;
        }
    };

    private AttachPins = (Frame: HTMLIFrameElement): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.IsOwner !== true || this.ServiceUrl.length === 0) { return; }
            new AppPinFrame(new AppPinFrameLink(this, this.NumberNow(), this.KeyNow()), this.OpenHref).Attach(Frame as unknown as IPfFrame);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.AttachPins");
        }
    };

    /**
     * ⭐ TRANSLATION ON THIS CONTACT VIEW: the chip on the `.back` line (shown only where `/translate` says it is
     * available), the flag / Copy / Retry / Send in English inside the frame, "Translate earlier messages". One-to-one
     * chats only, on the hosted page with a key. ⛔ The chip's listener only changes settings - never sends.
     */
    private AttachTranslate = (Frame: HTMLIFrameElement): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Translate.Translator.Who(this.ServiceUrl, this.NumberNow(), this.KeyNow());
            const Who: AppContact | null = this.Open;
            if (Who === null || (Who as AppContact).IsGroup === true || (Who as AppContact).ChatId.length === 0 || this.NewChat === true) { this.Translate.Close(); return; }
            this.Translate.Open(this.OpenHref, (Who as AppContact).Title, new AppTrDomScreen(), Frame as unknown as ITrFrame);
            // The quiet line under the header (the suggestion's Translate / Not now). ⚠ The chip itself only opens "Chat
            // settings" at Translation (`OnChatSettingsOpen`, one listener on the document).
            const Line: HTMLElement | null = document.getElementById(AppTranslateView.LineId);
            if (Line !== null) { Line.addEventListener("click", this.OnTranslateClick); }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.AttachTranslate");
        }
    };

    private OnTranslateClick = (Ev: Event): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Control: Element | null = AppEventTarget.Closest(Ev, "[" + AppTranslateView.ActAttr + "]", "AppMain.OnTranslateClick");
            if (Control === null) { return; }
            this.Translate.Act(nz(Control.getAttribute(AppTranslateView.ActAttr)));
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnTranslateClick");
        }
    };

    /**
     * `IAppTrPage.Resend` - ⛔ a failed translated bubble's Retry ("yes") or Send in English ("no"): the owner's click,
     * a NEW request through the composer's ONE sender and ONE latch (`AppComposer.SendText`).
     */
    public TranslateResend = (Text: string, Translate: boolean, Then: IAppTrResent): string => {
        if (getCoreUtils().KErrorMode === true) { return AppComposer.NoSendWhy(); }
        try {
            if (this.Compose === null) { return AppComposer.NoSendWhy(); }
            let Mode: string = "no";
            if (Translate === true) { Mode = "yes"; }
            return (this.Compose as AppComposer).SendText(Text, Then as IComposerSent, Mode);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.TranslateResend");
            return AppComposer.NoSendWhy();
        }
    };

    /** `IAppTrPage.Say` - the hint under the box. */
    // REUSE-JUSTIFIED: the body IS shared - `Said`. `TranslateSay`, `ReactSay` and `SendSay` are three INTERFACE members
    // (`IAppTrPage.Say`, the reaction host's and the send port's) that other classes call by those names; each is the
    // mandated guard + try/catch around `this.Said(...)` reporting under its own label. A field alias (`= this.Said`)
    // would depend on field initialiser order (the `AssistWarm.Shared` lesson) and drop the labels.
    public TranslateSay = (Text: string, Bad: boolean): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Said(Text, Bad);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.TranslateSay");
        }
    };

    /** `IAppTrPage.Tell` - the other tabs re-read this chat's translation settings. A notice only. */
    public TranslateTell = (Href: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.TellTabs("translate", Href, "", "", "", "", "", "");
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.TranslateTell");
        }
    };

    private AttachTasks = (Frame: HTMLIFrameElement): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.TaskFramer !== null) { (this.TaskFramer as AppTaskFrame).Stop(); }
            this.TaskFramer = null;
            if (AppTaskRules.Enabled(this.Index) === false || this.ServiceUrl.length === 0) { return; }
            const Made: AppTaskFrame = new AppTaskFrame(this.TaskActions, this.Index, this.OpenHref,
                new AppTaskFrameLink(this), AppMain.Coarse(), new AppWindowLater());
            Made.Decided = new AppTaskDecidedLink(this);
            Made.List.OnChanged(new AppPhoneTaskBadge(new AppPhoneChatTaskShow()));
            Made.Attach(Frame as unknown as ITfFrame);
            this.TaskFramer = Made;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.AttachTasks");
        }
    };

    /** `IRxHost.React` - an emoji was CLICKED. ⛔ The composer's own sender and latch (`SendReaction`). */
    public ReactVia(MessageId: string, Emoji: string, Then: IComposerSent): string {
        if (getCoreUtils().KErrorMode) { return AppComposer.NoSendWhy(); }
        try {
            const Composer = this.Compose;
            if (Composer === null) { return AppComposer.NoSendWhy(); }
            return Composer.SendReaction(MessageId, Emoji, Then);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain." + "ReactVia");
            return AppComposer.NoSendWhy();
        }
    }

    /** `IRxHost.Say` - the hint under the box. */
    // REUSE-JUSTIFIED: see `TranslateSay` - an interface member named for its caller, around the shared `Said`.
    public ReactSay = (Text: string, Bad: boolean): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Said(Text, Bad);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.ReactSay");
        }
    };

    /** (2026-10-14) The composer's mode bar, built once per composer and put just before the form. */
    private WireModeBar = (Form: HTMLElement): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.Compose === null || Form.parentNode === null) { return; }
            const Bar: AppMsgActionBar = new AppMsgActionBar(document as unknown as IMaDoc, new AppModeBarHost(this));
            (Form.parentNode as Node).insertBefore(Bar.Element() as unknown as Node, Form);
            (this.Compose as AppComposer).Bar = Bar;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.WireModeBar");
        }
    };

    /** `IRxHost.Act` / the mode bar's close: the composer's mode ("" = back to a new message). Sets a mode; sends nothing. */
    public ModeAct = (Kind: string, MessageId: string, Words: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.Compose === null) { return; }
            if (Kind.length === 0) { (this.Compose as AppComposer).ClearMode(); return; }
            if (Kind === "forward") { this.OpenForward(MessageId); return; }
            (this.Compose as AppComposer).SetMode(Kind, MessageId, Words);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.ModeAct");
        }
    };

    /** (2026-10-14) Where a picked forward goes, and the media the page read for it (null = a text forward). */
    private ForwardDest: AppForwardTarget | null = null;
    private ForwardMedia: { name: string; mime: string; data: string; voice: boolean } | null = null;

    // ── ⭐ ACTIONS ON A SEARCH HIT (2026-10-22, `AppSearchActions`, `IAppSearchActHost` via `AppSearchActHost`) ──
    // ⛔ DECISION 9: Reply / Forward / Help me reply OPEN things; only a face's click reaches `QueueReaction`.

    /** What a hit may offer now: send (service + key), the AI (owner), own tasks (tasks on), the pictures. */
    public SearchOpts = (): AppSearchActOpts => {
        const Out: AppSearchActOpts = new AppSearchActOpts();
        if (getCoreUtils().KErrorMode === true) { return Out; }
        try {
            const Keyed: boolean = this.ServiceUrl.length > 0 && this.KeyNow().length > 0;
            Out.CanSend = Keyed;
            Out.CanAi = Keyed && this.IsOwner === true;
            Out.CanTask = Keyed && AppTaskRules.Enabled(this.Index) === true;
            for (const C of this.Index.Contacts) { if (nz(C.Avatar).length > 0) { Out.Faces[C.Href] = C.Avatar; } }
            return Out;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.SearchOpts");
            return Out;
        }
    };

    /** The index row of a hit's chat (by href, else chat id), or null. */
    private SearchContact = (Hit: AppSearchHit): AppContact | null => {
        if (getCoreUtils().KErrorMode === true) { return null; }
        try {
            for (const C of this.Index.Contacts) { if (Hit.Chat.Href.length > 0 && C.Href === Hit.Chat.Href) { return C; } }
            for (const C of this.Index.Contacts) { if (Hit.Chat.ChatId.length > 0 && C.ChatId === Hit.Chat.ChatId) { return C; } }
            return null;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.SearchContact");
            return null;
        }
    };

    /** Reply / Forward: open the chat at the message; `Wire` sets the mode or opens the picker. ⛔ Sends nothing. */
    public SearchOpenFor = (Hit: AppSearchHit, Kind: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Who: AppContact | null = this.SearchContact(Hit);
            if (Who === null) { return; }
            this.PendingMsgKind = Kind;
            this.PendingMsgId = nz(Hit.Msg.MessageId);
            this.PendingMsgText = AppSearch.MatchedText(Hit);
            this.PendingMsgHref = Who.Href;
            this.GoTo(AppSearch.Link(Who.Href, Hit.Msg.Minute, Hit.Msg.OnPage, Hit.Msg.MessageId));
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.SearchOpenFor");
        }
    };

    /** Help me reply: the chat with the AI panel asked (`WireAssist` asks once). ⛔ Asking only. */
    public SearchAi = (Hit: AppSearchHit): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Who: AppContact | null = this.SearchContact(Hit);
            if (Who === null) { return; }
            this.PendingAsk = AppSearchActRules.AiAsk(Hit);
            this.AssistOpen = 1;
            this.GoTo(AppSearch.Link(Who.Href, Hit.Msg.Minute, Hit.Msg.OnPage, Hit.Msg.MessageId));
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.SearchAi");
        }
    };

    /** Move to a route (or repaint it when the address is already there). */
    private GoTo = (Link: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (Link.length === 0) { return; }
            if (window.location.hash === Link) { this.OnHash(); return; }
            window.location.hash = Link;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.GoTo");
        }
    };

    /** `Wire`: a hit's Reply sets the box's mode, its Forward opens the picker - once, only in the chat it was for. */
    private TakePendingMsg = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Kind: string = this.PendingMsgKind;
            const Href: string = this.PendingMsgHref;
            this.PendingMsgKind = ""; this.PendingMsgHref = "";
            if (Kind.length === 0 || Href !== this.OpenHref || this.Compose === null) { return; }
            if (Kind === AppSearchActRules.Forward) { this.OpenForward(this.PendingMsgId); return; }
            (this.Compose as AppComposer).SetMode(Kind, this.PendingMsgId, this.PendingMsgText);
            (this.Compose as AppComposer).Focus();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.TakePendingMsg");
        }
    };

    /** ⛔ A FACE WAS CLICKED: one reaction for the hit's chat, through `AppComposer.SendReaction` -> `QueueReaction`. */
    public SearchReact = (Hit: AppSearchHit, Emoji: string, Then: IComposerSent, Watch: IRxPending): string => {
        if (getCoreUtils().KErrorMode === true) { return AppComposer.NoSendWhy(); }
        try {
            const Who: AppContact | null = this.SearchContact(Hit);
            if (Who === null || Who.IsGroup === true) { return AppComposer.NoSendWhy(); }
            const Loose: AppComposer = new AppComposer(document.createElement("textarea") as unknown as IComposerBox,
                document.createElement("form") as unknown as IComposerForm, true, new AppSendToDoor(this, Who, Watch));
            return Loose.SendReaction(Hit.Msg.MessageId, Emoji, Then);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.SearchReact");
            return AppComposer.NoSendWhy();
        }
    };

    /** Remind me: an own task (`u-`) for the hit's contact, its label the message's words (`/tasks add`). */
    public SearchRemind = (Hit: AppSearchHit, Heard: IAppTaskHeard): string => {
        if (getCoreUtils().KErrorMode === true) { return AppTaskRules.LostWhy(); }
        try {
            const Who: AppContact | null = this.SearchContact(Hit);
            if (Who === null) { return AppTaskRules.LostWhy(); }
            const Add: AppTaskAdd = new AppTaskAdd();
            Add.Label = AppSearchActRules.RemindLabel(AppSearch.MatchedText(Hit));
            Add.Value = AppSearchActRules.RemindValue(Hit);
            Add.Owner = "me";
            return this.TaskActions.Send(Who.Href, "add", AppTaskBoard.NewUserId(), "", Add, new AppSearchTaskHeard(this, Heard));
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.SearchRemind");
            return AppTaskRules.LostWhy();
        }
    };

    /** A reminder landed: the service's row joins the index (the Tasks tab counts it). */
    public SearchTaskAdded = (Task: AppRow | null): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (Task !== null) { this.Index.Tasks.push(Task as AppRow); }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.SearchTaskAdded");
        }
    };

    /** The hits were drawn: their discs get the pictures the list already fetched. */
    public SearchPainted = (El: unknown): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (El !== null) { this.Faces().Fill(El as HTMLElement); }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.SearchPainted");
        }
    };

    /** A bubble's Forward: the picker over the owner's own 1:1 contacts. Sends nothing. */
    private OpenForward = (MessageId: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.Open === null) { return; }
            const All: AppForwardTarget[] = [];
            for (const C of this.Index.Contacts) {
                const T: AppForwardTarget = new AppForwardTarget();
                T.Href = C.Href; T.Title = C.Title; T.ChatId = C.ChatId;
                All.push(T);
            }
            new AppForwardPicker(document as unknown as IFwDoc, new AppForwardHost(this, MessageId), All, (this.Open as AppContact).ChatId).Open();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OpenForward");
        }
    };

    /**
     * ⛔ THE PICKER'S ONE CLICK: a held photo / voice note is read from the bubble's own blob first; then the composer's
     * `SendAction("forward")` - the ONE latch - and `QueueAction` builds the request for `Dest`.
     */
    public ForwardTo = (Dest: AppForwardTarget, MessageId: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.Compose === null) { return; }
            this.ForwardDest = Dest;
            this.ForwardMedia = null;
            const Url: string = this.ForwardMediaUrl(MessageId);
            if (Url.length === 0) { this.ForwardSend(MessageId); return; }
            new AppForwardRead(this, MessageId).Begin(Url);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.ForwardTo");
        }
    };

    /** The bubble's media the page holds (a `blob:` it filled), or "". */
    private ForwardMediaUrl = (MessageId: string): string => {
        if (getCoreUtils().KErrorMode === true || this.Appender === null) { return ""; }
        try {
            const Doc: Document | null = (this.Appender as AppChatAppend).Page() as unknown as Document | null;
            if (Doc === null || /^[A-Za-z0-9]{8,64}$/.test(MessageId) === false) { return ""; }
            const Media: Element | null = Doc.querySelector(".b[data-mid=\"" + MessageId + "\"] img[src^=\"blob:\"], .b[data-mid=\"" + MessageId + "\"] audio[src^=\"blob:\"]");
            if (Media === null) { return ""; }
            return nz(Media.getAttribute("src"));
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.ForwardMediaUrl");
            return "";
        }
    };

    /** The bubble's blob read (or not): send through the composer's latch. */
    public ForwardSend = (MessageId: string, Media: { name: string; mime: string; data: string; voice: boolean } | null = null): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.Compose === null) { return; }
            this.ForwardMedia = Media;
            const Why: string = (this.Compose as AppComposer).SendAction("forward", MessageId, "", new AppComposerModeSent(this.Compose as AppComposer));
            if (Why.length > 0) { this.Said(Why, true); }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.ForwardSend");
        }
    };

    /** The forward's request: an attachment (media the page read) or a schema-4 text forward the service resolves. */
    private ForwardRequest = (From: AppContact, MessageId: string, Why: string[]): AppSendRequest | null => {
        if (getCoreUtils().KErrorMode === true) { return null; }
        try {
            const Dest: AppForwardTarget | null = this.ForwardDest;
            const Media = this.ForwardMedia;
            this.ForwardDest = null;
            this.ForwardMedia = null;
            if (Dest === null) { Why.push("Choose who to forward it to."); return null; }
            if (Media !== null) { return AppOutbox.BuildAttachment(Dest.ChatId, Dest.Title, "", this.Source.Who(), Media, Why); }
            return AppOutbox.BuildAction(Dest.ChatId, Dest.Title, "forward", MessageId, "", this.Source.Who(), Why, From.ChatId);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.ForwardRequest");
            return null;
        }
    };

    /** The delete bar's "Delete" click - `AppComposer.ConfirmDelete`, the one way a delete leaves. */
    // REUSE-JUSTIFIED: `ReactVia` has the same two-line shape (no composer -> NoSendWhy, else forward) but calls a
    // different composer door with different arguments; a shared helper would take a callback and hide which door sends.
    public ModeDelete = (): string => {
        if (getCoreUtils().KErrorMode === true) { return AppComposer.NoSendWhy(); }
        try {
            if (this.Compose === null) { return AppComposer.NoSendWhy(); }
            return (this.Compose as AppComposer).ConfirmDelete();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.ModeDelete");
            return AppComposer.NoSendWhy();
        }
    };

    /**
     * `IComposerSender.QueueAction` - a reply / edit / delete, under the SAME ticket as a text or a reaction. The
     * request carries the kind and the message id; the service finds the key and writes schema 4.
     */
    public QueueAction = (Kind: string, MessageId: string, Text: string, Then: IComposerSent): string => {
        if (getCoreUtils().KErrorMode === true) { return AppComposer.NoSendWhy(); }
        const For: string = Kind;
        const Why: string[] = [];
        try {
            const Who: AppContact | null = this.Open;
            if (Who === null) { return AppComposer.NoSendWhy(); }
            const Ticket = this.SendTicket;
            if (Ticket !== null) { return AppComposer.BusyWhy(); }
            let Req: AppSendRequest | null = null;
            if (For === "forward") { Req = this.ForwardRequest(Who, MessageId, Why); }
            else { Req = AppOutbox.BuildAction(Who.ChatId, Who.Title, For, MessageId, Text, this.Source.Who(), Why); }
            if (Req === null) { return Why.join(" "); }
            const Reader: AppActQueue = new AppActQueue(this, For, Text, MessageId);
            return this.QueueBuilt(Req, Then, Reader.OnQueued, Reader.OnFailed);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.QueueAction");
            this.Busy(false);
            return AppComposer.NoSendWhy();
        }
    };

    /**
     * ⛔ THE SHARED WRITE of a reaction / reply / edit / delete / forward request: the page-wide `SendTicket` taken, busy
     * shown, the ONE `Source.Queue`. Only after each caller built its own request (their checks differ).
     */
    private QueueBuilt = (Req: AppSendRequest, Then: IComposerSent, OnQueued: (Id: string) => void,
                          OnFailed: (Why: string) => void): string => {
        if (getCoreUtils().KErrorMode === true) { return AppComposer.NoSendWhy(); }
        try {
            this.SendTicket = Then;
            this.Busy(true);
            this.Source.Queue(AppOutbox.FileName(Req), AppOutbox.Json(Req), OnQueued, OnFailed);
            return "";
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.QueueBuilt");
            this.Busy(false);
            return AppComposer.NoSendWhy();
        }
    };

    /** `/send` took the action: the latch goes, and the line says it is on its way (the live feed shows the result). */
    public OnActQueued = (RequestId: string, Kind: string = "", Text: string = "", MessageId: string = ""): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Busy(false);
            // (2026-10-20) A REPLY IS DRAWN AT ONCE, with its quote; WhatsApp's echo adopts it (`AdoptSent`).
            if (Kind === "reply" && this.Appender !== null && nz(RequestId).length > 0) {
                const Word: AppChatWord = new AppChatWord();
                Word.Text = AppChatRules.Waiting;
                if (this.Source.CanCheck() === true) { Word.Text = AppChatRules.Sending; }
                (this.Appender as AppChatAppend).AddReply(RequestId, Text, new Date().toISOString(), Word, MessageId);
            }
            const Then: IComposerSent | null = this.TakeTicket();
            if (Then !== null) { (Then as IComposerSent).Queued(); }
            this.Said(AppMsgActionRules.QueuedWords, false);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnActQueued");
        }
    };

    /** `/send` refused it: the sentence under the box; the mode and the words stay. */
    public OnActFailed = (Why: string): void => {
        const Broken: boolean = getCoreUtils().KErrorMode;
        if (Broken) { return; }
        try {
            this.Busy(false);
            const Then = this.TakeTicket();
            if (Then === null) { this.Said(nz(Why), true); return; }
            Then.Failed(Why);
            this.Said(nz(Why), true);
        } catch (e) {
            const Where: string = "AppMain." + "OnActFailed";
            getCoreUtils().KGlobalErrorHandler(e, Where);
        }
    };

    /**
     * `IComposerSender.QueueReaction` - the page half of a reaction, beside `QueueText` and under the
     * SAME ticket: a reaction and a text are never written at once. ⚠ The request carries the message
     * id and the emoji only; the service finds the key (`ReactTarget`).
     */
    public QueueReaction = (MessageId: string, Emoji: string, Then: IComposerSent, For: AppContact | null = null,
                            Watch: IRxPending | null = null): string => {
        if (getCoreUtils().KErrorMode === true) { return AppComposer.NoSendWhy(); }
        try {
            let Who: AppContact | null = this.Open;
            if (For !== null) { Who = For; }
            if (Who === null) { return AppComposer.NoSendWhy(); }
            if (this.SendTicket !== null) { return AppComposer.BusyWhy(); }
            const Why: string[] = [];
            const Req: AppSendRequest | null = AppOutbox.BuildReaction(Who.ChatId, Who.Title, MessageId, Emoji,
                this.Source.Who(), Why);
            if (Req === null) { return Why.join(" "); }
            const Reader: AppReactQueue = new AppReactQueue(this, MessageId, Watch);
            return this.QueueBuilt(Req, Then, Reader.OnQueued, Reader.OnFailed);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.QueueReaction");
            this.Busy(false);
            return AppComposer.NoSendWhy();
        }
    };

    /** `/send` took the reaction: whoever tapped hears it once, and its receipt is watched. */
    public OnReactQueued = (MessageId: string, RequestId: string, Watch: IRxPending | null = null): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Busy(false);
            const Then: IComposerSent | null = this.TakeTicket();
            if (Then !== null) { (Then as IComposerSent).Queued(); }
            // ⭐ A SEARCH HIT'S REACTION: its own line hears the receipt (`AppSearchReactWatch`), not the chat's pill.
            if (Watch !== null) { new AppReactPoll(this.Source, Watch as IRxPending, MessageId, RequestId, new AppWindowLater()).Start(); return; }
            if (this.Reactor === null) { return; }
            new AppReactPoll(this.Source, this.Reactor as AppReactions, MessageId, RequestId, new AppWindowLater()).Start();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnReactQueued");
        }
    };

    /** `/send` refused it: the tap's listener puts the pill back and says why (`AppReactSend.Failed`). */
    public OnReactFailed(Why: string): void {
        if (getCoreUtils().KErrorMode) { return; }
        const Text = Why;
        try {
            this.Busy(false);
            const Then = this.TakeTicket() as IComposerSent | null;
            if (Then === null) { return; }
            Then.Failed(Text);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain." + "OnReactFailed");
        }
    }

    /** The request was accepted: draw it in the conversation now, marked "Sending…". */
    private AppendSent = (Answered: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.Appender === null) { return; }
            let Id: string = this.SendingId;
            const Word: AppChatWord = new AppChatWord();
            Word.Text = AppChatRules.Waiting;
            // ⚠ THE ID THE POLL WATCHES: the service's answer where it can be asked, else our own.
            if (this.Source.CanCheck() === true) { Word.Text = AppChatRules.Sending; }
            if (this.Source.CanCheck() === true && nz(Answered).length > 0) { Id = nz(Answered); }
            // ⭐ TRANSLATING: the service translates before it sends - the bubble says so until `/live` says "sending".
            let Progress: string = "";
            if (this.Source.CanCheck() === true && this.SendingTranslate === true) { Word.Text = AppSendPush.TranslatingWord; Progress = AppSendPush.Translating; }
            (this.Appender as AppChatAppend).Add(Id, this.SendingText, new Date().toISOString(), Word);
            // ⭐ SEND AT ONCE: the open chat's feed asks again NOW, naming this send - its verdict comes back pushed.
            if (this.Source.CanCheck() === true) {
                AppSendPush.Shared.Watch(Id, Progress);
                if (this.Live !== null) { (this.Live as AppLiveFeed).AskAgain(); }
            }
            this.SendingTranslate = false;
            this.SendingText = "";
            this.SendingId = "";
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.AppendSent");
        }
    };

    // ── Sending ──────────────────────────────────────────────────────────────────────────────

    /**
     * The composer bar at the foot of the chat card. ⭐ NOTHING ABOVE IT (owner, 2026-09-26: "There are now
     * two ai areas - combine the bottom one into the right one"): the AI chips and the task-close card are
     * in the AI panel (`AssistMarkup`); the bar keeps only the ✦ button that opens it.
     *
     * ⚠ IT IS THE "UI-ORIGINATED HUMAN APPROVAL" IN DECISION 9, and every word of it is chosen so
     * the owner is not misled about what pressing the button does. It does NOT send. It writes a
     * request the bridge will read, check and act on - and if the bridge is not running, nothing
     * happens until it is. A button labelled "Send" that quietly means "maybe, later" is the only
     * way this feature could hurt someone, so the hint in the bar says so in plain words.
     *
     * ⚠ THE "SENT." LINE UNDER THE BOX IS GONE (2026-09-25): a message's fate is on its own bubble
     * (`AppChatAppend`). The hint (`wac-said`) keeps only what has no bubble to live on - a refusal
     * before sending, a request that could not be written, and the sentences that tell the owner
     * NOT to send again.
     *
     * ⚠ IT IS NOT RENDERED WHEN THERE IS NOTHING TO SEND TO. A contact whose row carries no chat id
     * gets an explanation instead of a dead box - the index is rebuilt by the generator, so this is
     * a real state on any folder built before `chatId` was written into it.
     */
    private Composer = (): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            const Who: AppContact | null = this.Open;
            if (Who === null) { return ""; }
            let Spark: string = "";
            if (this.AssistOn() === true) { Spark = AppAssistView.OpenButton(); }
            if (AppOutbox.IsJid(Who.ChatId) === false) { return AppComposerView.Off(Spark); }
            // ⚠ THE SOURCE SAYS WHO SENDS - never an internal name or a command the subscriber
            // cannot run (`AppDropboxSource.SendNote`).
            // ⚠ THE PLACEHOLDER NEVER SHOWS A RAW ID ("Message lid:…") - `AppAssistRules.Placeholder`.
            return AppComposerView.Bar(Spark, AppAssistRules.Placeholder(Who.Title), this.Source.SendNote());
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.Composer");
            return "";
        }
    };

    private Wire = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Compose = null;
            this.Attachments = null;
            const Form: HTMLElement | null = document.getElementById("wac-say");
            const Box: HTMLElement | null = document.getElementById("wac-text");
            if (Form === null || Box === null) { return; }
            Form.addEventListener("submit", this.OnSend);
            this.Compose = new AppComposer(Box as unknown as IComposerBox, Form as unknown as IComposerForm,
                AppMain.Coarse(), new AppSendDoor(this));
            (this.Compose as AppComposer).Wire();
            // (2026-10-14) Reply / Edit / Delete: the mode bar above the form (`AppMsgActionBar`).
            this.WireModeBar(Form);
            const File: HTMLInputElement | null = document.getElementById("wac-attachment") as HTMLInputElement | null;
            const Voice: HTMLInputElement | null = document.getElementById("wac-voice") as HTMLInputElement | null;
            if (File !== null && Voice !== null) { this.Attachments = new AppAttachmentComposer(this, File, Voice); }
            // ⚠ A "LET <NAME> KNOW?" CARD'S EDIT OPENED THIS CHAT: its draft goes into the box - and only
            // into the box; the owner presses Send. Taken once, and only by the chat it was meant for.
            const Fill: string = this.PendingFill;
            const FillHref: string = this.PendingFillHref;
            this.PendingFill = "";
            this.PendingFillHref = "";
            if (Fill.length > 0 && FillHref === this.OpenHref) { (this.Compose as AppComposer).Fill(Fill); }
            this.TakePendingMsg();
            // ⭐ A REPLY-OWED TASK ROW OPENED THIS CHAT: the box is focused, ready to type. Only the box.
            const FocusHref: string = this.PendingFocusHref;
            this.PendingFocusHref = "";
            if (this.ReplyFocus !== null) { this.ReplyFocus.Release(); this.ReplyFocus = null; }
            if (Fill.length === 0 && FocusHref.length > 0 && FocusHref === this.OpenHref) {
                (this.Compose as AppComposer).Focus();
                // ⛔ AND IT KEEPS IT while the conversation loads: the frame opens AT the message (`#m-...`) and the browser
                // would hand the focus to that bubble (`AppReplyFocus` - measured, about 1 open in 10).
                this.ReplyFocus = new AppReplyFocus(Box as unknown as IReplyFocusBox, document as unknown as IReplyFocusTarget, new AppLiveWindowClock());
            }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.Wire");
        }
    };

    /** A touch screen - where Enter in a message box is a new line, never a send. */
    private static Coarse = (): boolean => {
        return AppMediaQuery.IsCoarse("AppMain.Coarse");
    };

    // ── Ask AI about this chat ───────────────────────────────────────────────────────────────

    /**
     * Whether this copy can ask `/assist` at all: the hosted page, which knows its service. A copy
     * reading the folder beside itself (`npm run serve`) has no service and shows no AI help.
     */
    private AssistOn = (): boolean => {
        if (getCoreUtils().KErrorMode === true) { return false; }
        try {
            return this.ServiceUrl.length > 0 && this.Open !== null && this.NewChat === false;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.AssistOn");
            return false;
        }
    };

    /**
     * ⭐ "Export chat (CSV)" (owner-approved #8): the hosted page with a key, on a one-to-one chat. Every
     * subscriber - it is their own data (`/export` proves the `browser` key). See `AppExport`.
     */
    private ExportOn = (): boolean => {
        if (getCoreUtils().KErrorMode === true) { return false; }
        try {
            if (this.ServiceUrl.length === 0 || this.Open === null || this.KeyNow().length === 0 || this.NewChat === true) { return false; }
            return (this.Open as AppContact).IsGroup === false;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.ExportOn");
            return false;
        }
    };

    /** Who is asking, read at CLICK time (`AppExportAsk`). */
    private ExportWho = (): AppExportWho => {
        const Out: AppExportWho = new AppExportWho();
        if (getCoreUtils().KErrorMode === true) { return Out; }
        try {
            Out.ServiceUrl = this.ServiceUrl;
            Out.Phone = this.NumberNow();
            Out.Key = this.KeyNow();
            Out.Page = this.OpenHref;
            if (this.Open !== null) { Out.Title = (this.Open as AppContact).Title; }
            return Out;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.ExportWho");
            return Out;
        }
    };

    /**
     * Is "Chat settings" offered for this chat? On the hosted page with a key, for a chat the service can be asked
     * about: a one-to-one chat (a provisional page too) or a group it keeps a star for.
     */
    private ChatSettingsOn = (Who: AppContact | null): boolean => {
        if (getCoreUtils().KErrorMode === true) { return false; }
        try {
            if (this.ServiceUrl.length === 0 || Who === null || this.KeyNow().length === 0) { return false; }
            if (Who.IsGroup === true) { return AppChatListRules.IdOk(Who.ChatId) === true; }
            return AppLiveRules.ChatIdOk(Who.ChatId) === true;
        } catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppMain.ChatSettingsOn"); return false; }
    };

    private ArchiveWho = (): AppChatArchiveWho => {
        const Out: AppChatArchiveWho = new AppChatArchiveWho();
        if (getCoreUtils().KErrorMode === true) { return Out; }
        try {
            Out.ServiceUrl = this.ServiceUrl; Out.Number = this.NumberNow(); Out.Key = this.KeyNow();
            if (this.Open !== null) { Out.ChatId = this.Open.ChatId; }
            return Out;
        } catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppMain.ArchiveWho"); return Out; }
    };

    private ChatListBook = (): AppChatListRead => {
        if (getCoreUtils().KErrorMode === true) { return new AppChatListRead(this.ArchiveWho, this.DrawNativeChatViews); }
        try {
            if (this.NativeChatList === null) { this.NativeChatList = new AppChatListRead(this.ArchiveWho, this.DrawNativeChatViews); }
            return this.NativeChatList;
        } catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppMain.ChatListBook"); return new AppChatListRead(this.ArchiveWho, this.DrawNativeChatViews); }
    };

    /** The native chat view (Starred / Archived) that narrows the list now, or null when the list shows every chat. */
    private NativeViewOn = (): AppChatListRead | null => {
        if (getCoreUtils().KErrorMode === true) { return null; }
        try {
            if (this.IsOwner !== true || this.NativeChatList === null || this.NativeChatList.View === "all") { return null; }
            if (this.NativeChatList.ScopeMatches() === false) { return null; }
            return this.NativeChatList;
        } catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppMain.NativeViewOn"); return null; }
    };

    private IncludeNativeChat = (One: AppContact): boolean => {
        if (getCoreUtils().KErrorMode === true) { return false; }
        try {
            const View: AppChatListRead | null = this.NativeViewOn();
            if (View === null) { return true; }
            return View.Ids.has(One.ChatId);
        } catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppMain.IncludeNativeChat"); return false; }
    };

    private ChatRows = (Current: string = ""): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            const View: AppChatListRead | null = this.NativeViewOn();
            if (View === null) {
                return AppViews.Results(this.Index, this.Filter, Current);
            }
            if (View.Ready === false) {
                if (View.Loading === true) { return "<p class=\"none\">Checking this chat view…</p>"; }
                return "<p class=\"none\">This view is unavailable. All still shows your saved chats.</p>";
            }
            return AppViews.Results(this.Index, this.Filter, Current, this.IncludeNativeChat);
        } catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppMain.ChatRows"); return ""; }
    };

    private AttachNativeChatViews = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            // ⭐ The All / Starred / Archived switch goes right above the chat list.
            const Toggle: HTMLElement | null = document.getElementById(AppViews.ListId);
            const Offered: boolean = this.IsOwner === true && this.ServiceUrl.length > 0 && this.KeyNow().length > 0 && Toggle !== null;
            if (Offered === false) { if (this.NativeChatList !== null) { this.NativeChatList.Visible(false); } return; }
            const Book: AppChatListRead = this.ChatListBook();
            if (document.getElementById(AppChatListRules.Id) === null) {
                (Toggle as HTMLElement).insertAdjacentHTML("beforebegin", AppChatListRules.Switch(Book.View));
            }
            Book.Visible(document.visibilityState === "visible"); this.DrawNativeChatViews();
        } catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppMain.AttachNativeChatViews"); }
    };

    private OnNativeChatView = (Ev: Event): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Target: Element | null = AppEventTarget.Closest(Ev, "[" + AppChatListRules.Attr + "]", "AppMain.OnNativeChatView");
            if (Target === null || this.IsOwner !== true || document.getElementById(AppViews.ListId) === null) { return; }
            const View: string = nz(Target.getAttribute(AppChatListRules.Attr));
            this.ChatListBook().Load(View);
        } catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnNativeChatView"); }
    };

    private OnQuickChat = (Ev: Event): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Button: Element | null = AppEventTarget.Closest(Ev, "[" + AppChatQuickView.Attr + "]", "AppMain.OnQuickChat");
            if (Button === null) { return; }
            Ev.preventDefault();
            const Id: string = nz(Button.getAttribute(AppChatQuickView.Attr));
            for (const One of this.Index.Contacts) {
                if (One.ChatId !== Id) { continue; }
                this.OpenChatSettings(One, "", Button as HTMLElement, true);
                return;
            }
        } catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnQuickChat"); }
    };

    /**
     * ⭐ "CHAT SETTINGS" FOR THE OPEN CHAT: the header's "⋯" item, or its translation chip (which lands on Translation).
     * One listener on the document (`AppChatSettingsView.OpenAttr`) - the header is repainted with `innerHTML`.
     * The "⋯" menu is shut first and gets the keyboard back when the dialog closes; the chip gets it back itself.
     */
    private OnChatSettingsOpen = (Ev: Event): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Control: Element | null = AppEventTarget.Closest(Ev, "[" + AppChatSettingsView.OpenAttr + "]", "AppMain.OnChatSettingsOpen");
            if (Control === null || this.Open === null || document.getElementById(AppChatHead.Id) === null) { return; }
            Ev.preventDefault();
            let Opener: HTMLElement = Control as HTMLElement;
            const More: HTMLElement | null = document.querySelector("[" + AppMenuRules.Attr + "=\"" + AppChatHead.MenuId + "\"]");
            if (More !== null && Control.closest("[id=\"" + AppChatHead.MenuId + "\"]") !== null) {
                new AppMenus(document as unknown as IMenuDoc).Close(More as unknown as IMenuEl, false);
                Opener = More;
            }
            this.OpenChatSettings(this.Open, nz(Control.getAttribute(AppChatSettingsView.OpenAttr)), Opener, false);
        } catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnChatSettingsOpen"); }
    };

    private OpenChatSettings = (Who: AppContact, Section: string, Opener: HTMLElement | null, FromList: boolean): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.ChatSettingsOn(Who) === false) { return; }
            if (this.ChatSettingsBox === null) { this.ChatSettingsBox = new AppChatSettingsDialog(new AppChatSettingsLink(this)); }
            this.ChatSettingsHash = window.location.hash;
            this.ChatSettingsFromList = FromList;
            this.ChatSettingsBox.Open(Who, Section, Opener);
        } catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppMain.OpenChatSettings"); }
    };

    /** `IAppChatSettingsHost.Who`: fresh credentials for a chat that is still in the index (or is the open, new chat). */
    public ChatSettingsWho = (Selected: AppContact): AppChatArchiveWho => {
        const Out: AppChatArchiveWho = new AppChatArchiveWho();
        if (getCoreUtils().KErrorMode === true) { return Out; }
        try {
            if (this.ChatSettingsOn(Selected) === false) { return Out; }
            Out.ServiceUrl = this.ServiceUrl; Out.Number = this.NumberNow(); Out.Key = this.KeyNow(); Out.ChatId = Selected.ChatId;
            return Out;
        } catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppMain.ChatSettingsWho"); return Out; }
    };

    /**
     * `IAppChatSettingsHost.TranslatorFor`: the visit's translator for a one-to-one chat that has a saved page (the
     * service resolves translation by the page), on the hosted page with a key; else null - the dialog then has no
     * Translation section at all.
     */
    public ChatSettingsTranslator = (Selected: AppContact): AppTranslator | null => {
        if (getCoreUtils().KErrorMode === true) { return null; }
        try {
            if (Selected.IsGroup === true || Selected.IsNew === true || Selected.ChatId.length === 0 || Selected.Href.length === 0) { return null; }
            if (this.Open !== null && this.Open.ChatId === Selected.ChatId && this.NewChat === true) { return null; }
            this.Translate.Translator.Who(this.ServiceUrl, this.NumberNow(), this.KeyNow());
            if (this.Translate.Translator.CanAsk() === false) { return null; }
            return this.Translate.Translator;
        } catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppMain.ChatSettingsTranslator"); return null; }
    };

    /** `IAppChatSettingsHost.TranslationChanged`: the header's chip follows, the other tabs are told, a switch-on backfills. */
    public ChatSettingsTranslated = (Href: string, TurnedOn: boolean): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Translate.SavedElsewhere(Href, TurnedOn);
        } catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppMain.ChatSettingsTranslated"); }
    };

    /**
     * `IAppChatSettingsHost.Opener`: where the keyboard returns when what opened the dialog was repainted meanwhile -
     * the chat's "⋯" in the list, else the open chat's "⋯".
     */
    public ChatSettingsOpener = (Selected: AppContact): HTMLElement | null => {
        if (getCoreUtils().KErrorMode === true) { return null; }
        try {
            const Rows: NodeListOf<HTMLElement> = document.querySelectorAll("[" + AppChatQuickView.Attr + "]");
            for (let At: number = 0; At < Rows.length; At = At + 1) {
                if (Rows[At].getAttribute(AppChatQuickView.Attr) === Selected.ChatId && this.ChatSettingsFromList === true) { return Rows[At]; }
            }
            if (this.Open !== null && this.Open.ChatId === Selected.ChatId) {
                return document.querySelector("[" + AppMenuRules.Attr + "=\"" + AppChatHead.MenuId + "\"]");
            }
            return null;
        } catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppMain.ChatSettingsOpener"); return null; }
    };

    /** ⭐ "New chat": the form (`AppNewChatRules.Html`) and its one submit listener. ⛔ Nothing here sends a message. */
    private ShowNewChatForm = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Shell(true);
            this.Open = null; this.NewChat = false;
            this.PaintView(AppNewChatRules.Html(this.NcTyped, this.NcSay, this.NcBusy) + this.CenterTabs("chats"), "");
            const Form: HTMLElement | null = document.getElementById(AppNewChatRules.FormId);
            if (Form !== null) { Form.addEventListener("submit", this.OnNewChatSubmit); }
            const Box: HTMLElement | null = document.getElementById(AppNewChatRules.InputId);
            if (Box !== null) { Box.focus(); }
        } catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppMain.ShowNewChatForm"); }
    };
    private OnNewChatSubmit = (Ev: Event): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            Ev.preventDefault();
            if (this.NcBusy === true) { return; }
            const Box: HTMLInputElement | null = document.getElementById(AppNewChatRules.InputId) as HTMLInputElement | null;
            if (Box !== null) { this.NcTyped = Box.value; }
            const Chat: string = AppNewChatRules.ChatIdOf(this.NcTyped);
            const Url: string = AppSignUpApi.UrlFor(this.ServiceUrl, "/chat/settings");
            if (Chat.length === 0) { this.NcSay = AppNewChatRules.NumberWhy; this.ShowNewChatForm(); return; }
            if (Url.length === 0 || this.KeyNow().length === 0) { this.NcSay = AppMain.NotSignedInWhy(); this.ShowNewChatForm(); return; }
            this.NcBusy = true; this.NcSay = AppNewChatRules.CheckingWords; this.ShowNewChatForm();
            new AppAccountPost(Url, AppNewChatRules.Body(this.NumberNow(), this.KeyNow(), Chat), this.OnNewChatChecked).Send();
        } catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnNewChatSubmit"); }
    };
    private OnNewChatChecked = (Status: number, Text: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.NcBusy = false;
            const Got: AppNewChatAnswer = AppNewChatRules.Parse(Status, Text);
            const Here: boolean = window.location.hash === "#" + AppNewChatRules.Route;
            if (Got.Ok === true) {
                this.NcSay = ""; this.NcTyped = "";
                AppNewChatRules.Started.add(Got.ChatId);
                if (Here === true) { window.location.hash = "#" + AppViews.NewRoute + "/" + encodeURIComponent(Got.ChatId); }
                return;
            }
            this.NcSay = Got.Why;
            if (Here === true) { this.ShowNewChatForm(); }
        } catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnNewChatChecked"); }
    };

    /** ⭐ The phone's marks (`AppChatMarks`): read with the index and every 30 s while visible; each answer put on the rows. */
    private StartMarks = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.ServiceUrl.length === 0 || this.KeyNow().length === 0) { return; }
            if (this.PhoneMarks === null) { this.PhoneMarks = new AppChatMarks(this.ArchiveWho, this.OnPhoneMarks); }
            if (this.PhoneMarks.Marks.size > 0) { AppChatMarksRules.Apply(this.Index.Contacts, this.PhoneMarks.Marks); }
            if (document.visibilityState !== "hidden") { this.PhoneMarks.Load(); }
        } catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppMain.StartMarks"); }
    };
    private OnPhoneMarks = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.PhoneMarks === null || this.Index.Loaded === false) { return; }
            if (document.visibilityState === "hidden") { this.PhoneMarks.Stop(); }
            if (AppChatMarksRules.Apply(this.Index.Contacts, this.PhoneMarks.Marks) === false) { return; }
            if (this.Open !== null) { const Mark = this.PhoneMarks.Marks.get(this.Open.ChatId); this.Open.Blocked = Mark !== undefined && Mark.Blocked === true; }
            this.RepaintCards(false); this.RefreshHeadProps();
        } catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnPhoneMarks"); }
    };

    public ChatSettingConfirmed = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.PhoneMarks !== null) { this.PhoneMarks.Load(); }
            if (this.NativeChatList !== null && this.NativeChatList.View !== "all" && document.getElementById(AppViews.ListId) !== null) {
                this.NativeChatList.Load(this.NativeChatList.View, true);
            }
        } catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppMain.ChatSettingConfirmed"); }
    };

    private DrawNativeChatViews = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.NativeChatList === null) { return; }
            const List: HTMLElement | null = document.getElementById(AppViews.ListId);
            if (List === null) { return; }
            const Mark: AppFocusMark = AppFocusKeep.Before(document, List as unknown as IFocusEl);
            let Current: string = "";
            if (this.Open !== null && document.getElementById("wac-frame") !== null) { Current = this.Open.ChatId; }
            List.innerHTML = this.ChatRows(Current); this.Faces().Fill(List);
            AppFocusKeep.After(List as unknown as IFocusEl, Mark);
            const Buttons: NodeListOf<HTMLElement> = document.querySelectorAll("[" + AppChatListRules.Attr + "]");
            for (let At: number = 0; At < Buttons.length; At++) { Buttons[At].setAttribute("aria-pressed", String(Buttons[At].getAttribute(AppChatListRules.Attr) === this.NativeChatList.View)); }
            const Note: HTMLElement | null = document.getElementById(AppChatListRules.NoteId);
            if (Note !== null) { Note.textContent = this.NativeChatList.Note; Note.hidden = this.NativeChatList.Note.length === 0; }
            const Found: HTMLElement | null = document.getElementById(AppViews.FoundId);
            if (Found !== null) { Found.textContent = AppViews.FoundText(this.Index, this.Filter, this.IncludeNativeChat); }
        } catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppMain.DrawNativeChatViews"); }
    };

    private AssistMarkup = (): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            if (this.AssistOn() === false) { return ""; }
            // ⭐ ONE AI AREA: the chips and the "let <name> know?" region are the panel's (owner, 2026-09-26).
            // ⭐ THE CONTACT'S FACE beside "Ask about <name>" - laid on by `Frame` with the list's loader.
            const Open: AppContact = this.Open as AppContact;
            return AppAssistView.Panel(Open.Title, this.ChipList(), this.NotesMarkup(), AppAvatarRules.Disc(Open.Title, Open.Avatar));
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.AssistMarkup");
            return "";
        }
    };

    /**
     * Build the panel over this contact's conversation and wire every control.
     * ⚠ OPEN BY DEFAULT ON A WIDE SCREEN, SHUT ON A PHONE - decided once per visit, then the owner's
     * last choice holds from contact to contact.
     */
    private WireAssist = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Assist = null;
            // ⚠ "REPLY ABOUT THIS TASK" IS ASKED ONCE, on this paint or never - a question left over
            // would be asked again on the next contact the owner opens.
            const Pending: string = this.PendingAsk;
            this.PendingAsk = "";
            const Log: HTMLElement | null = document.getElementById(AppAssistView.LogId);
            if (this.AssistOn() === false || Log === null) { return; }
            // ⭐ ALWAYS VISIBLE ON A DESKTOP: open on the first contact unless this browser's owner closed it
            // (`AppAiPanelStore`); a phone starts shut, and its ✦ button shows the saved count instead.
            if (this.AssistOpen < 0) {
                this.AssistOpen = 0;
                if (AppAssistRules.OpenAtStart(AppMain.Wide(), AppAiPanelStore.Read()) === true) { this.AssistOpen = 1; }
            }
            const Title: string = (this.Open as AppContact).Title;
            if (Object.prototype.hasOwnProperty.call(this.Assists, this.OpenHref) === false) {
                this.Assists[this.OpenHref] = new AppAssistSession();
            }
            const Who: AppAssistWho = new AppAssistWho();
            Who.Phone = this.NumberNow();
            Who.Key = this.KeyNow();
            Who.Page = this.OpenHref;
            this.Assist = new AppAssistPanel(document as unknown as IAssistDoc, Log as unknown as IAssistNode,
                new AppAssistHost(this, this.OpenHref), this.Assists[this.OpenHref], Who, Title,
                // ⛔ The browser half (clipboard, download, the log's listeners) is made HERE, never imported by
                // the panel - the Bridge compiles the panel with no DOM lib. One listener set per log element.
                new AppAssistTools());
            // ⭐ "Remove from history" (`AppAssistForget`) - the owner's browser only; the service refuses everyone else.
            (this.Assist as AppAssistPanel).CanForget = this.IsOwner === true;
            (this.Assist as AppAssistPanel).Render();
            this.WireAssistControls();
            this.ShowAssist();
            // ⭐ THE SAVED HISTORY, READ ON EVERY OPEN - only in the OWNER's browser (AI help is owner-only,
            // and only the owner's history is ever written).
            if (this.IsOwner === true) { (this.Assist as AppAssistPanel).LoadHistory(); }
            // ⭐ A CONTACT OPENED: a warm-up naming it, so its history is read ahead (`AppAssistWarm`).
            this.WarmAssist(this.OpenHref);
            this.ShowCount();
            // ⛔ ASKS THE AI; NEVER SENDS. The answer's draft card has its own Send button.
            if (Pending.length > 0) { (this.Assist as AppAssistPanel).Ask(Pending); }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.WireAssist");
        }
    };

    private WireAssistControls = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            AppEventTarget.OnClick(AppAssistView.RootId, this.OnAssistClick, "AppMain.On");
            AppEventTarget.OnClick(AppAssistView.ChipsId, this.OnChipClick, "AppMain.On");
            AppEventTarget.OnClick(AppAssistView.OpenId, this.OnAssistToggle, "AppMain.On");
            AppEventTarget.OnClick(AppAssistView.CloseId, this.OnAssistClose, "AppMain.On");
            AppEventTarget.OnClick(AppAssistView.ScrimId, this.OnAssistClose, "AppMain.On");
            // ⚠ THE SAME GROW-AND-ENTER BEHAVIOUR AS THE MESSAGE BOX - here Enter asks, never sends:
            // ⛔ this box has NO sender (null) (`AppAskForm.Wire`), so it cannot reach `/send` even by mistake.
            AppAskForm.Wire(AppAssistView.AskFormId, AppAssistView.AskBoxId, this.OnAssistAsk, AppMain.Coarse(), "AppMain.WireAssistControls");
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.WireAssistControls");
        }
    };

    /** Where the panel is a column (open by default) rather than a sheet. */
    private static Wide = (): boolean => {
        if (getCoreUtils().KErrorMode === true) { return false; }
        try {
            return AppMediaQuery.Matches(AppMain.AssistWideQuery);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.Wide");
            return false;
        }
    };

    private ShowAssist = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Card: HTMLElement | null = document.getElementById("wac-contact");
            if (Card === null) { return; }
            let Cls: string = "contact";
            if (this.AssistOpen === 1) { Cls = "contact ai-on"; }
            Card.className = Cls;
            const Button: HTMLElement | null = document.getElementById(AppAssistView.OpenId);
            if (Button !== null) { Button.setAttribute("aria-expanded", String(this.AssistOpen === 1)); }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.ShowAssist");
        }
    };

    private OnAssistToggle = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.AssistOpen = 1 - Math.max(0, this.AssistOpen);
            this.Remember();
            this.ShowAssist();
            if (this.AssistOpen === 1) { AppMain.FocusAsk(); this.WarmAssist(this.OpenHref); }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnAssistToggle");
        }
    };

    private OnAssistClose = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            // ⭐ THE FOCUS GOES BACK TO THE BUTTON THAT OPENS THE PANEL (audit 2026-10-01): closing hid the element that
            // had it (the ask box, the × itself), so the keyboard fell to the top of the page.
            const Had: boolean = AppFocus.Inside(document, AppAssistView.RootId);
            this.AssistOpen = 0;
            this.Remember();
            this.ShowAssist();
            if (Had === true) { AppFocus.To(document, AppAssistView.OpenId); }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnAssistClose");
        }
    };

    /**
     * ⭐ THE OWNER'S OWN OPEN/CLOSE ON A DESKTOP IS REMEMBERED PER BROWSER (× closes it for good; ✦ opens it
     * again). ⚠ Only there: on a phone the sheet always starts shut, so its choice is not a preference.
     */
    private Remember = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (AppMain.Wide() === false) { return; }
            let Value: string = AppAssistRules.PanelOpen;
            if (this.AssistOpen !== 1) { Value = AppAssistRules.PanelClosed; }
            AppAiPanelStore.Write(Value);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.Remember");
        }
    };

    /** The ✦ button's count - how many saved questions this contact has (drawn on a phone by `app.css`). */
    private ShowCount = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Button: HTMLElement | null = document.getElementById(AppAssistView.OpenId);
            if (Button === null || this.Assist === null) { return; }
            const Count: number = AppAssistRules.SavedCount((this.Assist as AppAssistPanel).Session);
            if (Count <= 0) { Button.removeAttribute("data-count"); return; }
            let Label: string = String(Count);
            if (Count > 99) { Label = "99+"; }
            Button.setAttribute("data-count", Label);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.ShowCount");
        }
    };

    /** ⚠ Not on a touch screen: focusing would throw the keyboard over the sheet the owner opened to read. */
    private static FocusAsk = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (AppMain.Coarse() === true) { return; }
            const Box: HTMLElement | null = document.getElementById(AppAssistView.AskBoxId);
            if (Box !== null) { Box.focus(); }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.FocusAsk");
        }
    };

    /** A chip: open the panel and ask its question. ⚠ The chip carries an INDEX, never the text. */
    private OnChipClick = (Ev: Event): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Chip: Element | null = AppEventTarget.Closest(Ev, "[" + AppAssistView.AskAttr + "]", "AppMain.Closest");
            if (Chip === null || this.Assist === null) { return; }
            const At: number = parseInt(nz(Chip.getAttribute(AppAssistView.AskAttr)), 10);
            // ⚠ THE SAME LIST THE CHIPS WERE DRAWN FROM (`ChipList`) - an index read against another
            // list would ask a different question than the chip the owner pressed.
            const List: string[] = this.ChipList();
            if (isNaN(At) === true || At < 0 || At >= List.length) { return; }
            this.AssistOpen = 1;
            this.ShowAssist();
            // ⭐ "Chart how we've been in touch" goes as its preset ID - the service draws it at once, no model.
            (this.Assist as AppAssistPanel).Ask(List[At], AppAssistApi.PresetIdAt(List, At));
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnChipClick");
        }
    };

    /** The chips' questions: `AppAssistApi.Presets`, plus the task questions with tasks on. */
    private ChipList = (): string[] => {
        if (getCoreUtils().KErrorMode === true) { return AppAssistApi.Presets.slice(); }
        try {
            let Title: string = "";
            if (this.Open !== null) { Title = (this.Open as AppContact).Title; }
            return AppTaskRules.Presets(Title, AppTaskRules.Enabled(this.Index));
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.ChipList");
            return AppAssistApi.Presets.slice();
        }
    };

    /** A button inside the log - a draft's Send, Edit or Copy, Try again, Cancel. */
    private OnAssistClick = (Ev: Event): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            AppAssistLogClick.Route(Ev, "AppMain.Closest", this.Assist, this.AssistCitation);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnAssistClick");
        }
    };

    public AssistCitation = (ChatId: string, MessageId: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try { new AppMessageContext(this.Source).Open(ChatId, MessageId); }
        catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppMain.AssistCitation"); }
    };

    /** The free question. ⚠ The box is emptied only when the question actually went. */
    private OnAssistAsk = (Ev: Event): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            AppAskForm.Submit(Ev, AppAssistView.AskBoxId, this.Assist, "AppMain.OnAssistAsk");
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnAssistAsk");
        }
    };

    /** `IAssistHost.PostStream`: one streamed POST to `/assist` (`AppAssistStreamPost`), `Done` once. */
    // REUSE-JUSTIFIED: the shared address lookup and no-service answer are in ONE member, `RouteUrl`. The three lines
    // left differ in the transport - this one is `AppAssistStreamPost` with an `OnText` callback - and cannot be folded
    // with `AssistPost`: `AppAssistExport.test.ts` reads `AssistPost`'s OWN body for the literal
    // `new AppAccountPost(Url, Body, Done).Send()` (the AI call must use the transport with no give-up timer).
    public AssistPostStream = (Body: string, OnText: (Partial: string) => void, Done: AppAssistDone): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Url: string = this.RouteUrl(AppAssistApi.Route, Done);
            if (Url.length === 0) { return; }
            new AppAssistStreamPost(Url, Body, OnText, Done).Send();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.AssistPostStream");
        }
    };

    /**
     * ⭐ THE WARM-UP (`AppAssistWarm`): tell the service to have Claude ready. ⛔ ONLY THE OWNER'S BROWSER (`/folder`
     * said `owner: true`), only from a visible tab; `Page` names the open contact ("" from anywhere else).
     * Called on app start (the owner proof), a contact open, the panel opening and the tab being shown.
     */
    // REUSE-JUSTIFIED: `OnWarmTick` repeats this owner + service + visible-tab line on purpose - `AppAssistFast.test.ts`
    // reads THIS member's body for `this.IsOwner !== true` and `visibilityState === "visible"` (a source pin), and
    // the two differ in the sender's method (`Ping` at once, `Tick` the keep-alive) and in the page they name.
    public WarmAssist = (Page: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.IsOwner !== true || this.ServiceUrl.length === 0) { return; }
            this.Warmer.Ping(this.NumberNow(), this.KeyNow(), Page, document.visibilityState === "visible", Date.now());
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.WarmAssist");
        }
    };

    /** The warm-up's post: fire and forget - the answer is not read. */
    public WarmPost = (Body: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.AssistPost(Body, AppMain.WarmAnswered);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.WarmPost");
        }
    };

    /** DOCUMENTED EXCEPTION: the warm-up's answer is deliberately unread. ERROR-SUPPRESSED-JUSTIFIED: nothing to do. */
    private static WarmAnswered = (Status: number, Text: string): void => {
        return;
    };

    /** The sender's post before `Start` wires the real one (field order). DOCUMENTED EXCEPTION: sends nothing. */
    private static NoWarmPost = (Body: string): void => {
        return;
    };

    /** Every `AppAssistWarmRules.EveryMs`: a keep-alive from a VISIBLE tab only. */
    // REUSE-JUSTIFIED: `WarmAssist` repeats this owner + service + visible-tab line on purpose and the two cannot
    // share it: `AppAssistFast.test.ts` ("THE TRIGGER IS APP START") reads `WarmAssist`'s OWN body for
    // `this.IsOwner !== true` and `visibilityState === "visible"`, and pins `window.setInterval(this.OnWarmTick, ...)`.
    // The contracts differ too: this calls the sender's `Tick` (the keep-alive, rate rule of its own) for the open
    // chat; `WarmAssist` calls `Ping` (at once) for the page its caller names.
    private OnWarmTick = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.IsOwner !== true || this.ServiceUrl.length === 0) { return; }
            this.Warmer.Tick(this.NumberNow(), this.KeyNow(), this.OpenHref, document.visibilityState === "visible", Date.now());
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnWarmTick");
        }
    };

    /** The tab was shown: a warm-up, and the open panel re-reads its history (`AppAssistPanel.OnVisible`). */
    private OnVisibleAssist = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (document.visibilityState !== "visible" || this.IsOwner !== true) { return; }
            this.WarmAssist(this.OpenHref);
            if (this.Assist !== null) { (this.Assist as AppAssistPanel).OnVisible(Date.now()); }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnVisibleAssist");
        }
    };

    /**
     * ⭐ FOR OTHER TABS (`AppTabBus` - notices only, never an action): the AI history of `Href` was saved elsewhere
     * (`Kind` "aichat") or a draft's outcome recorded (`Kind` "outcome", `Id`, `Outcome`). Reaches the open panel
     * only when it shows `Href`. ⛔ Sends nothing.
     */
    public AssistNotice = (Href: string, Kind: string, Id: string, Outcome: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.Assist === null || nz(Href) !== this.OpenHref) { return; }
            if (Kind === "aichat") { (this.Assist as AppAssistPanel).NoticeHistorySaved(); return; }
            if (Kind === "outcome") { (this.Assist as AppAssistPanel).NoticeOutcome(Id, Outcome); }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.AssistNotice");
        }
    };

    /** `IAssistHost.Post`: one POST to `/assist`, answered once (`AppAccountPost`). */
    // REUSE-JUSTIFIED: the shared address lookup and no-service answer are in ONE member, `RouteUrl`. The three lines
    // left must stay HERE: `AppAssistExport.test.ts` reads this member's own body for the literal
    // `new AppAccountPost(Url, Body, Done).Send()` (no give-up timer on an AI call), so a member shared with
    // `AssistPostStream` (another transport, `AppAssistStreamPost`, with an `OnText` callback) would break that pin.
    public AssistPost = (Body: string, Done: AppAssistDone): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Url: string = this.RouteUrl(AppAssistApi.Route, Done);
            if (Url.length === 0) { return; }
            new AppAccountPost(Url, Body, Done).Send();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.AssistPost");
        }
    };

    /**
     * `IAssistHost.Send` - a draft card's Send was CLICKED. ⛔ The composer's own send
     * (`AppComposer.SendText`), never a second one: same `/send`, validation, bubble and latch. The
     * box is left alone - it may hold something the owner is typing. On a phone the sheet closes
     * once the request went, so the bubble in the chat is what the owner sees next.
     */
    public AssistSend = (Text: string, Then: IComposerSent): string => {
        if (getCoreUtils().KErrorMode === true) { return AppComposer.NoSendWhy(); }
        try {
            if (this.Compose === null) { return "Nothing can be sent to this chat from here - use Copy instead."; }
            const Why: string = (this.Compose as AppComposer).SendText(Text, Then);
            if (Why.length === 0 && AppMain.Wide() === false) { this.AssistOpen = 0; this.ShowAssist(); }
            return Why;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.AssistSend");
            return AppComposer.NoSendWhy();
        }
    };

    /**
     * `IAssistHost.Fill` - a draft card's Edit. ⛔ INTO THE BOX, NEVER OUT OF IT: `AppComposer.Fill`
     * sets the text and the focus and does nothing else. On a phone the sheet closes so the box and
     * its Send button are what the owner sees next.
     */
    public AssistFill = (Text: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.Compose === null) {
                if (this.Assist !== null) { (this.Assist as AppAssistPanel).Say("There is no message box for this chat - use Copy instead."); }
                return;
            }
            if (AppMain.Wide() === false) { this.AssistOpen = 0; this.ShowAssist(); }
            (this.Compose as AppComposer).Fill(Text);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.AssistFill");
        }
    };

    /** `IAssistHost.Copy`. ⚠ Same rules as the pairing code's Copy: an absent clipboard is a sentence. */
    public AssistCopy = (Text: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            new AppAssistCopyJob(nz(Text), { Copied: this.OnAssistCopied, Refused: this.OnAssistCopyRefused },
                false, "AppMain.AssistCopy").Start();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.AssistCopy");
        }
    };

    private OnAssistCopied = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        const Note: string = "Copied.";
        try {
            const Panel = this.Assist;
            if (Panel !== null) { (Panel as AppAssistPanel).Say(Note); }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnAssistCopied");
        }
    };

    /** ERROR-SUPPRESSED-JUSTIFIED: a refused clipboard is a browser permission answer, not a fault. */
    private OnAssistCopyRefused = (): void => {
        if (getCoreUtils().KErrorMode) { return; }
        const Note = "This browser would not copy it - select the draft and copy it by hand.";
        try {
            const Panel = this.Assist as AppAssistPanel | null;
            if (Panel !== null) { Panel.Say(Note); }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain." + "OnAssistCopyRefused");
        }
    };

    /**
     * `IAssistHost.Outcome` / `IAppNotifyHost.Outcome`: note what the owner did with a draft on its history
     * item in the chat `Href`. ⛔ IT RECORDS - the service sends nothing for it (`AppAiOutcome`).
     */
    public AssistOutcome = (Href: string, Id: string, Outcome: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Body: string = AppAssistApi.OutcomeBody(this.NumberNow(), this.KeyNow(), Href, Id, Outcome);
            if (Body.length === 0) { return; }
            new AppAiOutcomeSend(new AppAiOutcomeLink(this), Body).Go();
            this.TellTabs("outcome", Href, "", "", "", Outcome, Id, "");
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.AssistOutcome");
        }
    };

    /** `IAiOutcomeHost.NotNoted` - one ink line in the panel on screen. */
    public AssistNotNoted = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.Assist !== null) { (this.Assist as AppAssistPanel).Say(AppAiOutcomeSend.NotNotedWhy()); }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.AssistNotNoted");
        }
    };

    /** `IAssistHost.ReadHistory`: the chat `Href`'s `ai-chat.json`, with the read ticket (`AppSource.LoadBeside`). */
    public AssistReadHistory = (Href: string, Done: (Text: string) => void, Missing: () => void, Fail: (Why: string) => void): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const File: string = AppAiChat.FileOf(Href);
            if (File.length === 0) { Missing(); return; }
            this.Source.LoadBeside(File, Done, Missing, Fail);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.AssistReadHistory");
        }
    };

    /** `IAssistHost.Answered`: repaint only if that conversation is the one on screen. */
    public AssistAnswered = (Session: AppAssistSession): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.TellSaved(Session);
            if (this.Assist === null || (this.Assist as AppAssistPanel).Session !== Session) { return; }
            (this.Assist as AppAssistPanel).Render();
            this.ShowCount();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.AssistAnswered");
        }
    };

    /**
     * `IAssistHost.Forgot` - a "Remove from history" ended (`AppAssistForget`). Removed: the other tabs showing that
     * chat re-read its history (the `aichat` notice) and the ✦ count follows. Either way the panel on screen is
     * repainted WHERE THE OWNER IS READING. ⛔ Nothing is sent to anyone.
     */
    public AssistForgot = (Session: AppAssistSession, Removed: boolean): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (Removed === true && this.IsOwner === true) {
                for (const Href of Object.keys(this.Assists)) {
                    if (this.Assists[Href] === Session) { this.TellTabs("aichat", Href, "", "", "", "", "", ""); }
                }
            }
            if (this.Assist === null || (this.Assist as AppAssistPanel).Session !== Session) { return; }
            (this.Assist as AppAssistPanel).RenderInPlace();
            this.ShowCount();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.AssistForgot");
        }
    };

    /** The composer's form was submitted (Send, or Enter): the box's own send - `AppComposer.Submit`. */
    private OnSend = (Ev: Event): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            Ev.preventDefault();
            if (this.Compose === null) { return; }
            if (this.Attachments !== null && this.Attachments.HasFile()) {
                const Box: HTMLTextAreaElement = document.getElementById("wac-text") as HTMLTextAreaElement;
                this.Attachments.Send(Box.value, this.OpenHref);
                return;
            }
            const Why: string = (this.Compose as AppComposer).Submit();
            if (Why.length > 0) { this.Said(Why, true); }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnSend");
        }
    };

    /**
     * `IComposerSender.Queue` - THE page half of every send (the box's and a draft card's): validate,
     * write the request, and answer `Then` once. "" when it went, else the sentence to show.
     *
     * ⚠ THE BUTTON IS DISABLED BEFORE THE REQUEST IS WRITTEN, NOT AFTER. A second press while the
     * first upload is in flight would write a SECOND request with a SECOND id - and two different
     * ids are two different messages to the bridge's ledger, which is exactly the duplicate it
     * cannot catch. ⛔ `SendTicket` refuses it here too, across contacts: the composer's own latch
     * is rebuilt with every contact paint, this one is not.
     */
    public QueueText = (Text: string, Then: IComposerSent, Translate: string = ""): string => {
        if (getCoreUtils().KErrorMode === true) { return AppComposer.NoSendWhy(); }
        try {
            return this.QueueTo(this.Open, Text, Then, Translate);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.QueueText");
            return AppComposer.NoSendWhy();
        }
    };

    public HoldAttachment = (Then: IComposerSent): string => {
        if (getCoreUtils().KErrorMode || this.Source.Who().length === 0) { return AppComposer.NoSendWhy(); }
        if (this.SendTicket !== null) { return AppComposer.BusyWhy(); }
        this.HoldSend(Then);
        return "";
    };

    public ReleaseAttachment = (Then: IComposerSent): void => {
        if (this.SendTicket === Then) { this.ReleaseSend(); }
    };

    public QueueAttachment = (Data: { name: string; mime: string; data: string; voice: boolean }, Caption: string,
                              Href: string, Then: IComposerSent): string => {
        if (getCoreUtils().KErrorMode) { return AppComposer.NoSendWhy(); }
        try {
            if (this.SendTicket !== Then) { return AppComposer.BusyWhy(); }
            this.ReleaseSend();
            if (Href !== this.OpenHref || this.Open === null) { return "Open the original chat and select the attachment again."; }
            const Why: string[] = [];
            const Req: AppSendRequest | null = AppOutbox.BuildAttachment(this.Open.ChatId, this.Open.Title,
                Caption, this.Source.Who(), Data, Why);
            if (Req === null) { return Why.join(" "); }
            return this.QueueWrite(Href, Req, Then);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.QueueAttachment");
            return AppComposer.NoSendWhy();
        }
    };

    public AttachmentQueued = (): void => {
        if (this.Compose !== null && this.SendingHref === this.OpenHref) { this.Compose.Clear(); }
    };

    /**
     * `QueueText` for a named chat - the open one, or (a "Let <name> know?" card's Send on the Tasks tab)
     * the task's contact. ⛔ The SAME validation, request and page-wide `SendTicket` latch.
     */
    public QueueTo = (Who: AppContact | null, Text: string, Then: IComposerSent, Translate: string = ""): string => {
        if (getCoreUtils().KErrorMode === true) { return AppComposer.NoSendWhy(); }
        try {
            if (Who === null) { return AppComposer.NoSendWhy(); }
            if (this.SendTicket !== null) { return AppComposer.BusyWhy(); }
            const Why: string[] = [];
            if (AppOutbox.Build(Who.ChatId, Who.Title, Text, this.Source.Who(), Why) === null) { return Why.join(" "); }
            // ⭐ TRANSLATION DECIDES HERE, IN ONE TESTED PLACE (`AppTrSendGate`): the flag is stamped on the request, a
            // chat not known yet is asked about first (the ticket held), a lost answer for a chat last seen ON refuses.
            this.Translate.Translator.Who(this.ServiceUrl, this.NumberNow(), this.KeyNow());
            const Job: AppTrSendJob = new AppTrSendJob();
            Job.Href = Who.Href;
            Job.ChatId = Who.ChatId;
            Job.Title = Who.Title;
            Job.Text = Text;
            Job.Approver = this.Source.Who();
            return this.SendGate.Begin(Job, Translate, Then, new AppTrSendPortMain(this, Who.Href));
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.QueueTo");
            this.Busy(false);
            return AppComposer.NoSendWhy();
        }
    };

    /** `IAppTrSendPort.Hold` - a send waits for its chat's translation state: the ticket held, the button busy. */
    public HoldSend = (Then: IComposerSent): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.SendTicket = Then;
            this.Busy(true);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.HoldSend");
        }
    };

    /** `IAppTrSendPort.Release` - the wait ended: the held ticket (once), the button free. */
    public ReleaseSend = (): IComposerSent | null => {
        if (getCoreUtils().KErrorMode === true) { return null; }
        try {
            const Then: IComposerSent | null = this.TakeTicket();
            this.Busy(false);
            return Then;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.ReleaseSend");
            return null;
        }
    };

    /** `IAppTrSendPort.Say` - the hint under the box. */
    // REUSE-JUSTIFIED: see `TranslateSay` - an interface member named for its caller, around the shared `Said`.
    public SendSay = (Text: string, Bad: boolean): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Said(Text, Bad);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.SendSay");
        }
    };

    /** `IAppTrSendPort.Write` - write the request `AppTrSendGate` built and stamped; answer `Then` once, later. */
    public QueueWrite = (Href: string, Req: AppSendRequest, Then: IComposerSent): string => {
        if (getCoreUtils().KErrorMode === true) { return AppComposer.NoSendWhy(); }
        try {
            if (this.SendTicket !== null) { return AppComposer.BusyWhy(); }
            this.SendingText = Req.Text;
            if (Req.Attachment !== null) {
                let Kind: string = "Attachment: ";
                if (Req.Attachment.voice === true) { Kind = "Voice note: "; }
                this.SendingText = Kind + Req.Attachment.name;
                if (Req.Text.length > 0) { this.SendingText += "\n" + Req.Text; }
            }
            this.SendingId = Req.Id;
            this.SendingTranslate = Req.Translate === true && Req.IsReaction === false;
            this.SendingHref = Href;
            this.SendTicket = Then;
            this.Busy(true);
            this.Said("Sending…", false);
            this.Source.Queue(AppOutbox.FileName(Req), AppOutbox.Json(Req), this.OnQueued, this.OnQueueFailed, this.OnQueueUnknown);
            return "";
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.QueueWrite");
            this.Busy(false);
            return AppComposer.NoSendWhy();
        }
    };

    /** Who pressed Send on the request that just answered - taken, so it is told exactly once. */
    private TakeTicket = (): IComposerSent | null => {
        if (getCoreUtils().KErrorMode === true) { return null; }
        try {
            const Then: IComposerSent | null = this.SendTicket;
            this.SendTicket = null;
            return Then;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.TakeTicket");
            return null;
        }
    };

    /**
     * ⚠ IT SAYS "QUEUED", NEVER "SENT". At this moment the message is a file. The bridge has not
     * seen it, WhatsApp has not seen it, and the person it is addressed to certainly has not. The
     * receipt is what makes it sent, and that arrives in the folder on the next rebuild.
     */
    /** ERROR-SUPPRESSED-JUSTIFIED: uncertain acceptance still releases the ticket and watches its original ID. */
    private OnQueueUnknown = (Id: string): void => {
        try {
            this.OnQueued(Id);
            this.UnknownSendingId = Id;
            if (this.Appender !== null) { this.Appender.SetState(Id, AppChatRules.WordForState(AppSendHistory.Unconfirmed)); }
            this.Said("Not confirmed yet - checking its receipt. Check WhatsApp before sending it again.", false);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnQueueUnknown");
        }
    };

    private OnQueued = (Text: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Busy(false);
            const Then: IComposerSent | null = this.TakeTicket();
            // ⚠ THE BUBBLE GOES INTO ITS OWN CHAT ONLY - a card's Send from the Tasks tab has no chat on screen.
            if (this.Compose !== null && this.SendingHref === this.OpenHref) { this.AppendSent(nz(Text)); }
            this.TellSent(nz(Text));
            this.SendingText = "";
            this.SendingId = "";
            // ⚠ WHOEVER PRESSED SEND HEARS IT: the box empties itself (`AppComposer.Queued`); a draft
            // card shows it is in the chat. A draft's send leaves the box alone.
            if (Then !== null) { (Then as IComposerSent).Queued(); }
            if (this.Source.CanCheck() === true) {
                // ⚠ THE BUBBLE SAYS "Sending…" - the hint stays empty rather than saying it twice.
                this.Said("", false);
                // ⚠ A NEWER SEND ENDS THE OLDER WATCH, or its timer would start a second polling
                // chain for the new id beside this one.
                if (this.SendTimer !== 0) { window.clearTimeout(this.SendTimer); }
                this.Watching = nz(Text);
                this.Polls = 0;
                this.SendTimer = window.setTimeout(this.OnSendPoll, AppMain.SendPollMs);
                return;
            }
            this.Said("On its way. WACommander sends it within about half a minute, and it shows in this "
                + "chat after the next update (" + AppUpdateEvery.Within + ").", false);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnQueued");
        }
    };

    /** How often, and for how long, the page asks whether a message has gone. */
    public static readonly SendPollMs: number = 4000;
    public static readonly SendPolls: number = 45;

    /**
     * Ask once whether the message being watched has been sent.
     *
     * ⛔ ONE POLL AT A TIME: the next is scheduled only when this one answers, so a slow network
     * cannot stack requests. ⚠ A NEWER SEND REPLACES THE WATCH - the line under the box is about the
     * last message, and a late answer for an older one must not overwrite it (see `OnSendState`).
     */
    private OnSendPoll = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.SendTimer = 0;
            if (this.Watching.length === 0) { return; }
            this.Polls = this.Polls + 1;
            const Reader: AppSendWatch = new AppSendWatch(this, this.Watching);
            this.Source.Check(this.Watching, Reader.OnState);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnSendPoll");
        }
    };

    /**
     * ⚠ "SENT" ONLY ON THE SENDER'S RECEIPT - the one moment WhatsApp has accepted it.
     * ⚠ RUNNING OUT OF POLLS IS NOT A FAILURE. The message is still queued and will go when the
     * connection allows; saying "failed" would make the owner send it again from their phone, and
     * then it goes twice.
     * ⛔ UNCONFIRMED IS FINAL AND IS NEITHER: WhatsApp never answered, so it may have arrived and the
     * sender will not try again. The line says to check the phone before sending again, in ink -
     * `AppSignUpApi.SendLineFor` decides the words and the colour.
     */
    public OnSendState = (Id: string, Sent: boolean, Final: boolean, Why: string,
                          Unconfirmed: boolean, Extra: AppSendExtra = new AppSendExtra()): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            // ⛔ ONE VERDICT PER SEND: the `/live` push and the `/send` check poll may both bring it - the second is ignored.
            if ((Sent === true || Unconfirmed === true || Final === true) && AppSendPush.Shared.Settle(Id) === false) {
                if (Id === this.Watching) { this.Watching = ""; }
                return;
            }
            if (Id === this.UnknownSendingId && Sent === false && Final === true && Unconfirmed === false) {
                Unconfirmed = true;
                Why = "Acceptance could not be confirmed. Check WhatsApp before sending it again.";
            }
            // ⚠ THE BUBBLE HEARS ITS OWN VERDICT EVEN AFTER A NEWER SEND TOOK OVER THE LINE BELOW.
            if (this.Appender !== null && (Sent === true || Unconfirmed === true || Final === true)) {
                (this.Appender as AppChatAppend).SetState(Id, AppChatRules.WordForPoll(Sent, Unconfirmed, Final, Why));
                // ⭐ TRANSLATION: sent in other words = a flag that shows them; could not translate = Retry / Send in English.
                if (Sent === true) { (this.Appender as AppChatAppend).SetSentText(Id, Extra.SentText); }
                if (Extra.TranslateFailed === true) { (this.Appender as AppChatAppend).SetFailed(Id); }
            }
            if (Id !== this.Watching) { return; }
            if (Extra.TranslateFailed === true) {
                this.Watching = "";
                this.Said(AppTranslateRules.FailedHint, true);
                return;
            }
            if (Sent === true || Unconfirmed === true || Final === true) {
                this.Watching = "";
                const Line: AppSendLine = AppSignUpApi.SendLineFor(Sent, Unconfirmed, Why);
                // ⚠ "SENT" LIVES ON THE BUBBLE ONLY. Unconfirmed and refused keep their sentence in
                // the hint too: the bubble's two words cannot say "do not send it again".
                if (Sent === true) { this.Said("", false); return; }
                if (Line.Text.length > 0) { this.Said(Line.Text, Line.Trouble); }
                return;
            }
            if (this.Polls >= AppMain.SendPolls) {
                this.Watching = "";
                if (Id === this.UnknownSendingId) {
                    this.Said("Not confirmed. Check WhatsApp before sending it again.", false);
                    return;
                }
                if (this.Appender !== null) { (this.Appender as AppChatAppend).SetState(Id, AppChatRules.WordForState("")); }
                this.Said("Still waiting for WhatsApp to confirm. It stays queued and goes as soon as"
                    + " the connection allows - no need to send it again.", false);
                return;
            }
            this.SendTimer = window.setTimeout(this.OnSendPoll, AppMain.SendPollMs);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnSendState");
        }
    };

    /**
     * ⭐ SEND AT ONCE: the open chat's `/live` answer carried the state of sends made from this page (`AppSendPush`).
     * A verdict goes through the SAME reader as the `/send` check (`AppSignUpApi.SendVerdictOf`) and `OnSendState`
     * (settled once); a progress word repaints the bubble ("Translating…" -> "Sending…").
     */
    public OnSendsPushed = (Sends: Record<string, Record<string, unknown>>): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            for (const Id of Object.keys(Sends)) {
                const Entry: Record<string, unknown> = Sends[Id];
                if (AppSendPush.IsFinal(Entry) === true) {
                    const Verdict: AppSendVerdict = AppSignUpApi.SendVerdictOf(AppSignUpApi.Answer(200, JSON.stringify(Entry)));
                    const Extra: AppSendExtra = new AppSendExtra();
                    Extra.SentText = Verdict.SentText;
                    Extra.TranslateFailed = Verdict.TranslateFailed;
                    this.OnSendState(Id, Verdict.Sent, Verdict.Final, Verdict.Why, Verdict.Unconfirmed, Extra);
                    continue;
                }
                this.ShowProgress(Id, AppSendPush.ProgressOf(Entry.progress));
            }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnSendsPushed");
        }
    };

    /** A send's bubble says what the service is doing with it now. */
    private ShowProgress = (Id: string, Progress: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            AppSendPush.Shared.Showing(Id, Progress);
            if (Progress.length === 0 || this.Appender === null) { return; }
            const Word: AppChatWord = new AppChatWord();
            Word.Text = AppChatRules.Sending;
            if (Progress === AppSendPush.Translating) { Word.Text = AppSendPush.TranslatingWord; }
            (this.Appender as AppChatAppend).SetState(Id, Word);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.ShowProgress");
        }
    };

    /** A user-facing failure, and the text STAYS IN THE BOX - retyping a message the product lost
     *  is the one thing that would stop the owner trusting the box at all. */
    private OnQueueFailed = (Why: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Busy(false);
            const Then: IComposerSent | null = this.TakeTicket();
            this.Said("Not queued. " + Why, true);
            if (Then !== null) { (Then as IComposerSent).Failed(Why); }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnQueueFailed");
        }
    };

    private Busy = (On: boolean): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Button: HTMLButtonElement =
                document.getElementById("wac-send") as HTMLButtonElement;
            if (Button === null) { return; }
            Button.disabled = On;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.Busy");
        }
    };

    private Said = (Text: string, Bad: boolean): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Line: HTMLElement | null = document.getElementById("wac-said");
            if (Line === null) { return; }
            Line.textContent = Text;
            let Cls: string = "sayhint";
            if (Bad === true) { Cls = "sayhint bad"; }
            Line.className = Cls;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.Said");
        }
    };

    /**
     * The sign-up route.
     *
     * ⚠ THE STATE IS HELD, NOT THE STEP. `AppSignUp.StepFor` derives where the visitor is from what
     * is known about them, so this method has nothing to advance and a reload cannot land them on a
     * step whose preconditions have gone - see `AppSignUp`'s header.
     */
    /** Whether the address bar is asking for sign-up. Read from the hash, not remembered. */
    public static WantsSignUp = (): boolean => {
        if (getCoreUtils().KErrorMode === true) { return false; }
        try {
            return AppMain.RouteIs(AppMain.SignUpRoute, "AppMain.WantsSignUp");
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.WantsSignUp");
            return false;
        }
    };

    /** Is the address bar on this route? Read from the hash, not remembered. */
    public static RouteIs = (Route: string, Label: string = "AppMain.RouteIs"): boolean => {
        if (getCoreUtils().KErrorMode === true) { return false; }
        try {
            return AppThreeColRules.First(window.location.hash) === Route;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, Label);
            return false;
        }
    };

    /**
     * Is the visitor on one of the routes that need no folder - sign up, sign in, close account?
     *
     * ⛔ ALL THREE ARE ANSWERED BEFORE THE ARCHIVE IS OPENED. Opening first would paint "Opening
     * your archive..." over the one page the visitor asked for, and for `#leave` would make closing
     * an account depend on a Dropbox read succeeding - which is not something leaving should need.
     */
    public static WantsPreFolder = (): boolean => {
        if (getCoreUtils().KErrorMode === true) { return false; }
        try {
            return AppMain.WantsSignUp() === true || AppMain.RouteIs(AppAccount.SignInRoute) === true
                || AppMain.RouteIs(AppAccount.LeaveRoute) === true
                || AppMain.RouteIs(AppAccount.ImportRoute) === true
                || AppMain.RouteIs(AppClaudeToken.Route) === true;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.WantsPreFolder");
            return false;
        }
    };

    /**
     * No folder found.
     *
     * ⛔ FOR A STRANGER THIS IS NOT A FAULT, IT IS THE REASON THEY CAME. The app's own visitor has a
     * folder and a missing one is worth reporting; somebody who has never signed up has no folder by
     * definition, and telling them their archive could not be read would be the product refusing to
     * let them start. So the absent folder becomes the sign-up route rather than a failure.
     *
     * ⚠ IT STILL REPORTS FOR EVERYONE ELSE. Only the visitor who ASKED for sign-up is routed; an
     * existing subscriber whose folder went missing gets the trouble message they need.
     */
    private OnNoFolder = (Why: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (AppMain.WantsSignUp() === true) { this.EnterSignUp(); return; }
            // ⛔ MEASURED IN A BROWSER 2026-09-24: this painted "Could not read index.json (status
            // 404)" to a subscriber on the published site. That sentence is a DEVELOPER'S - it names
            // a file they have never heard of, blames a status code for a page that is working
            // exactly as built, and offers nothing to do next.
            //
            // ⭐ REACHING HERE ON THE LOCAL SOURCE WITH A SERVICE CONFIGURED MEANS ONE THING: this
            // visitor never had a key, so `OpenArchive` was never even tried. That is not a failure
            // to report, it is somebody who is not signed in - and `OfferSignUp` gives them the
            // control that fixes it. ⚠ A DROPBOX source failing keeps its own sentence, which is
            // already about their archive and already actionable.
            if (this.Source instanceof AppLocalSource && this.ServiceUrl.length > 0) {
                this.OfferSignUp(AppMain.NotSignedInWhy());
                return;
            }
            this.Trouble(Why);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnNoFolder");
        }
    };

    /**
     * ⚠ NOT AN ERROR - THIS IS THE ORDINARY STATE OF A BROWSER THAT HAS NEVER SIGNED IN, which on a
     * public address is most of them. It says what this page is and the one thing to do next.
     *
     * DOCUMENTED EXCEPTION: returns a constant sentence.
     * ERROR-SUPPRESSED-JUSTIFIED: pure helper, called only from a guarded method.
     */
    private static NotSignedInWhy = (): string => {
        // ⭐ OWNER 2026-11-01: "no marketing here" - the fact, and the two buttons under it say the rest.
        return "This browser is not signed in.";
    };

    /**
     * Repaint the card the import handlers belong to - sign-up's, or "Import a backup"'s.
     * ⚠ The handlers call this after every change, which is why the choice is made here.
     */
    // ⛔ ONLY AN ARRIVAL ON THE ROUTE (`Enter`) PAINTS THE CARD WHERE IT IS NOT ALREADY SHOWING (verifier, 2026-10-01).
    // The pairing poll, the Dropbox page and the upload all answer LATER, and each answer ends here: a visitor who
    // had gone to another screen meanwhile (Back, a footer link) had the sign-up card painted over it, under an
    // address that named something else. The state is still updated by the caller, so coming back shows it.
    private ShowSignUp = (Enter: boolean = false): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (Enter !== true && this.SignUpOnScreen() === false) { return; }
            const Had: string = this.FocusedId();
            // ⚠ Read BEFORE the paint: `Paint` redraws the footer, and a focused link there would be gone after it.
            const Elsewhere: boolean = Enter !== true && this.FocusElsewhere();
            if (this.ImportLater === true) { this.Paint(AppSignUp.LaterHtml(this.SignUp)); }
            else { this.Paint(AppSignUp.Html(this.SignUp)); }
            this.WireSignUp();
            this.FocusSignUp(Had, Elsewhere);
            this.ResumeWait();
            // The import status line (when the card carries one): its elapsed count, and its watch carried on.
            if (this.Imports !== null) { (this.Imports as AppImportPanel).Attach(); }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.ShowSignUp");
        }
    };

    // ── What became of the uploaded backup (`AppImportStatus` / `AppImportRun`) ──────────────────────────

    /** The one import panel of the page. */
    private ImportPanel = (): AppImportPanel => {
        // ERROR-SUPPRESSED-JUSTIFIED: no KErrorMode guard - it must answer an object; the panel's own methods are guarded.
        if (this.Imports === null) { this.Imports = new AppImportPanel(this.ServiceUrl, this); }
        return this.Imports as AppImportPanel;
    };

    /**
     * This visit's upload finished as Dropbox revision `Rev`: start asking the service what becomes of it.
     * False when it cannot be asked (no service, no `rev`, nothing to prove with) - the page then says what it
     * said before. ⚠ "Import a backup" proves itself with the archive KEY only (`OnUnlocked`'s reason).
     */
    private WatchUpload = (Rev: string): boolean => {
        if (getCoreUtils().KErrorMode === true) { return false; }
        try {
            if (this.ServiceUrl.length === 0) { return false; }
            let Secret: string = nz(this.Secret);
            if (this.ImportLater === true) { Secret = ""; }
            return this.ImportPanel().Track(nz(this.SignUp.Number), Secret, this.KeyNow(), Rev);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.WatchUpload");
            return false;
        }
    };

    /** A new upload is starting: the earlier one's status leaves the card and is no longer asked about. */
    private DropUploadStatus = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.SignUp.Upload = null;
            if (this.Imports !== null) { (this.Imports as AppImportPanel).Pause(); }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.DropUploadStatus");
        }
    };

    /**
     * `IAppImportOwner`: what is shown about the upload changed. The panel has already written the line in
     * place; this keeps the state a repaint draws from, and acts on the two endings:
     * - ⭐ IMPORTED after THIS visit's upload on "Import a backup": back to the main screen with the result
     *   (owner, 2026-09-25: "A successful save should bring me back to the main screen").
     * - a service with no `/import` route (`Off`): the page says what it said before this existed.
     * ⛔ A REFUSAL STAYS ON THE CARD - it is the thing the subscriber came back to read.
     */
    public OnImportShown = (Shown: ImportShown): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Mine: boolean = this.ImportLater === true && this.SignUp.Imported === true;
            if (Shown.Off === true) {
                this.SignUp.Upload = null;
                if (Mine === true && this.SignUpOnScreen() === true) {
                    this.BackToMain("Backup uploaded. " + AppSignUp.LaterDoneWords());
                    return;
                }
                this.ShowSignUp();
                return;
            }
            this.SignUp.Upload = Shown;
            if (Shown.State === AppImportStatus.Imported && Mine === true) { this.FinishImported(Shown.Sentence); }
            // ⭐ REFUSED (or no longer there) AFTER THIS VISIT'S UPLOAD: the card stops saying "Backup uploaded"
            // over a refusal and becomes the import step again, the verdict above it as "Your last upload" -
            // so another file can be chosen right there (what a reload already showed).
            if (Mine === true && Shown.Final === true && AppImportStatus.AsksAnother(Shown.State) === true) {
                // The import step as `ShowImportLater` enters it - nothing chosen, nothing typed - plus the verdict.
                const Phone: string = nz(this.SignUp.Number);
                this.SignUp = new SignUpState();
                this.SignUp.Number = Phone;
                this.SignUp.Linked = true;
                this.SignUp.Dropbox = "your Dropbox";
                this.SignUp.Upload = Shown;
                this.Picked = null;
                this.Plain = null;
                this.ShowSignUp();
            }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnImportShown");
        }
    };

    /** Imported: read the index again (so the list holds the history), then go back to the main screen. */
    private FinishImported = (Say: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.ImportedSay = Say;
            if (this.Index.Loaded === false) { this.OnImportedBack(); return; }
            this.Source.LoadIndex(this.OnImportedIndex, this.OnImportedFail);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.FinishImported");
        }
    };

    private OnImportedIndex = (Text: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Fresh: AppIndex = AppIndexReader.Parse(Text);
            if (Fresh.Loaded === true) {
                AppLiveListRules.Adopt(Fresh, this.Index, this.Unread);
                this.Index = Fresh;
            }
            this.OnImportedBack();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnImportedIndex");
        }
    };

    /** ERROR-SUPPRESSED-JUSTIFIED: a background re-read failing keeps the index in hand (`OnQuietFail`'s reason);
     *  the result is still said. */
    private OnImportedFail = (Why: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.OnImportedBack();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnImportedFail");
        }
    };

    /** ⛔ ONLY WHILE THE CARD IS STILL WHAT THE PAGE SHOWS - a visitor who went elsewhere meanwhile is not moved. */
    private OnImportedBack = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Say: string = this.ImportedSay;
            this.ImportedSay = "";
            if (Say.length === 0 || this.ImportLater !== true || this.SignUpOnScreen() === false) { return; }
            this.SignUp.Upload = null;
            this.BackToMain(Say);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnImportedBack");
        }
    };

    /** Is the sign-up card (or "Import a backup", the same card) what the page is showing right now? */
    private SignUpOnScreen = (): boolean => {
        if (getCoreUtils().KErrorMode === true) { return false; }
        try {
            if (this.Where === null) { return false; }
            return this.Where.querySelector("section.signup:not(.account)") !== null;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.SignUpOnScreen");
            return false;
        }
    };

    /** Is the focus on a real control OUTSIDE the app's own area (the top bar, a menu, the footer)? */
    private FocusElsewhere = (): boolean => {
        if (getCoreUtils().KErrorMode === true) { return false; }
        try {
            const At: Element | null = document.activeElement;
            if (At === null || At === document.body || At === document.documentElement) { return false; }
            return this.Where !== null && this.Where.contains(At) === false;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.FocusElsewhere");
            return false;
        }
    };

    /** The field `FocusedId` last saw the caret in, and where it stood (-1 = none). Put back by `PutCaret`. */
    private CaretIn: string = "";
    private CaretFrom: number = -1;
    private CaretTo: number = -1;

    /**
     * The id of the focused element inside the app, or "".
     *
     * ⭐ IT ALSO NOTES THE CARET (verifier, 2026-10-01). A repaint builds a NEW field, and a new field given the
     * focus has its caret at the START - so whoever typed on after an answer repainted the card (a refused number,
     * the Dropbox page arriving on the sign-in screen) typed in front of what was there: "+46" then " 70" read
     * " 70+46", seen in Chrome.
     */
    private FocusedId = (): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            this.CaretIn = "";
            this.CaretFrom = -1;
            this.CaretTo = -1;
            const At: Element | null = document.activeElement;
            if (At === null || this.Where === null || this.Where.contains(At) === false) { return ""; }
            if (At instanceof HTMLInputElement && typeof At.selectionStart === "number" && typeof At.selectionEnd === "number") {
                this.CaretIn = nz(At.id);
                this.CaretFrom = At.selectionStart;
                this.CaretTo = At.selectionEnd;
            }
            return nz(At.id);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.FocusedId");
            return "";
        }
    };

    /** The caret goes back where it was, when `El` is the repainted field `FocusedId` saw it in. */
    private PutCaret = (El: HTMLElement): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if ((El instanceof HTMLInputElement) === false || this.CaretFrom < 0) { return; }
            const Box: HTMLInputElement = El as HTMLInputElement;
            if (this.CaretIn.length === 0 || Box.id !== this.CaretIn || typeof Box.selectionStart !== "number") { return; }
            const End: number = Box.value.length;
            Box.setSelectionRange(Math.min(this.CaretFrom, End), Math.min(this.CaretTo, End));
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.PutCaret");
        }
    };

    /**
     * Where the focus goes after the sign-up card was painted.
     *
     * ⭐ EVERY PAINT REPLACES THE CARD, so the focus used to fall back to the top of the document on every
     * answer - a keyboard user tabbed through the top bar again after each step (seen in Chrome 2026-10-01).
     * A NEW screen gets its own first control (`AppSignUp.FocusFor`: the heading on a touch screen, so no
     * keyboard opens over the instructions); the SAME screen painted again keeps the focus where it was.
     */
    // ⛔ `Elsewhere` (the focus was on a control outside the card when a LATE answer repainted it): left alone
    // (`AppSignUp.FocusAfter`). ⚠ A screen whose own control is not on the card (the no-key import has no key box)
    // gets the heading, never nothing - the focus used to fall back to the top of the document there.
    private FocusSignUp = (Had: string, Elsewhere: boolean = false): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Screen: string = AppSignUp.ScreenOf(this.SignUp);
            let Mark: string = Screen;
            if (this.ImportLater === true) { Mark = "later-" + Screen; }
            const Fresh: boolean = Mark !== this.SignUpScreen;
            const Want: string = AppSignUp.FocusAfter(Screen, AppMain.Typing(), Fresh, Had, Elsewhere);
            this.SignUpScreen = Mark;
            if (Want.length === 0) { return; }
            let El: HTMLElement | null = document.getElementById(Want);
            if (El === null && Fresh === true) { El = document.getElementById(AppSignUp.HeadId); }
            if (El === null) { return; }
            El.focus();
            if (Fresh === false) { this.PutCaret(El); }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.FocusSignUp");
        }
    };

    /** Is this a device with a keyboard and a mouse? ⚠ A touch screen answers false: no field is focused for it. */
    private static Typing = (): boolean => {
        if (getCoreUtils().KErrorMode === true) { return false; }
        try {
            return AppMediaQuery.Matches("(hover: hover) and (pointer: fine)");
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.Typing");
            return false;
        }
    };

    /**
     * Enter in a field presses the button the field names (`AppSignUp.GoAttr`).
     *
     * ⛔ IT CLICKS THE STEP'S OWN BUTTON AND DOES NOTHING ELSE - so a disabled or busy button stays
     * unpressed and every guard in the button's handler applies. Only sign-up and account fields carry
     * the attribute; the reply box does not, and nothing here can send a message.
     */
    private OnFieldKey = (Evt: KeyboardEvent): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const From: EventTarget | null = Evt.target;
            if (From === null || (From instanceof HTMLInputElement) === false) { return; }
            // ⚠ `keyCode` 229: Safari reports the Enter that ENDS a composition with `isComposing` false and this code.
            // ⛔ `repeat`: a HELD Enter is one press (`AppSignUp.EnterTarget`).
            const Go: string = AppSignUp.EnterTarget(Evt.key, nz((From as HTMLInputElement).getAttribute(AppSignUp.GoAttr)),
                Evt.isComposing === true || Evt.keyCode === 229,
                Evt.ctrlKey === true || Evt.altKey === true || Evt.metaKey === true || Evt.shiftKey === true, Evt.repeat === true);
            if (Go.length === 0) { return; }
            const Button: HTMLElement | null = document.getElementById(Go);
            if (Button === null || (Button as HTMLButtonElement).disabled === true) { return; }
            Evt.preventDefault();
            Button.click();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnFieldKey");
        }
    };

    /** The import step's `.drop` box under a drag: marked `.dropon` while a file hovers over it. */
    private OnPickDrag = (Evt: DragEvent): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Box: Element | null = Evt.target instanceof Element ? Evt.target.closest(".signup .drop") : null;
            if (Box === null || Box.querySelector("#wac-pick") === null) { return; }
            if (Evt.type === "dragover") {
                Evt.preventDefault();
                Box.classList.add("dropon");
                return;
            }
            Box.classList.remove("dropon");
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnPickDrag");
        }
    };

    /**
     * A file dropped on the import step's box goes into the real `wac-pick` input and its `change` is fired, so the
     * ONE pick path (`OnSignUpPick`) takes it exactly as a chosen file - nothing is read here.
     */
    private OnPickDrop = (Evt: DragEvent): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Box: Element | null = Evt.target instanceof Element ? Evt.target.closest(".signup .drop") : null;
            if (Box === null) { return; }
            const Pick: Element | null = Box.querySelector("#wac-pick");
            if (!(Pick instanceof HTMLInputElement)) { return; }
            Evt.preventDefault();
            Box.classList.remove("dropon");
            const Files: FileList | null = Evt.dataTransfer !== null ? Evt.dataTransfer.files : null;
            if (Files === null || Files.length === 0) { return; }
            Pick.files = Files;
            Pick.dispatchEvent(new Event("change", { bubbles: true }));
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnPickDrop");
        }
    };

    /**
     * Typing in a sign-up / sign-in field: what was typed is kept for the next paint, and on the two
     * Dropbox screens the main button follows the code box (`AppSignUp.FinishLeads`) - in place, never
     * by a repaint, which would take the caret out of the box.
     */
    private OnFieldInput = (Evt: Event): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const From: EventTarget | null = Evt.target;
            if (From === null || (From instanceof HTMLInputElement) === false) { return; }
            const Box: HTMLInputElement = From as HTMLInputElement;
            if (Box.id === "wac-number") { this.SignUp.Typed = nz(Box.value); return; }
            if (Box.id === "wac-dbxcode") {
                this.SignUp.DbxTyped = nz(Box.value);
                AppMain.Lead("wac-dbxsave", "wac-dropbox", AppSignUp.FinishLeads(Box.value));
                return;
            }
            if (Box.id === AppAccountViews.SignInCodeId) {
                AppMain.Lead(AppAccountViews.SignInGoId, AppAccountViews.SignInLinkId, AppSignUp.FinishLeads(Box.value));
            }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnFieldInput");
        }
    };

    /** Make `First` the primary button and `Second` the secondary one - or the other way round. */
    private static Lead = (First: string, Second: string, FirstLeads: boolean): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const A: HTMLElement | null = document.getElementById(First);
            const B: HTMLElement | null = document.getElementById(Second);
            if (A !== null) { A.classList.toggle("primary", FirstLeads); A.classList.toggle("secondary", FirstLeads === false); }
            if (B !== null) { B.classList.toggle("primary", FirstLeads === false); B.classList.toggle("secondary", FirstLeads); }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.Lead");
        }
    };

    /** The waiting screen's count starts: one tick a second, written in place (`OnWaitTick`). */
    private StartWait = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.StopWait();
            this.WaitSince = Date.now();
            this.SignUp.WaitedSec = 0;
            this.WaitTimer = window.setInterval(this.OnWaitTick, 1000);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.StartWait");
        }
    };

    /**
     * The waiting screen was painted again with no tick running (the visitor left the route and came back while a
     * code was still on its way): the count carries on from when the wait BEGAN. ⚠ Paints only, like `OnWaitTick`.
     */
    private ResumeWait = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.WaitTimer !== 0 || this.SignUp.Waiting !== true || this.WaitSince <= 0) { return; }
            if (document.getElementById(AppSignUp.WaitedId) === null) { return; }
            this.WaitTimer = window.setInterval(this.OnWaitTick, 1000);
            this.OnWaitTick();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.ResumeWait");
        }
    };

    private StopWait = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.WaitTimer === 0) { return; }
            window.clearInterval(this.WaitTimer);
            this.WaitTimer = 0;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.StopWait");
        }
    };

    /**
     * ⛔ THIS TICK PAINTS AND NOTHING ELSE. It asks the service for nothing - the poll is `OnPairPoll`,
     * and a second ask would cancel the code on its way. ⚠ `textContent` in place: a repaint would
     * restart the spinner and the bar every second.
     */
    private OnWaitTick = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Sec: number = Math.floor((Date.now() - this.WaitSince) / 1000);
            this.SignUp.WaitedSec = Sec;
            const Count: HTMLElement | null = document.getElementById(AppSignUp.WaitedId);
            if (Count === null) { this.StopWait(); return; }
            Count.textContent = AppSignUp.WaitedText(Sec);
            const Hint: HTMLElement | null = document.getElementById(AppSignUp.WaitHintId);
            const Say: string = AppSignUp.WaitHint(Sec);
            if (Hint !== null && Hint.textContent !== Say) { Hint.textContent = Say; }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnWaitTick");
        }
    };

    /**
     * The `#signup` route.
     *
     * ⚠ A STATE LEFT BY "IMPORT A BACKUP" IS DROPPED FIRST. That state says "linked, Dropbox
     * connected", and painting sign-up over it would show a stranger a finished sign-up that is not
     * theirs; a chosen file or an unlocked database goes with it (`OnSkipImport`'s reason).
     */
    private EnterSignUp = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.ImportLater === true) {
                this.ImportLater = false;
                this.SignUp = new SignUpState();
                this.Picked = null;
                this.Plain = null;
            }
            // ⚠ Arriving on the route is a new screen: the focus goes to its first control again.
            this.SignUpScreen = "";
            this.ShowSignUp(true);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.EnterSignUp");
        }
    };

    /**
     * `#import` - bring a backup after sign-up, with the archive key as the proof.
     *
     * ⚠ THE NUMBER IS THE KEY'S OWN (`SessionNumber`, then the store), never `SignUp.Number` - the
     * service checks the key against the number it names, and a sign-up left in this tab could
     * name somebody else. ⚠ Entered fresh each time the route is taken, unless an import is running.
     */
    private ShowImportLater = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Shell(false);
            const Phone: string = AppAccount.First(this.SessionNumber, AppArchiveStore.Number());
            if (this.KeyNow().length === 0 || Phone.length === 0) {
                this.OfferSignUp(AppMain.NotSignedInWhy());
                return;
            }
            if (this.ImportLater === false || this.SignUp.Busy === false) {
                this.SignUp = new SignUpState();
                this.SignUp.Number = Phone;
                this.SignUp.Linked = true;
                this.SignUp.Dropbox = "your Dropbox";
                this.Picked = null;
                this.Plain = null;
            }
            this.ImportLater = true;
            this.SignUpScreen = "";
            // ⭐ AN UPLOAD THIS BROWSER MADE EARLIER (a reload, a return to this page) is asked about again with
            // the key - `OnImportShown` puts what it says on the card (synchronously, its first words).
            if (this.SignUp.Busy === false && this.SignUp.Imported === false && this.ServiceUrl.length > 0
                && this.ImportPanel().Recall(Phone, this.KeyNow()) === true) {
                this.SignUp.Upload = this.ImportPanel().Shown();
            }
            this.ShowSignUp(true);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.ShowImportLater");
        }
    };

    /**
     * "Open WACommander" / "Back to my archive".
     *
     * ⛔ THE LINK ALONE WAS A DEAD CLICK WHEN THE ADDRESS WAS ALREADY `#all` - see
     * `AppSignUp.OpenButton`. With a folder already loaded the link's own `hashchange` lists it;
     * otherwise the route is set WITHOUT a `hashchange` (`replaceState`, `OpenSignedIn`'s reason) and
     * the archive is opened here. ⚠ `Opening` is cleared first: a resumed sign-up reached this page
     * through a refused ticket, which latched it.
     */
    private OnOpenPress = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Opening = false;
            if (this.Index.Loaded === true) { return; }
            window.history.replaceState(null, "", "#all");
            this.OpenArchive();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnOpenPress");
        }
    };

    /**
     * ⚠ THE LISTENERS ARE ATTACHED AFTER EVERY PAINT, NOT ONCE. `Paint` replaces `innerHTML`, which
     * destroys the elements the previous listeners were on - so a handler bound once works until the
     * first re-render and then silently stops, which is the worst kind of dead button.
     */
    private WireSignUp = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            AppEventTarget.OnClick("wac-claim", this.OnClaim, "AppMain.On");
            AppEventTarget.OnClick("wac-dbxsave", this.OnDropboxCode, "AppMain.On");
            AppEventTarget.OnClick("wac-unlock", this.OnSignUpUnlock, "AppMain.On");
            // The no-key import (an iPhone's database, `ImportPlain`): send it, or choose another file.
            AppEventTarget.OnClick(AppSignUp.PlainGoId, this.OnPlainImport, "AppMain.On");
            AppEventTarget.OnClick(AppSignUp.RepickId, this.OnRepick, "AppMain.On");
            AppEventTarget.OnClick("wac-connect", this.OnAskCode, "AppMain.On");
            AppEventTarget.OnClick("wac-dbxretry", this.OnDropboxRetry, "AppMain.On");
            AppEventTarget.OnClick("wac-onedrive", this.OnOneDriveGo, "AppMain.On");
            // ⚠ BOUND LIKE THE REST, AND FOR THE SAME REASON. The code screen is re-painted on
            // every poll answer, so a Copy wired once would work until the first repaint and then
            // silently stop - on the one control whose whole job is to save a minute.
            AppEventTarget.OnClick("wac-copy", this.OnCopyCode, "AppMain.On");
            AppEventTarget.OnClick("wac-skipimport", this.OnSkipImport, "AppMain.On");
            AppEventTarget.OnClick(AppSignUp.OpenId, this.OnOpenPress, "AppMain.On");
            // ⛔ A FILE INPUT ANSWERS `change`, NOT `click`. `wac-pick` was a BUTTON that opened the
            // Google Picker; it is now an `<input type="file">` because the browser opens the
            // backup locally and no Picker exists any more. Bound with `On` it would fire on the
            // press that opens the chooser - before a file has been chosen - so `PickedName` would
            // be set from nothing and the key box would appear over an empty selection.
            AppMain.OnChange("wac-pick", this.OnSignUpPick);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.WireSignUp");
        }
    };

    /**
     * The same, for an element that answers `change` rather than `click`.
     *
     * ⚠ IT IS A SECOND METHOD RATHER THAN A PARAMETER ON `On`, because every existing caller passes
     * a button and a defaulted event name is a thing to get wrong silently - a handler bound to the
     * wrong event does not fail, it simply never runs, which is the dead-button failure `WireSignUp`
     * exists to avoid.
     */
    private static OnChange = (Id: string, Then: () => void): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const El: HTMLElement | null = document.getElementById(Id);
            if (El === null) { return; }
            El.addEventListener("change", Then);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnChange");
        }
    };

    // ── 1. Claim the number ──────────────────────────────────────────────────────────────────────

    /**
     * ⛔ THE NUMBER IS NOT VALIDATED HERE, AND THAT IS DELIBERATE. `ClaimGate` already refuses one
     * that is not E.164 with a sentence naming the country code, and a second opinion in the page
     * would be a second thing to keep in step - on the question whose wrong answer is telling
     * somebody their own number is invalid. One decider, `TenantRoster.KeyOf`, server side.
     *
     * ⚠ `Busy` REFUSES A SECOND PRESS. This is the step a hesitant visitor double-taps, and two
     * claims in flight would race to paint two different answers over each other.
     */
    private OnClaim = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.SignUp.Busy === true) { return; }
            const Box: HTMLInputElement | null =
                document.getElementById("wac-number") as HTMLInputElement | null;
            if (Box === null) { return; }
            this.Typed = nz(Box.value).trim();
            // ⚠ KEPT FOR EVERY REPAINT (busy, refused) - the box used to empty under the visitor.
            this.SignUp.Typed = nz(Box.value);
            // ⛔ NOTHING TYPED IS ANSWERED HERE, NOT SENT. With no body the transport sends a GET, and the
            // answer to that reads "could not be reached - nothing is wrong with what you typed" to
            // somebody who typed nothing. Whether a number IS one stays the service's question.
            if (this.Typed.length === 0) {
                this.SignUp.Why = AppSignUp.NoNumberWhy;
                this.ShowSignUp();
                return;
            }
            this.SignUp.Why = "";
            this.SignUp.Busy = true;
            this.ShowSignUp();
            const Url: string = AppSignUpApi.UrlFor(this.ServiceUrl, AppSignUpApi.Claim);
            new AppSignUpPost(Url, AppSignUpApi.ClaimBody(this.Typed), this.OnClaimed).Send();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnClaim");
        }
    };

    /**
     * ⛔ THE NUMBER AND THE SECRET ARE WRITTEN ONLY ONCE THE SERVICE HAS ACCEPTED. `StepFor` reads
     * `Number` as the FACT that the claim succeeded, so setting it from the box would advance the
     * wizard past a claim that was refused - and every later step would then work against a
     * registry with no row for them.
     *
     * ⛔ AND A SUCCESS WITH NO SECRET IS TREATED AS A FAILURE. Without it `/pair` and `/dropbox`
     * both refuse, so advancing would hand the visitor a sign-up that works for one screen and
     * then stops with nothing to say why.
     */
    private OnClaimed = (Answer: SignUpAnswer): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.SignUp.Busy = false;
            // ⭐ A RELOAD MID-SIGN-UP LANDS BACK HERE, ON `#signup`, AND THE CLAIM IS REFUSED BECAUSE
            // THE NUMBER IS ALREADY LIVE. If this browser holds a key for THAT number it is the same
            // subscriber coming back, so their archive - or its unfinished Dropbox step, via
            // `OnFolderRefused` - opens instead of a refusal with nowhere to go.
            if (Answer.Ok !== true && AppArchiveStore.Held() === true
                && AppAccount.SameNumber(this.Typed, AppArchiveStore.Number()) === true) {
                this.OpenSignedIn();
                return;
            }
            if (Answer.Ok !== true || nz(Answer.Secret).length === 0) {
                this.SignUp.Why = AppMain.WhyIn(Answer);
                // ⭐ "WACommander is full" is a condition at OUR end, flagged by the service (`ClaimRules.FullField`)
                // - the ink notice, never decided by the sentence's words (the passkey flag's rule).
                this.SignUp.InfoWhy = "";
                if (Answer.Full === true) { this.SignUp.InfoWhy = this.SignUp.Why; }
                this.ShowSignUp();
                return;
            }
            this.Secret = nz(Answer.Secret);
            this.SignUp.Number = nz(Answer.Number);
            this.SignUp.Typed = "";
            this.SignUp.Why = "";
            this.ShowSignUp();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnClaimed");
        }
    };

    /** ⚠ AN ANSWER WITH NO SENTENCE STILL GETS ONE - a blank refusal explains nothing. */
    private static WhyIn = (Answer: SignUpAnswer): string => {
        if (getCoreUtils().KErrorMode === true) { return AppSignUpApi.OursWhy(); }
        try {
            if (nz(Answer.Why).trim().length > 0) { return nz(Answer.Why); }
            return AppSignUpApi.OursWhy();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.WhyIn");
            return AppSignUpApi.OursWhy();
        }
    };

    // ── 2. The handset ───────────────────────────────────────────────────────────────────────────

    /**
     * ⛔ ONE ASK, EVER, PER PRESS - AND THE POLL NEVER ASKS AGAIN.
     *
     * Each new pairing code CANCELS the one before it. So `ask` goes out exactly once here, the
     * timer only ever sends `poll`, and `Busy` plus a live timer both refuse a second press. The
     * page's own affordances agree: `AppSignUp` shows no button at all while waiting or while a
     * code is on screen.
     */
    private OnAskCode = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.SignUp.Busy === true) { return; }
            if (this.PairTimer !== 0) { return; }
            if (nz(this.Secret).length === 0) {
                this.SignUp.Why = AppSignUpApi.NoServiceWhy();
                this.ShowSignUp();
                return;
            }
            this.SignUp.Why = "";
            this.SignUp.Code = "";
            this.SignUp.Waiting = true;
            this.SignUp.Busy = true;
            this.StartWait();
            this.ShowSignUp();
            this.SendPair(AppSignUpApi.Ask, this.OnAsked);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnAskCode");
        }
    };

    private SendPair = (Action: string, Done: (A: SignUpAnswer) => void): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Url: string = AppSignUpApi.UrlFor(this.ServiceUrl, AppSignUpApi.Pair);
            const Body: string = AppSignUpApi.PairBody(this.SignUp.Number, this.Secret, Action);
            new AppSignUpPost(Url, Body, Done).Send();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.SendPair");
        }
    };

    /**
     * ⛔ A REFUSED ASK STOPS THE WAIT, because nothing is coming. Leaving the page waiting on an
     * ask the service never recorded is the silent stall this flow exists to avoid - and the
     * visitor's only remaining move would be a button the waiting screen deliberately hides.
     */
    private OnAsked = (Answer: SignUpAnswer): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (Answer.Ok !== true) {
                this.StopWait();
                this.SignUp.Busy = false;
                this.SignUp.Waiting = false;
                this.SignUp.Why = AppMain.WhyIn(Answer);
                this.ShowSignUp();
                return;
            }
            this.PairTimer = window.setInterval(this.OnPairPoll, AppMain.PollMs);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnAsked");
        }
    };

    /**
     * ⚠ IT RIDES THE SERVICE'S OWN CADENCE. The tenant's cycle picks the ask up on its outbox tick
     * (20s), so polling faster buys nothing but requests; polling much slower would spend the
     * subscriber's one-minute window waiting for the page rather than the phone.
     */
    public static readonly PollMs: number = 4000;

    /** ⛔ `poll` ONLY. An `ask` on a timer would issue a second code every cycle. */
    private OnPairPoll = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            // ⛔ NOTHING TO PROVE THE SESSION WITH = NOTHING IS SENT, AND THE WATCH ENDS (`AppSignUpPost` sends an
            // empty body as a GET - the rule the empty Dropbox code broke).
            if (AppSignUpApi.PairBody(this.SignUp.Number, this.Secret, AppSignUpApi.Poll).length === 0) { this.StopPolling(); return; }
            this.SendPair(AppSignUpApi.Poll, this.OnPairState);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnPairPoll");
        }
    };

    /**
     * ⛔ A FAILED POLL DOES NOT END THE WATCH. (The retired Drive watcher ruled this first.) Stopping would
     * abandon an ask that is being answered, and the obvious recovery - press Connect again -
     * cancels the code on its way. A blip is simply retried on the next tick.
     *
     * ⛔ THE TIMER IS CLEARED ON `linked` AND ON A CODE. On a code because the subscriber now has
     * about a minute of work to do and nothing further will change until they do it; on `linked`
     * because the step is over. Leaving it running would keep polling a finished sign-up for as
     * long as the tab is open.
     */
    private OnPairState = (Answer: SignUpAnswer): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            // ⛔ ONE RULE FOR WHAT A POLL ANSWER MEANS, THE RE-LINK BANNER'S (`AppAccount.RelinkVerdict`). Until
            // 2026-10-01 this method read a LOST CONNECTION (status 0, or a page that is not JSON - every deploy
            // produces one) as a refusal: the watch ended, the code on screen was replaced by "could not be
            // reached" and the "Show me a code" button came back - one press from cancelling the code being typed.
            const Verdict: string = AppAccount.RelinkVerdict(Answer.Ok, Answer.Linked, Answer.Code, Answer.Waiting,
                Answer.Why, AppSignUpApi.OursWhy());
            if (Verdict === "linked") { this.OnLinked(); return; }
            if (Verdict === "code") { this.OnPairCode(nz(Answer.Code)); return; }
            if (Verdict === "refused") { this.OnPairRefused(Answer); return; }
            // ⚠ NOTHING TO DO FOR "STILL WAITING": the screen's own tick (`OnWaitTick`) counts the seconds and
            // changes the sentence. `Slow` was set here and never painted, so that sentence never showed.
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnPairState");
        }
    };

    /**
     * A pairing code arrived on a poll.
     *
     * ⛔ THE POLL KEEPS RUNNING WHILE A CODE IS ON SCREEN. IT USED TO STOP HERE, AND THAT MADE THE
     * ENDING OF SIGN-UP UNREACHABLE. The old reasoning was "the subscriber has about a minute of work
     * to do and nothing further will change until they do it". The thing that changes IS them doing
     * it: the handset completes the pairing, the service writes `linked`, and a page that has stopped
     * asking never hears it. Measured live 2026-09-23 - the phone linked, the service wrote
     * `linked: true`, and the page sat on the code for ever under a caption promising "this page
     * moves on by itself".
     *
     * ⛔ POLLING IS SAFE TO CONTINUE AND THAT IS WHY `poll` AND `ask` ARE SEPARATE VERBS. `ask`
     * issues a code and each new one cancels the last; `poll` reads and changes nothing. Stopping was
     * never protecting the code - it was only losing the answer.
     *
     * ⚠ AND IT REPAINTS ONLY WHEN THE CODE CHANGES. A repaint every four seconds would wipe the
     * "Copied" confirmation and any text the subscriber had selected, mid-read, on the one screen
     * where they are copying eight characters by eye.
     */
    private OnPairCode = (Code: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (nz(Code) === nz(this.SignUp.Code)) { return; }
            this.SignUp.Code = nz(Code);
            this.SignUp.Waiting = false;
            this.ShowSignUp();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnPairCode");
        }
    };

    /** The service answered the poll with a refusal - the watch ends and the sentence is shown. */
    private OnPairRefused = (Answer: SignUpAnswer): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.StopPolling();
            this.SignUp.Busy = false;
            this.SignUp.Waiting = false;
            // ⚠ A refusal ends the code too: one that was showing must not come back on a later paint.
            this.SignUp.Code = "";
            this.SignUp.Why = AppMain.WhyIn(Answer);
            // ⭐ WhatsApp's passkey demand is a condition on the ACCOUNT, flagged by the service - the ink notice.
            this.SignUp.InfoWhy = "";
            if (Answer.Passkey === true) { this.SignUp.InfoWhy = this.SignUp.Why; }
            this.ShowSignUp();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnPairRefused");
        }
    };

    /**
     * Put the pairing code on the clipboard.
     *
     * ⛔ IT IS NOT A SECOND WAY TO ASK FOR A CODE, and that is the whole reason a button may exist
     * on a screen that deliberately offers nothing else: it reads what is already on this page,
     * writes nothing anywhere, and costs nothing pressed twice. Asking again would cancel the code
     * the subscriber is at that moment typing.
     *
     * ⚠ THE CLIPBOARD MAY SIMPLY NOT BE THERE. `navigator.clipboard` is undefined on an insecure
     * origin - which is exactly how this app runs from `file://` - and a permission prompt can be
     * refused. Both are EXPECTED, not defects: the code is on screen and can be read straight off
     * it, so the answer is a sentence beside the button. Reporting it would flip `KErrorMode` and
     * blank the step a subscriber is one minute into.
     */
    private OnCopyCode = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        this.CopyCodeTo(nz(this.SignUp.Code), "wac-copied");
    };

    public static readonly ByHand: string = "Select the code above and copy it by hand.";

    /** Writes the existing status line without rebuilding the code the owner is reading. */
    private CopyCodeTo = (Code: string, LineId: string): void => {
        if (Code.length === 0) { return; }
        const Note: AppCodeCopyNote = new AppCodeCopyNote(LineId);
        new AppAssistCopyJob(Code, Note, false, "AppCodeCopy.Start").Start();
    };
    private StopPolling = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.StopWait();
            if (this.PairTimer === 0) { return; }
            window.clearInterval(this.PairTimer);
            this.PairTimer = 0;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.StopPolling");
        }
    };

    /** The phone is linked. ⚠ The Dropbox step needs a URL, which only the service can build. */
    private OnLinked = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.StopPolling();
            this.SignUp.Busy = false;
            this.SignUp.Waiting = false;
            this.SignUp.Code = "";
            this.SignUp.Linked = true;
            this.SignUp.Why = "";
            this.ShowSignUp();
            this.AskDropboxUrl();
            // ⛔ THE KEY IS ASKED FOR NOW, NOT AT "OPEN WACOMMANDER". The number is LIVE from this
            // moment, so `/claim` will refuse it - a subscriber who loses the sign-up secret (a
            // reload, a closed tab) between here and the end would have no way back in at all.
            this.AskEarlyKey();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnLinked");
        }
    };

    // ── 3. Dropbox ───────────────────────────────────────────────────────────────────────────────

    /**
     * ⚠ THE URL IS FETCHED, NEVER BUILT HERE. `DropboxAuth.Scopes` is the single source for what is
     * requested, and a URL assembled in the browser would be a second place for it to drift - a
     * missing scope surfacing months later as a refused upload in front of a subscriber.
     */
    private AskDropboxUrl = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Url: string = AppSignUpApi.UrlFor(this.ServiceUrl, AppSignUpApi.Dropbox);
            new AppSignUpPost(Url, "", this.OnDropboxUrl).Send();
            this.AskOneDriveUrl();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.AskDropboxUrl");
        }
    };

    /**
     * ⭐ WAVE 3 (DORMANT): ask `/onedrive` for Microsoft's page with a fresh state - ONLY on the registered origin (the
     * return comes to https://wa.kalmstrom.com/ and nowhere else). No answer / an older service = no OneDrive offer.
     */
    private AskOneDriveUrl = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.SignUp.OneDriveUrl = "";
            if (AppOneDriveRules.OriginOk(window.location.origin) === false) { return; }
            const Bytes: Uint8Array = new Uint8Array(16);
            window.crypto.getRandomValues(Bytes);
            this.OneDriveState = AppOneDriveRules.StateOf(Bytes);
            const Url: string = AppOneDriveRules.UrlFor(this.ServiceUrl, this.OneDriveState);
            if (Url.length === 0) { return; }
            new AppSignUpPost(Url, "", this.OnOneDriveUrl).Send();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.AskOneDriveUrl");
        }
    };

    private OnOneDriveUrl = (Answer: SignUpAnswer): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (Answer.Ok !== true || /^https:\/\//.test(nz(Answer.Url)) === false) { return; }
            this.SignUp.OneDriveUrl = nz(Answer.Url);
            this.ShowSignUp();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnOneDriveUrl");
        }
    };

    /**
     * "Connect OneDrive": keep {state, number, proof} in THIS tab's sessionStorage, then let the link leave.
     * ⛔ A browser that cannot keep it (blocked storage) does not leave - it could never finish the step on return.
     */
    private OnOneDriveGo = (Ev: Event): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const One: AppOneDrivePending = new AppOneDrivePending();
            One.State = this.OneDriveState; One.Number = nz(this.SignUp.Number);
            One.Secret = nz(this.Secret); One.Key = this.KeyNow(); One.AtMs = Date.now();
            if (One.State.length > 0 && One.Number.length > 0 && AppOneDrivePendingStore.Save(One) === true) { return; }
            Ev.preventDefault();
            this.SignUp.Why = "This browser cannot keep the OneDrive step across Microsoft's page. Use Dropbox, or"
                + " allow this site to store data and try again.";
            this.ShowSignUp();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnOneDriveGo");
        }
    };

    /**
     * Back from Microsoft: the code is taken only when the state matches what THIS tab kept (`ReturnIn`); the query is
     * stripped from the address either way (a code must not sit in the history or be re-sent on a reload).
     * True = this load was a OneDrive return and is handled.
     */
    private OneDriveReturn = (): boolean => {
        if (getCoreUtils().KErrorMode === true) { return false; }
        try {
            if (AppOneDriveRules.ReturnIn(window.location.search, null).Seen === false) { return false; }
            const Kept: AppOneDrivePending | null = AppOneDrivePendingStore.Take();
            const Back: AppOneDriveReturn = AppOneDriveRules.ReturnIn(window.location.search, Kept);
            window.history.replaceState(null, "", window.location.pathname + "#signup");
            if (Kept !== null) {
                this.SignUp.Number = Kept.Number; this.SignUp.Linked = true; this.Secret = Kept.Secret;
                if (Kept.Key.length > 0) { this.SessionKey = Kept.Key; this.SessionNumber = Kept.Number; }
            }
            this.SignUp.Why = Back.Why;
            this.SignUp.Busy = Back.Code.length > 0;
            this.ShowSignUp(true);
            let Body: string = "";
            if (Kept !== null && Back.Code.length > 0) { Body = AppOneDriveRules.GrantBody(Kept, Back.Code); }
            if (Body.length === 0) { this.SignUp.Busy = false; this.AskDropboxUrl(); return true; }
            new AppSignUpPost(AppSignUpApi.UrlFor(this.ServiceUrl, AppOneDriveRules.Route), Body, this.OnOneDriveDone).Send();
            return true;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OneDriveReturn");
            return false;
        }
    };

    /** The grant's answer: the Dropbox step's own path (`OnDropboxDone`), then the OneDrive words. */
    private OnOneDriveDone = (Answer: SignUpAnswer): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.OnDropboxDone(Answer);
            if (AppSignUp.IsGrant(Answer.Ok, Answer.Url) === true) {
                this.SignUp.Storage = "onedrive";
                this.SignUp.Dropbox = "your OneDrive";
                this.ShowSignUp();
                return;
            }
            this.AskDropboxUrl();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnOneDriveDone");
        }
    };

    /**
     * ⚠ NO URL LEAVES `DropboxUrl` EMPTY ON PURPOSE. `AppSignUp.AskDropbox` then renders no button
     * at all and says the fault is ours - which is true, it means the service has no app key - and
     * a dead "Connect" would instead have the visitor pressing it and blaming themselves.
     */
    private OnDropboxUrl = (Answer: SignUpAnswer): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.SignUp.DropboxUrl = "";
            this.SignUp.DropboxAsked = true;
            this.SignUp.Busy = false;
            if (Answer.Ok === true) { this.SignUp.DropboxUrl = nz(Answer.Url); }
            // ⚠ The card changes shape here ("getting the page" -> the step, or -> "not available"), so the
            // focus is placed again rather than left on a control that is gone.
            this.SignUpScreen = "";
            this.ShowSignUp();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnDropboxUrl");
        }
    };

    private OnDropboxCode = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.SignUp.Busy === true) { return; }
            const Box: HTMLInputElement | null =
                document.getElementById("wac-dbxcode") as HTMLInputElement | null;
            if (Box === null) { return; }
            // ⛔ AN EMPTY BOX IS ANSWERED HERE AND NOTHING IS SENT (found in Chrome 2026-10-01). With no code the
            // body is "", the transport then sends a GET, `/dropbox` answers that with `ok` and the Dropbox page's
            // address - and `OnDropboxDone` read it as a finished grant: the sign-up MOVED ON to the history
            // step with no Dropbox connected, to be refused there as "not connected to a Dropbox account yet".
            if (nz(Box.value).trim().length === 0) {
                this.SignUp.DbxTyped = "";
                this.SignUp.Why = AppSignUp.NoCodeWhy;
                this.ShowSignUp();
                return;
            }
            this.SignUp.DbxTyped = nz(Box.value);
            this.SignUp.Why = "";
            this.SignUp.Busy = true;
            this.ShowSignUp();
            const Url: string = AppSignUpApi.UrlFor(this.ServiceUrl, AppSignUpApi.Dropbox);
            // ⚠ THE SECRET WHEN THIS TAB HAS ONE, ELSE THE KEY - the resumed sign-up (`ResumeDropbox`)
            // lost its secret to a reload, and `/dropbox` takes the key while no grant is stored.
            const Body: string = AppSignUpApi.DropboxBody(this.SignUp.Number, this.Secret,
                nz(Box.value), this.KeyNow());
            // ⛔ NO BODY (nothing left to prove this browser with) IS NEVER SENT, for the same reason as the
            // empty box: a GET's answer would read as a finished grant. The service's own sentence for it.
            if (Body.length === 0) { this.OnDropboxDone(AppSignUpApi.No(AppAccount.LeaveStaleWhy)); return; }
            new AppSignUpPost(Url, Body, this.OnDropboxDone).Send();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnDropboxCode");
        }
    };

    /**
     * "Try again" on "Dropbox is not available": ask the service for the Dropbox page once more.
     * ⚠ SAFE TO REPEAT - it reads an address and changes nothing (unlike asking for a pairing code).
     */
    private OnDropboxRetry = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.SignUp.Busy === true) { return; }
            this.SignUp.Busy = true;
            this.SignUp.Why = "";
            this.ShowSignUp();
            this.AskDropboxUrl();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnDropboxRetry");
        }
    };

    /**
     * ⚠ AN ACCEPTED GRANT WITH NO ACCOUNT NAME STILL ADVANCES. The label is cosmetic and the
     * service says so; refusing over it would throw away a working connection and send the
     * subscriber round the whole Dropbox detour again.
     */
    private OnDropboxDone = (Answer: SignUpAnswer): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.SignUp.Busy = false;
            // ⚠ A Dropbox code works once, so it is not offered back - refused or accepted.
            this.SignUp.DbxTyped = "";
            // ⛔ `ok` WITH THE DROPBOX PAGE'S ADDRESS IS NOT A GRANT (`AppSignUp.IsGrant`) - the third guard on the
            // way to the history step, behind the two in `OnDropboxCode` that keep that request from being sent.
            if (AppSignUp.IsGrant(Answer.Ok, Answer.Url) === false) {
                this.SignUp.Why = AppMain.WhyIn(Answer);
                if (Answer.Ok === true) { this.SignUp.Why = AppSignUp.NoCodeWhy; }
                this.ShowSignUp();
                return;
            }
            this.SignUp.Dropbox = AppMain.AccountIn(Answer);
            // ⭐ Does this service keep what WhatsApp hands over at linking? It chooses the "no backup" words (a flag).
            this.SignUp.LinkHistory = Answer.History === true;
            this.SignUp.Why = "";
            this.ShowSignUp();
            // ⚠ AGAIN HERE, because `/folder` answers a key only alongside a ticket, and a ticket
            // needs the Dropbox grant that has only now landed. Skipped when the page already holds
            // one - each mint adds to a five-entry list and would evict another of their devices.
            this.AskEarlyKey();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnDropboxDone");
        }
    };

    /**
     * ⛔ A BLANK ACCOUNT MUST NOT BE STORED, because `StepFor` reads `Dropbox` as the FACT that
     * storage is connected - and "" would send a connected subscriber back to the Dropbox step for
     * ever, on a grant that already worked.
     */
    private static AccountIn = (Answer: SignUpAnswer): string => {
        if (getCoreUtils().KErrorMode === true) { return "your Dropbox"; }
        try {
            if (nz(Answer.Account).trim().length > 0) { return nz(Answer.Account).trim(); }
            return "your Dropbox";
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.AccountIn");
            return "your Dropbox";
        }
    };

    // ── 4. The history ───────────────────────────────────────────────────────────────────────────

    /**
     * "I use an iPhone / have no backup": go on without an import.
     *
     * ⚠ IT RECORDS A FACT AND RE-DERIVES THE STEP - it does not jump to "done". `StepFor` reads
     * `SkippedImport` exactly as it reads `Imported`, so the wizard stays derived.
     *
     * ⛔ A HALF-FINISHED IMPORT IS DROPPED, NOT KEPT FOR LATER. A chosen file and, worse, an unlocked
     * database are every message the subscriber has; holding them on a page that has just been told
     * "no import" would keep plaintext in memory for nothing. ⚠ Refused while busy: skipping in the
     * middle of an unlock would race the upload that is about to report `Imported`.
     */
    // REUSE-JUSTIFIED: the statements `OnRepick` shares are in ONE member, `DropPick(Skipped)`. What is left in both
    // is the mandated guard + try/catch around one call, each a click handler `Wire` attaches by its own name
    // ("wac-skipimport" / `AppSignUp.RepickId`) and each reporting under its own label.
    private OnSkipImport = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.DropPick(true);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnSkipImport");
        }
    };

    /**
     * The subscriber chose a file on this device.
     *
     * ⛔ THIS USED TO OPEN THE GOOGLE PICKER, AND THE MISMATCH WAS A DEAD END NOBODY COULD GET PAST.
     * `wac-pick` became an `<input type="file">` when the import moved to the browser, and this
     * handler was left calling `AppPicker.Refusal` - so choosing the backup answered "Choosing a
     * file from Drive is not set up on this copy of WACommander yet" in red, and DISCARDED the file.
     * Measured on the live page 2026-09-23, at the last step of the owner's own sign-up.
     *
     * ⚠ A CANCEL IS SILENT. A file input fires `change` only on a real choice, but a cleared one is
     * possible, and putting a refusal on screen because somebody changed their mind would be the
     * page telling them off for using it.
     */
    private OnSignUpPick = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Box: HTMLInputElement | null =
                document.getElementById("wac-pick") as HTMLInputElement | null;
            if (Box === null || Box.files === null || Box.files.length === 0) { return; }
            const One: File = Box.files[0];
            const Chosen: PickedFile = new PickedFile();
            Chosen.Name = nz(One.name);
            Chosen.Bytes = Number(One.size);
            Chosen.Data = One;
            // ⛔ A NEW CHOICE ENDS ANY LOOK STILL IN FLIGHT. Without this, a `.crypt15` picked while an
            // earlier file was being read was REPLACED by that file's verdict a moment later
            // (`OnSniffed` matched the old file against the old `Sniffed`).
            this.Sniffed = null;
            // ⭐ ANYTHING THAT IS NOT AN ENCRYPTED ANDROID BACKUP IS LOOKED INTO (`ImportPlain`): an
            // iPhone's database has a hashed name and no extension, so only its contents can say what it
            // is. A `.crypt15` goes on exactly as before.
            if (ImportPlainRules.NeedsSniff(Chosen.Name) === true) {
                this.Sniffed = Chosen;
                new AppPlainSniff(One, Chosen.Name, this.OnSniffed).Start();
                return;
            }
            this.OnSignUpPicked(Chosen, "");
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnSignUpPick");
        }
    };

    /** The file `AppPlainSniff` is looking into. A second pick replaces it. */
    private Sniffed: PickedFile | null = null;

    /**
     * What the page found inside the chosen file: a WhatsApp database that needs no key, or the
     * sentence saying what it is instead (validation - shown, never reported).
     * ⛔ AN ANSWER ABOUT A FILE THAT IS NO LONGER THE CHOSEN ONE IS DROPPED (`File` is the object that
     * was read): a second pick made while the first was being read must not inherit its verdict.
     */
    private OnSniffed = (Verdict: PlainVerdict, File: Blob): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Chosen: PickedFile | null = this.Sniffed;
            if (Chosen === null || Chosen.Data !== File) { return; }
            this.Sniffed = null;
            if (Verdict.Ok !== true) { this.OnSignUpPicked(null, nz(Verdict.Why)); return; }
            Chosen.Plain = nz(Verdict.Kind);
            this.OnSignUpPicked(Chosen, "");
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnSniffed");
        }
    };

    /**
     * "Import" on a database that needs no key: straight to the storage ticket and the upload.
     *
     * ⭐ THE FILE IS HANDED ON AS A `Blob`, NEVER READ INTO MEMORY - `AppDropboxUpload` streams it from
     * the disk in pieces, so its size is the service's limit and not this tab's.
     */
    private OnPlainImport = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.Picked === null || this.SignUp.Busy === true) { return; }
            const Data: Blob | null = (this.Picked as PickedFile).Data;
            if (Data === null || nz((this.Picked as PickedFile).Plain).length === 0) { return; }
            this.SignUp.Busy = true;
            this.SignUp.Why = "";
            this.DropUploadStatus();
            this.ShowSignUp();
            this.OnUnlocked(Data, "");
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnPlainImport");
        }
    };

    /** "Choose a different file": back to the file box, nothing kept. Refused while a transfer runs. */
    // REUSE-JUSTIFIED: the statements `OnSkipImport` shares are in ONE member, `DropPick(Skipped)`. What is left in
    // both is the mandated guard + try/catch around one call, each a click handler `Wire` attaches by its own name
    // (`AppSignUp.RepickId` / "wac-skipimport") and each reporting under its own label.
    private OnRepick = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.DropPick(false);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnRepick");
        }
    };

    /**
     * The chosen file, an unlocked database and their sentence are dropped and the card is drawn again
     * (`OnRepick`, `OnSkipImport`). ⚠ Refused while a transfer runs. `Skipped` = "go on without an import":
     * the FACT is recorded before the paint, so `StepFor` derives the next step from it.
     */
    private DropPick = (Skipped: boolean): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.SignUp.Busy === true) { return; }
            this.Picked = null;
            this.Plain = null;
            this.SignUp.PickedName = "";
            this.SignUp.PickedKind = "";
            this.SignUp.Why = "";
            if (Skipped === true) { this.SignUp.SkippedImport = true; }
            this.ShowSignUp();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.DropPick");
        }
    };

    /**
     * Unlock the chosen backup, then send the database to their Dropbox.
     *
     * ⛔ THE KEY IS READ OFF THE ELEMENT AND NEVER STORED. It is not kept on `SignUp`, because that
     * object is re-rendered, inspected and passed around; the key lives for the length of this run
     * and the box is the only place it ever sat.
     *
     * ⛔ AND IT IS CLEARED THE MOMENT THE RUN OWNS IT - a 64-digit backup key left in a field of a
     * long-lived object survives into every later state, every re-render, and anything that ever
     * inspects the app.
     */
    private OnSignUpUnlock = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Box: HTMLInputElement | null =
                document.getElementById("wac-key") as HTMLInputElement | null;
            if (Box === null || this.Picked === null) { return; }
            const Data: Blob | null = (this.Picked as PickedFile).Data;
            if (Data === null) { return; }
            const Key: string = Box.value;
            Box.value = "";
            this.SignUp.Busy = true;
            this.SignUp.Why = "";
            this.DropUploadStatus();
            this.ShowSignUp();
            new AppUnlockRun(Data as Blob, Key, this.OnImportStep, this.OnUnlocked).Start();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnSignUpUnlock");
        }
    };

    /**
     * Unlocked. Ask the service for somewhere to put it.
     *
     * ⛔ THE TICKET IS ASKED FOR AFTER THE UNLOCK, NOT BEFORE, AND THE ORDER IS THE SPACE CHECK'S.
     * The service compares the size against the subscriber's free Dropbox, and the only size that
     * matters is the size of the DATABASE - the `.crypt15` on disk is deflated, so checking room
     * for it would clear an upload that does not fit.
     */
    private OnUnlocked = (Db: Uint8Array | Blob | null, Why: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (Db === null) { this.OnImportDone(nz(Why)); return; }
            this.Plain = Db;
            this.OnImportStep("Finding room in your Dropbox…", -1);
            const Url: string = AppSignUpApi.UrlFor(this.ServiceUrl, AppSignUpApi.Storage);
            // ⛔ THE SECRET COMES OFF `this`, NOT OFF `SignUp`. `SignUpState` is handed to the
            // renderer and stringified into the page's markup; the session secret is a bearer
            // credential for this subscriber's storage and lives in a field of this object only.
            // ⚠ "IMPORT A BACKUP" SENDS THE KEY ONLY: a secret this tab still holds from sign-up
            // expires in two hours and would win (`AppSignUpApi.WithProof`), refusing a subscriber
            // whose key is perfectly good. Sign-up sends its secret, or the key once it lost it.
            let Secret: string = nz(this.Secret);
            if (this.ImportLater === true) { Secret = ""; }
            const Body: string = AppSignUpApi.StorageBody(nz(this.SignUp.Number), Secret,
                AppDropboxUpload.SizeOf(Db), this.KeyNow());
            new AppSignUpPost(Url, Body, this.OnStorageTicket).Send();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnUnlocked");
        }
    };

    /**
     * ⛔ A REFUSED TICKET ENDS THE RUN AND DROPS THE DATABASE. Holding the plaintext in memory to
     * "retry later" would leave every message the subscriber has on a page that may sit open for
     * hours; they still have the file, and starting the step again costs one unlock.
     */
    private OnStorageTicket = (Answer: SignUpAnswer): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Db: Uint8Array | Blob | null = this.Plain;
            // ⭐ WAVE 3: a OneDrive archive answers an upload ADDRESS for the one file, no token.
            if (Answer.Ok === true && nz(Answer.UploadUrl).length > 0 && Db !== null) {
                this.Plain = null;
                this.UploadingOne = new AppOneDriveUpload(nz(Answer.UploadUrl), Db, this.OnImportStep, this.OnImportDone);
                (this.UploadingOne as AppOneDriveUpload).Start();
                return;
            }
            if (Answer.Ok !== true || nz(Answer.Token).length === 0 || Db === null) {
                this.Plain = null;
                this.OnImportDone(nz(Answer.Why));
                return;
            }
            this.Plain = null;
            // ⚠ KEPT, so the `rev` Dropbox gives the finished upload can be read in `OnImportDone`.
            this.Uploading = new AppDropboxUpload(nz(Answer.Token), AppMain.PathIn(Answer), Db,
                this.OnImportStep, this.OnImportDone);
            (this.Uploading as AppDropboxUpload).Start();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnStorageTicket");
        }
    };

    /**
     * ⚠ THE SERVICE NAMES THE PATH; THE FALLBACK EXISTS SO AN OLDER SERVICE IS NOT A DEAD END.
     * Both constants are the same string and a Bridge test pins them together, so the fallback is
     * a belt on a brace rather than a second answer.
     *
     * DOCUMENTED EXCEPTION: picks between two values in hand.
     * ERROR-SUPPRESSED-JUSTIFIED: pure helper, called only from a guarded method.
     */
    private static PathIn = (Answer: SignUpAnswer): string => {
        if (nz(Answer.Path).length > 0) { return nz(Answer.Path); }
        return DropboxIoRules.UploadPath;
    };

    /**
     * ⚠ THE PROGRESS LINE IS PAINTED DIRECTLY, NOT THROUGH A RE-RENDER. Re-rendering the step on
     * every percentage would destroy and rebuild the key box mid-run, and a phone keyboard closing
     * repeatedly during a two-minute upload is its own kind of broken.
     */
    private OnImportStep = (Say: string, Percent: number): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const El: HTMLElement | null = document.getElementById("wac-progress");
            if (El === null) { return; }
            // ⚠ The runs' own sentences end in the ellipsis character; DesignSystem.test.ts bans three typed dots.
            let Text: string = Say;
            if (Percent >= 0) { Text = Text + " " + String(Percent) + "%"; }
            El.textContent = Text;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnImportStep");
        }
    };

    private OnImportDone = (Why: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.SignUp.Busy = false;
            this.SignUp.Why = Why;
            if (Why.length === 0) { this.SignUp.Imported = true; }
            let Rev: string = "";
            if (this.Uploading !== null) { Rev = nz((this.Uploading as AppDropboxUpload).Rev); }
            this.Uploading = null;
            // ⭐ THE UPLOAD IS ONLY HALF OF IT (2026-10-01): the SERVICE imports the file, and may refuse it. The
            // card now stays and says what becomes of it (`AppImportStatus`); `OnImportShown` takes "Import a
            // backup" back to the main screen once it IS imported, with the result.
            let Watched: boolean = false;
            if (Why.length === 0) { Watched = this.WatchUpload(Rev); }
            // ⚠ NOTHING TO ASK ABOUT (an older service's upload answer, no service): "Import a backup" ends on
            // the main screen with the done card's own sentence, as before. The SIGN-UP's import does not jump:
            // its done step is the "Open WACommander" step.
            if (Why.length === 0 && this.ImportLater === true && Watched === false) {
                this.BackToMain("Backup uploaded. " + AppSignUp.LaterDoneWords());
                return;
            }
            this.ShowSignUp();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnImportDone");
        }
    };

    private OnSignUpPicked = (File: PickedFile | null, Why: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (File === null) {
                if (Why.length > 0) { this.SignUp.Why = Why; this.ShowSignUp(); }
                return;
            }
            // ⚠ NO "OLDER SNAPSHOT" REFUSAL ANY MORE: the service keeps every backup that holds
            // something the others do not (`ArchiveSet` in the Bridge), so a dated file is safe.
            const No: string = ImportGate.FileRefusal(File);
            this.SignUp.Why = No;
            if (No.length === 0) {
                this.SignUp.PickedName = File.Name;
                this.SignUp.PickedKind = nz(File.Plain);
                this.Picked = File;
            }
            this.ShowSignUp();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnSignUpPicked");
        }
    };

    /** How often the top bar's "updated 12 min ago" and the connection dot are brought up to date. */
    public static readonly StatusEveryMs: number = 15000;

    /** The top bar's connection line, from what this page knows (`AppTopBarRules.Status`). */
    private ShowStatus = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            let Health: string = AppTopBarRules.Off;
            // ⭐ TRUTHFUL TOP BAR: what the SERVICE says about WhatsApp (`AppWaLink`), the standing the band shows, and how
            // the feed itself is doing - `StatusWith` makes one line of them (a service that does not say = `Status`).
            const Link: AppTopLink = new AppTopLink();
            if (this.ListFeed !== null) {
                const Feed: AppLiveList = this.ListFeed as AppLiveList;
                Health = Feed.Health();
                Link.Wa = Feed.WaNow();
                Link.Standing = Feed.StandingNow().State;
                Link.FailingMs = Feed.FailingMs();
                Link.Waiting = Feed.IsWaiting();
            }
            this.TopBar.Status(AppTopBarRules.StatusWith(this.Index.Loaded, Health, navigator.onLine !== false,
                this.Index.BuiltIso, Date.now(), Link));
            this.StandingBar.Refresh(Date.now());
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.ShowStatus");
        }
    };

    /** The Chats view's search in the top bar: made (and wired) once, then shown again with its count up to date. */
    private ShowBarSearch = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.TopBar.Mounted === false) { return; }
            const Made: HTMLInputElement | null = this.TopBar.ShowSearch(true, AppViews.SearchBox(this.Index, this.Filter));
            if (Made !== null) { return; }
            const Found: HTMLElement | null = document.getElementById(AppViews.FoundId);
            if (Found !== null) { Found.textContent = AppViews.FoundText(this.Index, this.Filter, this.IncludeNativeChat); }
            const Box: HTMLInputElement | null = document.getElementById(AppViews.FindId) as HTMLInputElement | null;
            if (Box !== null && document.activeElement !== Box && Box.value !== this.Filter) { Box.value = this.Filter; }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.ShowBarSearch");
        }
    };

    private Paint = (Html: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.Where === null) { return; }
            // ⚠ THE WHOLE PAGE: the three panes (if they were up) go, and with them the wide layout's rules on <html>.
            this.Three.Leave(this.ThreeDoc);
            this.Where.innerHTML = Html;
            this.MarkRail();
            this.AttachNativeChatViews();
            // ⭐ The bar's search belongs to the Chats view only - `List` shows it again after its paint.
            this.TopBar.ShowSearch(false, "");
            this.Footer();
            this.ShowStatus();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.Paint");
        }
    };

    // ── The early key (sign-up) ──────────────────────────────────────────────────────────────────

    /**
     * Ask `/folder` for a durable key while the sign-up secret is still in hand.
     *
     * ⚠ NOTHING IS PAINTED, WHATEVER THE ANSWER. The sign-up card is the visitor's screen; this is a
     * safety net underneath it, and a refusal here ("no Dropbox yet") is expected on the first ask.
     */
    private AskEarlyKey = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.SessionKey.length > 0) { return; }
            const Body: string = AppSignUpApi.FolderBody(this.SignUp.Number, this.Secret, "");
            const Url: string = AppSignUpApi.UrlFor(this.ServiceUrl, AppSignUpApi.Folder);
            if (Body.length === 0 || Url.length === 0) { return; }
            new AppSignUpPost(Url, Body, this.OnEarlyKey).Send();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.AskEarlyKey");
        }
    };

    /**
     * ⚠ A KEY IS KEPT WHETHER OR NOT THE ANSWER IS `ok` - the service may mint one and still refuse
     * the ticket (no Dropbox yet); the key is what matters here, not the ticket.
     */
    private OnEarlyKey = (Answer: SignUpAnswer): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (nz(Answer.Key).length === 0) { return; }
            this.SessionKey = nz(Answer.Key);
            this.SessionNumber = nz(this.SignUp.Number);
            AppArchiveStore.Save(this.SessionNumber, this.SessionKey);
            this.Footer();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnEarlyKey");
        }
    };

    // ── Sign in on a new device (`#signin`) ──────────────────────────────────────────────────────

    private ShowSignIn = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Shell(false);
            if (nz(this.SignIn.Number).length === 0) { this.SignIn.Number = AppArchiveStore.Number(); }
            this.Paint(AppAccountViews.SignIn(this.SignIn));
            AppEventTarget.OnClick(AppAccountViews.SignInGoId, this.OnSignInPress, "AppMain.On");
            this.AskSignInUrl();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.ShowSignIn");
        }
    };

    /** ⚠ ONCE PER PAGE - the Dropbox page does not change, and a repaint must not re-ask. */
    private AskSignInUrl = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.SignInAsking === true || this.SignIn.Asked === true) { return; }
            this.SignInAsking = true;
            const Url: string = AppSignUpApi.UrlFor(this.ServiceUrl, AppSignUpApi.SignIn);
            new AppSignUpPost(Url, "", this.OnSignInUrl).Send();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.AskSignInUrl");
        }
    };

    private OnSignInUrl = (Answer: SignUpAnswer): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.SignInAsking = false;
            this.SignIn.Asked = true;
            this.SignIn.Url = "";
            this.SignIn.UrlWhy = "";
            if (Answer.Ok === true && nz(Answer.Url).length > 0) { this.SignIn.Url = nz(Answer.Url); }
            else { this.SignIn.UrlWhy = AppMain.WhyIn(Answer); }
            if (AppMain.RouteIs(AppAccount.SignInRoute) === true) { this.RepaintSignIn(); }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnSignInUrl");
        }
    };

    /**
     * ⚠ THE NUMBER TYPED SO FAR SURVIVES A REPAINT - it is read back into the state first, so an
     * answer arriving while somebody types does not throw their typing away.
     */
    private RepaintSignIn = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Box: HTMLInputElement | null =
                document.getElementById(AppAccountViews.SignInNumberId) as HTMLInputElement | null;
            if (Box !== null) { this.SignIn.Number = nz(Box.value); }
            const Had: string = this.FocusedId();
            this.Paint(AppAccountViews.SignIn(this.SignIn));
            AppEventTarget.OnClick(AppAccountViews.SignInGoId, this.OnSignInPress, "AppMain.On");
            this.Refocus(Had);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.RepaintSignIn");
        }
    };

    /** After a repaint of an account card: the focus goes back to the control that had it (by id), if it is still there. */
    private Refocus = (Had: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (Had.length === 0) { return; }
            const El: HTMLElement | null = document.getElementById(Had);
            if (El === null) { return; }
            El.focus();
            this.PutCaret(El);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.Refocus");
        }
    };

    private OnSignInPress = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.SignIn.Busy === true) { return; }
            const Num: HTMLInputElement | null =
                document.getElementById(AppAccountViews.SignInNumberId) as HTMLInputElement | null;
            const Code: HTMLInputElement | null =
                document.getElementById(AppAccountViews.SignInCodeId) as HTMLInputElement | null;
            if (Num === null || Code === null) { return; }
            this.SignIn.Number = nz(Num.value).trim();
            const Body: string = AppSignUpApi.SignInBody(this.SignIn.Number, nz(Code.value));
            const Url: string = AppSignUpApi.UrlFor(this.ServiceUrl, AppSignUpApi.SignIn);
            // ⚠ VALIDATION IN THE PAGE ONLY FOR "NOTHING TYPED" - whether the number is a number is
            // the service's question (one decider, `TenantRoster.KeyOf`).
            if (Body.length === 0) {
                this.SignIn.Why = "Type your WhatsApp number and paste the code Dropbox showed you.";
                this.RepaintSignIn();
                return;
            }
            this.SignIn.Why = "";
            this.SignIn.Busy = true;
            this.RepaintSignIn();
            new AppSignUpPost(Url, Body, this.OnSignedIn).Send();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnSignInPress");
        }
    };

    /**
     * ⛔ ONLY `ok` WITH A KEY IS A SIGN-IN. Anything else keeps the number, clears the code (a
     * Dropbox code is single-use) and shows the service's sentence.
     *
     * ⚠ THE SERVICE'S NORMALISED NUMBER IS STORED, not the typed one - `/folder` addresses the
     * archive by E.164, and "+46 73 ..." with spaces would be a number with no archive.
     */
    private OnSignedIn = (Answer: SignUpAnswer): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.SignIn.Busy = false;
            if (Answer.Ok !== true || nz(Answer.Key).length === 0) {
                this.SignIn.Why = AppMain.WhyIn(Answer);
                this.RepaintSignIn();
                return;
            }
            this.SessionNumber = AppAccount.First(Answer.Number, this.SignIn.Number);
            this.SessionKey = nz(Answer.Key);
            AppArchiveStore.Save(this.SessionNumber, this.SessionKey);
            this.OpenSignedIn();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnSignedIn");
        }
    };

    /**
     * Open the archive with the key just earned, through the ordinary stored-key path.
     *
     * ⚠ A SIGN-UP LEFT IN THIS TAB IS DROPPED FIRST: `NumberNow` prefers `SignUp.Number`, and a
     * stale one would address `/folder` for somebody else. ⚠ `replaceState`, not `location.hash`:
     * the route changes without a `hashchange` racing the request `OpenArchive` is about to make.
     */
    private OpenSignedIn = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            // ⛔ THE PAIRING POLL ENDS WITH THE SIGN-UP IT BELONGED TO. Left running, its next tick had no secret to
            // send, so it went out as a GET, was read as a refusal, and painted the sign-up card over the archive.
            this.StopPolling();
            this.SignUp = new SignUpState();
            this.Secret = "";
            this.Opening = false;
            this.Index = new AppIndex();
            this.SignIn = new AppSignInState();
            window.history.replaceState(null, "", "#chats");
            this.OpenArchive();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OpenSignedIn");
        }
    };

    // ── Close my account (`#leave`) ──────────────────────────────────────────────────────────────

    private ShowLeave = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Shell(false);
            let Done: boolean = this.Leaving.Answer !== null
                && (this.Leaving.Answer as AppLeaveAnswer).Left === true;
            // ⚠ A CLOSED ACCOUNT FOLLOWED BY A NEW SIGN-IN IS A NEW ACCOUNT: forget the old answer.
            if (Done === true && this.KeyNow().length > 0) { this.Leaving = new AppLeaveState(); Done = false; }
            if (this.Leaving.Busy === false && Done === false) {
                this.Leaving.Target = "";
                if (this.KeyNow().length > 0) { this.Leaving.Target = this.NumberNow(); }
            }
            this.PaintLeave();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.ShowLeave");
        }
    };

    private PaintLeave = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Had: string = this.FocusedId();
            this.Paint(AppAccountViews.Leave(this.Leaving));
            this.Refocus(Had);
            const Box: HTMLElement | null = document.getElementById(AppAccountViews.LeaveBoxId);
            if (Box !== null) { Box.addEventListener("input", this.OnLeaveTyped); }
            AppEventTarget.OnClick(AppAccountViews.LeaveGoId, this.OnLeavePress, "AppMain.On");
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.PaintLeave");
        }
    };

    /** ⚠ THE BUTTON IS SWITCHED IN PLACE, never by a repaint - a repaint per keystroke would take
     *  the caret out of the box and close a phone's keyboard after every digit. */
    private OnLeaveTyped = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Box: HTMLInputElement | null =
                document.getElementById(AppAccountViews.LeaveBoxId) as HTMLInputElement | null;
            const Go: HTMLButtonElement | null =
                document.getElementById(AppAccountViews.LeaveGoId) as HTMLButtonElement | null;
            if (Box === null || Go === null) { return; }
            this.Leaving.Typed = nz(Box.value);
            Go.disabled = AppAccount.MayLeave(this.Leaving) === false;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnLeaveTyped");
        }
    };

    /** ⛔ `MayLeave` IS ASKED AGAIN HERE - a disabled button is a hint, not a guard. */
    private OnLeavePress = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (AppAccount.MayLeave(this.Leaving) === false) { return; }
            const Url: string = AppSignUpApi.UrlFor(this.ServiceUrl, AppAccount.LeavePath);
            const Body: string = AppSignUpApi.LeaveBody(this.Leaving.Target, this.KeyNow(),
                this.Leaving.Typed);
            if (Url.length === 0) { this.OnLeaveAnswer(-1, ""); return; }
            if (Body.length === 0) { this.OnLeaveAnswer(-2, ""); return; }
            this.Leaving.Busy = true;
            this.PaintLeave();
            new AppAccountPost(Url, Body, this.OnLeaveAnswer).Send();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnLeavePress");
        }
    };

    /**
     * ⛔ THE KEY IS FORGOTTEN ONLY WHEN THE ACCOUNT IS CLOSED, OR WHEN THE SERVICE SAYS IT IS NO
     * LONGER ANY GOOD. A partial leave KEEPS it: it is the only thing that authorises the retry, and
     * forgetting it would lock somebody out of their own exit - `LeaveRules`' step 6, from this side.
     *
     * ⚠ -1 / -2 ARE THIS PAGE'S OWN "COULD NOT EVEN ASK": no service configured, or nothing to prove
     * the browser with. Both say so in the same ink as every other answer.
     */
    private OnLeaveAnswer = (Status: number, Text: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Leaving.Busy = false;
            let Answer: AppLeaveAnswer = AppAccount.ParseLeave(Status, Text, AppSignUpApi.OursWhy());
            if (Status === -1) { Answer = AppAccount.NoLeave(AppSignUpApi.NoServiceWhy()); }
            if (Status === -2) { Answer = AppAccount.NoLeave(AppAccount.LeaveStaleWhy); }
            this.Leaving.Answer = Answer;
            if (Answer.Left === true || AppAccount.IsStale(Answer) === true) { this.ForgetBrowser(); }
            if (Answer.Left !== true && AppAccount.IsStale(Answer) === true) { this.Leaving.Target = ""; }
            this.PaintLeave();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnLeaveAnswer");
        }
    };

    /** Drop every trace of the account this browser was signed in to. */
    private ForgetBrowser = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            AppArchiveStore.Forget();
            // ⛔ The remembered upload ("wac.import.upload") is a trace of the account too, and its watch must stop.
            if (this.Imports !== null) { (this.Imports as AppImportPanel).Forget(); }
            AppImportPanel.ForgetHere();
            this.SessionKey = "";
            this.SessionNumber = "";
            this.StopPolling();
            this.SignUp = new SignUpState();
            this.Secret = "";
            this.StopRelink();
            this.Relink = new AppRelinkState();
            this.Index = new AppIndex();
            this.Source = new AppLocalSource("");
            this.Opening = false;
            this.IsOwner = false;
            this.Claude = new AppClaudeState();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.ForgetBrowser");
        }
    };

    // ── The owner's Claude analysis panel (`#claude`) ────────────────────────────────────────────

    /**
     * Paint the panel and ask the service whether a token is stored.
     *
     * ⚠ THE SERVICE DECIDES WHO SEES THE FORM, NOT THIS PAGE. Anybody can type `#claude`; the form
     * appears only after a status answer for this browser's key, and everybody else sees the
     * service's one neutral sentence (`ClaudeTokenRules.NeutralWhy`).
     */
    private ShowClaude = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Shell(false);
            const Url: string = AppSignUpApi.UrlFor(this.ServiceUrl, AppClaudeToken.Path);
            const Body: string = AppClaudeToken.StatusBody(this.NumberNow(), this.KeyNow());
            this.Claude = new AppClaudeState();
            if (Url.length === 0) { this.Claude.Why = AppSignUpApi.NoServiceWhy(); this.PaintClaude(); return; }
            if (Body.length === 0) { this.Claude.Why = AppMain.NotSignedInWhy(); this.PaintClaude(); return; }
            this.Claude.Busy = true;
            this.PaintClaude();
            new AppAccountPost(Url, Body, this.OnClaudeStatus).Send();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.ShowClaude");
        }
    };

    private PaintClaude = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            // ⚠ A browser with no key gets the two ways in under the sentence (it had nothing to press).
            let Ways: string = "";
            if (this.KeyNow().length === 0) { Ways = AppAccountViews.WaysIn(); }
            const Had: string = this.FocusedId();
            this.Paint(AppClaudeView.Panel(this.Claude, Ways));
            AppEventTarget.OnClick(AppClaudeView.GoId, this.OnClaudeSave, "AppMain.On");
            this.Refocus(Had);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.PaintClaude");
        }
    };

    // REUSE-JUSTIFIED: the reading IS shared (`AppClaudeToken.Read`). `OnClaudeSaved` differs in what the answer does:
    // `TakeStatus` (what is stored, when) vs `TakeSave`, and only a save that worked goes back to the main screen.
    private OnClaudeStatus = (Status: number, Text: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Answer: AppClaudeAnswer = AppClaudeToken.Read(Status, Text, AppSignUpApi.OursWhy());
            AppClaudeToken.TakeStatus(this.Claude, Answer);
            this.PaintClaude();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnClaudeStatus");
        }
    };

    /**
     * ⛔ THE TOKEN LIVES IN ONE LOCAL, FOR ONE REQUEST. It is read from the box, the box is emptied
     * at once (before any check), and it goes into the request body and nowhere else - not the
     * state, not storage. A malformed paste is a sentence in ink, and the box stays empty.
     */
    private OnClaudeSave = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.Claude.Busy === true) { return; }
            const Box: HTMLInputElement | null =
                document.getElementById(AppClaudeView.BoxId) as HTMLInputElement | null;
            if (Box === null) { return; }
            const Token: string = nz(Box.value).trim();
            Box.value = "";
            const Shape: string = AppClaudeToken.ShapeWhy(Token);
            const Url: string = AppSignUpApi.UrlFor(this.ServiceUrl, AppClaudeToken.Path);
            const Body: string = AppClaudeToken.SaveBody(this.NumberNow(), this.KeyNow(), Token);
            if (Shape.length > 0) { this.Claude.Why = Shape; this.Claude.JustSaved = false; this.PaintClaude(); return; }
            if (Url.length === 0 || Body.length === 0) { this.Claude.Why = AppMain.NotSignedInWhy(); this.PaintClaude(); return; }
            this.Claude.Busy = true;
            this.Claude.Why = "";
            this.PaintClaude();
            new AppAccountPost(Url, Body, this.OnClaudeSaved).Send();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnClaudeSave");
        }
    };

    // REUSE-JUSTIFIED: see `OnClaudeStatus` - the shared `Read`, then this answer's own step (`TakeSave`) and the
    // return to the main screen on success (`BackToMain(AppNotice.ClaudeSaved)`).
    private OnClaudeSaved = (Status: number, Text: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Answer: AppClaudeAnswer = AppClaudeToken.Read(Status, Text, AppSignUpApi.OursWhy());
            AppClaudeToken.TakeSave(this.Claude, Answer);
            // ⭐ A SAVE THAT WORKED GOES BACK TO THE MAIN SCREEN AND SAYS SO THERE; a refusal stays
            // on the panel with its sentence, where the next paste goes.
            if (Answer.Ok === true) { this.BackToMain(AppNotice.ClaudeSaved); return; }
            this.PaintClaude();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnClaudeSaved");
        }
    };

    // ── The re-link banner ───────────────────────────────────────────────────────────────────────

    private WireRelink = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            AppEventTarget.OnClick(AppAccountViews.RelinkGoId, this.OnRelinkGo, "AppMain.On");
            AppEventTarget.OnClick(AppAccountViews.RelinkCopyId, this.OnRelinkCopy, "AppMain.On");
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.WireRelink");
        }
    };

    /** ⚠ ONLY THE BANNER IS REPAINTED - a whole-page repaint would reset the search box and the
     *  contact frame under somebody reading them. */
    private PaintRelink = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const El: HTMLElement | null = document.getElementById(AppAccountViews.RelinkId);
            if (El === null) { return; }
            El.outerHTML = AppAccountViews.Relink(this.Relink);
            this.WireRelink();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.PaintRelink");
        }
    };

    /** ⛔ ONE ASK PER PRESS, and the press is refused while one is out or a code is showing. */
    private OnRelinkGo = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.Relink.Busy === true || this.RelinkTimer !== 0) { return; }
            if (this.Relink.Waiting === true || nz(this.Relink.Code).length > 0) { return; }
            const Url: string = AppSignUpApi.UrlFor(this.ServiceUrl, AppSignUpApi.Pair);
            const Body: string = AppAccount.RelinkBody(this.NumberNow(), this.KeyNow(), AppSignUpApi.Ask);
            this.Relink.Why = "";
            if (Body.length === 0) { this.Relink.Why = AppAccount.LeaveStaleWhy; this.PaintRelink(); return; }
            this.Relink.Busy = true;
            this.Relink.Waiting = true;
            this.PaintRelink();
            new AppSignUpPost(Url, Body, this.OnRelinkAsked).Send();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnRelinkGo");
        }
    };

    private OnRelinkAsked = (Answer: SignUpAnswer): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (Answer.Ok !== true) {
                this.Relink.Busy = false;
                this.Relink.Waiting = false;
                this.Relink.Why = AppMain.WhyIn(Answer);
                this.PaintRelink();
                return;
            }
            this.RelinkTimer = window.setInterval(this.OnRelinkPoll, AppMain.PollMs);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnRelinkAsked");
        }
    };

    /** ⛔ `poll` ONLY - an `ask` on a timer would cancel every code it issued. */
    private OnRelinkPoll = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Url: string = AppSignUpApi.UrlFor(this.ServiceUrl, AppSignUpApi.Pair);
            const Body: string = AppAccount.RelinkBody(this.NumberNow(), this.KeyNow(), AppSignUpApi.Poll);
            if (Body.length === 0) { this.StopRelink(); return; }
            new AppSignUpPost(Url, Body, this.OnRelinkState).Send();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnRelinkPoll");
        }
    };

    /** ⚠ The meaning is `AppAccount.RelinkVerdict`'s; this only paints it. The poll keeps running
     *  while a code is shown - the handset finishing the pairing IS the thing it waits to hear. */
    private OnRelinkState = (Answer: SignUpAnswer): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Verdict: string = AppAccount.RelinkVerdict(Answer.Ok, Answer.Linked, Answer.Code,
                Answer.Waiting, Answer.Why, AppSignUpApi.OursWhy());
            if (Verdict === "wait") { return; }
            if (Verdict === "code") {
                if (nz(Answer.Code) === nz(this.Relink.Code)) { return; }
                this.Relink.Code = nz(Answer.Code);
                this.Relink.Waiting = false;
                this.PaintRelink();
                return;
            }
            this.StopRelink();
            this.Relink.Busy = false;
            this.Relink.Waiting = false;
            this.Relink.Code = "";
            if (Verdict === "linked") { this.Relink.Linked = true; this.Relink.Why = ""; }
            else { this.Relink.Why = AppMain.WhyIn(Answer); }
            this.PaintRelink();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnRelinkState");
        }
    };

    private StopRelink = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (this.RelinkTimer === 0) { return; }
            window.clearInterval(this.RelinkTimer);
            this.RelinkTimer = 0;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.StopRelink");
        }
    };

    /** The banner's Copy. ⚠ Same rules as `OnCopyCode`: reads what is on the page, writes nothing,
     *  and an absent clipboard is a sentence, never a fault. */
    private OnRelinkCopy = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        this.CopyCodeTo(nz(this.Relink.Code), AppAccountViews.RelinkCopiedId);
    };
    // ── The Sent tab ─────────────────────────────────────────────────────────────────────────────

    private ShowSent = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Shell(false);
            this.PaintView(AppAccountViews.Relink(this.Relink) + AppViews.ViewHead(AppViews.ViewName(AppAccount.SentRoute))
                + AppAccountViews.SentShell() + this.CenterTabs(AppAccount.SentRoute), "");
            this.WireRelink();
            this.SentSeq = this.SentSeq + 1;
            this.Source.History(new AppSentReader(this, this.SentSeq).OnAnswer);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.ShowSent");
        }
    };

    /**
     * ⚠ A LATE ANSWER TO AN OLDER ASK IS IGNORED, and so is any answer once the page has moved on:
     * both find nothing current to paint into.
     */
    public OnSent = (Seq: number, Answer: AppHistoryAnswer): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (Seq !== this.SentSeq) { return; }
            const Head: HTMLElement | null = document.getElementById(AppAccountViews.SentHeadId);
            const List: HTMLElement | null = document.getElementById(AppAccountViews.SentListId);
            if (Head === null || List === null) { return; }
            const Say: string = AppAccount.Sentence(AppSendHistory.HeadOf(Answer));
            Head.textContent = Say;
            Head.hidden = Say.length === 0;
            List.innerHTML = AppAccountViews.SentRows(AppSendHistory.LinesOf(Answer, Date.now()));
            const Old: HTMLElement | null = document.getElementById(AppAccountViews.SentRetryId);
            if (Old !== null && Old.parentElement !== null) { Old.parentElement.remove(); }
            if (Answer.Waiting !== true) { return; }
            List.insertAdjacentHTML("afterend", AppAccountViews.SentRetry());
            const Retry: HTMLElement | null = document.getElementById(AppAccountViews.SentRetryId);
            if (Retry !== null) { Retry.addEventListener("click", this.OnSentRetry); }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnSent");
        }
    };

    /** ⚠ A LINK TO THE ROUTE ALREADY SHOWING FIRES NO `hashchange`, so the retry is done here. */
    private OnSentRetry = (Ev: Event): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            Ev.preventDefault();
            this.ShowSent();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.OnSentRetry");
        }
    };

    /** ⭐ What the keyboard shortcuts and the palette read (`AppKeys`, wac-keys 2026-09-30) - facts only, never a sender. */
    public KeyFacts = (): AppKeyFacts => {
        if (getCoreUtils().KErrorMode === true) { return new AppKeyFacts(); }
        try {
            const Out: AppKeyFacts = new AppKeyFacts();
            Out.Loaded = this.Index.Loaded;
            Out.Contacts = this.Index.Contacts;
            Out.Filter = this.Filter;
            Out.AskAll = this.IsOwner === true && this.ServiceUrl.length > 0;
            Out.Sent = this.Source.CanHistory();
            return Out;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMain.KeyFacts");
            return new AppKeyFacts();
        }
    };
}

/**
 * Carries which Sent request this is across the history call, so `OnSent` can ignore a stale one.
 * A named class rather than a closure - house rule.
 */
class AppSentReader {
    private Owner: AppMain;
    private Seq: number;

    public constructor(Owner: AppMain, Seq: number) {
        this.Owner = Owner;
        this.Seq = Seq;
    }

    public OnAnswer = (Answer: AppHistoryAnswer): void => {
        // ERROR-SUPPRESSED-JUSTIFIED: no KErrorMode guard - the page is waiting on this answer, and
        // `OnSent` carries its own.
        try {
            this.Owner.OnSent(this.Seq, Answer);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppSentReader.OnAnswer");
        }
    };
}

/**
 * Carries a message id across one status request.
 *
 * ⚠ THE ID TRAVELS WITH THE REQUEST so a late answer about an OLDER message is recognised and
 * ignored by `OnSendState`, rather than writing "Sent" under a message that has not gone yet.
 */
class AppSendWatch {
    private Owner: AppMain;
    private Id: string;

    public constructor(Owner: AppMain, Id: string) {
        this.Owner = Owner;
        this.Id = Id;
    }

    public OnState = (Sent: boolean, Final: boolean, Why: string, Unconfirmed: boolean, Extra?: AppSendExtra): void => {
        // ERROR-SUPPRESSED-JUSTIFIED: no KErrorMode guard - the poll chain continues from here, and
        // a silent return would end it with "Sending..." on screen for ever.
        try {
            let Known: AppSendExtra = new AppSendExtra();
            if (Extra !== undefined) { Known = Extra as AppSendExtra; }
            this.Owner.OnSendState(this.Id, Sent, Final, Why, Unconfirmed, Known);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppSendWatch.OnState");
        }
    };
}

/**
 * ⚠ KEPT ALIVE ON PURPOSE. KBuild tree-shakes, and this class is reached only by NAME from the
 * HTML shell - nothing imports it. Without a reference the bundler is entirely correct to delete
 * the app from its own bundle.
 */
const Any: Record<string, unknown> = window as unknown as Record<string, unknown>;
Any.WACApp = AppMain;

/**
 * The composer's way to `/send` (`IComposerSender`) - `AppMain.QueueText`, the one page half of a send.
 */
// REUSE-JUSTIFIED: an interface adapter - it exists so `AppMain`'s private state never crosses into the composer,
// the panel, the bar or the frame; each method is one guarded forward to a DIFFERENT `AppMain` method, so folding them
// would still need one call per method plus a dispatch on a name string (judged an interface pass-through).
class AppSendDoor implements IComposerSender {
    private Owner: AppMain;

    public constructor(Owner: AppMain) {
        this.Owner = Owner;
    }

    public Queue(Text: string, Then: IComposerSent, Translate: string = ""): string {
        const Broken: boolean = getCoreUtils().KErrorMode;
        if (Broken) { return AppComposer.NoSendWhy(); }
        try {
            const Sent: string = this.Owner.QueueText(Text, Then, Translate);
            return Sent;
        } catch (e) {
            const Where: string = "AppSendDoor." + "Queue";
            getCoreUtils().KGlobalErrorHandler(e, Where);
            return AppComposer.NoSendWhy();
        }
    }

    public QueueReaction(MessageId: string, Emoji: string, Then: IComposerSent): string {
        if (getCoreUtils().KErrorMode) { return AppComposer.NoSendWhy(); }
        try {
            const Sent = this.Owner.QueueReaction(MessageId, Emoji, Then) as string;
            return Sent;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppSendDoor." + "QueueReaction");
            return AppComposer.NoSendWhy();
        }
    }

    /** (2026-10-14) A reply / edit / delete - only from `AppComposer.SendAction`, under its latch. */
    public QueueAction = (Kind: string, MessageId: string, Text: string, Then: IComposerSent): string => {
        if (getCoreUtils().KErrorMode.valueOf()) { return AppComposer.NoSendWhy(); }
        try {
            const Sent: string = ((): string => this.Owner.QueueAction(Kind, MessageId, Text, Then))();
            return Sent;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppSendDoor.QueueAction");
            return AppComposer.NoSendWhy();
        }
    };
}

/**
 * The reaction row's way back into the page (`IRxHost`). ⛔ Its `React` is the composer's own sender
 * (`AppMain.ReactVia` -> `AppComposer.SendReaction`), reached only from a click on an emoji.
 */
// REUSE-JUSTIFIED: an interface adapter - it exists so `AppMain`'s private state never crosses into the composer,
// the panel, the bar or the frame; each method is one guarded forward to a DIFFERENT `AppMain` method, so folding them
// would still need one call per method plus a dispatch on a name string (judged an interface pass-through).
class AppReactHost implements IRxHost {
    private Owner: AppMain;

    public constructor(Owner: AppMain) {
        this.Owner = Owner;
    }

    public React = (MessageId: string, Emoji: string, Then: IComposerSent): string => {
        const KError: boolean = getCoreUtils().KErrorMode;
        if (KError === true) { return AppComposer.NoSendWhy(); }
        try {
            return this.Owner.ReactVia(MessageId, Emoji, Then);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppReactHost." + "React");
            return AppComposer.NoSendWhy();
        }
    };

    /** `IRxHost.Act` - a bubble's Reply / Edit / Delete: the composer's mode. Sends nothing. */
    public Act = (Kind: string, MessageId: string, Words: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Owner.ModeAct(Kind, MessageId, Words);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppReactHost.Act");
        }
    };

    public Say = (Text: string, Bad: boolean): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Owner.ReactSay(Text, Bad);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppReactHost.Say");
        }
    };
}

/** Carries which message a reaction was on across `/send`'s answer. A class, not a closure. */
/** The page's half of one reply / edit / delete on its way to `/send`. */
/** The forward picker's one click into the page. */
class AppForwardHost implements IFwHost {
    private Owner: AppMain;
    private Mid: string;

    public constructor(Owner: AppMain, Mid: string) {
        this.Owner = Owner;
        this.Mid = Mid;
    }

    public Picked = (Target: AppForwardTarget): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Owner.ForwardTo(Target, this.Mid);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppForwardHost.Picked");
        }
    };
}

/** A held photo / voice note read from the bubble's own `blob:` URL, as base64, for the attachment path. */
class AppForwardRead {
    private Owner: AppMain;
    private Mid: string;
    private Xhr: XMLHttpRequest = new XMLHttpRequest();

    public constructor(Owner: AppMain, Mid: string) {
        this.Owner = Owner;
        this.Mid = Mid;
    }

    public Begin = (Url: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Xhr.open("GET", Url);
            this.Xhr.responseType = "arraybuffer";
            this.Xhr.addEventListener("load", this.OnLoad);
            this.Xhr.addEventListener("error", this.OnError);
            this.Xhr.send();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppForwardRead.Begin");
        }
    };

    private OnLoad = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Bytes: Uint8Array = new Uint8Array(this.Xhr.response as ArrayBuffer);
            let Bin: string = "";
            for (let At: number = 0; At < Bytes.length; At = At + 1) { Bin = Bin + String.fromCharCode(Bytes[At]); }
            let Mime: string = nz(this.Xhr.getResponseHeader("Content-Type"));
            if (Mime.length === 0) { Mime = "image/jpeg"; }
            let Ext: string = "jpg";
            if (Mime.indexOf("audio/") === 0) { Ext = "ogg"; }
            this.Owner.ForwardSend(this.Mid, { name: "forwarded." + Ext, mime: Mime, data: btoa(Bin), voice: false });
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppForwardRead.OnLoad");
        }
    };

    /** The page's own blob could not be read (the frame was replaced): said, nothing sent. */
    private OnError = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Owner.ReactSay("That photo or voice note is no longer on the page - open the chat again and forward it.", true);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppForwardRead.OnError");
        }
    };
}

class AppActQueue {
    private Owner: AppMain;
    private Kind: string;
    private Text: string;
    private MessageId: string;

    public constructor(Owner: AppMain, Kind: string = "", Text: string = "", MessageId: string = "") {
        this.Owner = Owner;
        this.Kind = Kind;
        this.Text = Text;
        this.MessageId = MessageId;
    }

    /** ERROR-SUPPRESSED-JUSTIFIED: no KErrorMode guard - the send button stays disabled until this lands. */
    public OnQueued = (RequestId: string): void => {
        try {
            this.Owner.OnActQueued(RequestId, this.Kind, this.Text, this.MessageId);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppActQueue.OnQueued");
        }
    };

    /** ERROR-SUPPRESSED-JUSTIFIED: no KErrorMode guard - see `OnQueued`. */
    public OnFailed = (Why: string): void => {
        try {
            this.Owner.OnActFailed(Why);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppActQueue.OnFailed");
        }
    };
}

/** The mode bar's buttons into the page. `Delete` is the bar's click -> `AppComposer.ConfirmDelete`. */
// REUSE-JUSTIFIED: an interface adapter - it exists so `AppMain`'s private state never crosses into the composer,
// the panel, the bar or the frame; each method is one guarded forward to a DIFFERENT `AppMain` method, so folding them
// would still need one call per method plus a dispatch on a name string (judged an interface pass-through).
class AppModeBarHost implements IMaBarHost {
    private Owner: AppMain;

    public constructor(Owner: AppMain) {
        this.Owner = Owner;
    }

    public Close = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Owner.ModeAct("", "", "");
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppModeBarHost.Close");
        }
    };

    public Delete = (): string => {
        if (getCoreUtils().KErrorMode) { return AppComposer.NoSendWhy(); }
        try {
            const Sent: string = this.Owner.ModeDelete();
            return Sent;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppModeBarHost." + "Delete");
            return AppComposer.NoSendWhy();
        }
    };

    public Say = (Text: string, Bad: boolean): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Owner.ReactSay(Text, Bad);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppModeBarHost.Say");
        }
    };
}

class AppReactQueue {
    private Owner: AppMain;
    private Mid: string;
    private Watch: IRxPending | null;

    public constructor(Owner: AppMain, Mid: string, Watch: IRxPending | null = null) {
        this.Owner = Owner;
        this.Mid = Mid;
        this.Watch = Watch;
    }

    /** ERROR-SUPPRESSED-JUSTIFIED: no KErrorMode guard - the send button stays disabled until this lands. */
    public OnQueued = (RequestId: string): void => {
        try {
            this.Owner.OnReactQueued(this.Mid, RequestId, this.Watch);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppReactQueue.OnQueued");
        }
    };

    /** ERROR-SUPPRESSED-JUSTIFIED: no KErrorMode guard - see `OnQueued`. */
    public OnFailed = (Why: string): void => {
        try {
            this.Owner.OnReactFailed(Why);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppReactQueue.OnFailed");
        }
    };
}

/**
 * The AI panel's way back into the page (`IAssistHost`). ⛔ Its `Send` is the composer's own
 * (`AppMain.AssistSend` -> `AppComposer.SendText`), reached only from a draft card's Send click.
 */
// REUSE-JUSTIFIED: an interface adapter - it exists so `AppMain`'s private state never crosses into the composer,
// the panel, the bar or the frame; each method is one guarded forward to a DIFFERENT `AppMain` method, so folding them
// would still need one call per method plus a dispatch on a name string (judged an interface pass-through).
class AppAssistHost implements IAssistHost {
    private LaterPort: AppWindowLater = new AppWindowLater();
    private Owner: AppMain;
    /** The chat this panel belongs to - where its outcomes and its history live. */
    private Href: string;

    public constructor(Owner: AppMain, Href: string) {
        this.Owner = Owner;
        this.Href = Href;
    }

    public Outcome = (Id: string, Outcome: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Owner.AssistOutcome(this.Href, Id, Outcome);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppAssistHost.Outcome");
        }
    };

    /** ⭐ A refusal that clears on its own is asked again after `Ms` (`IAssistHost.Later`). */
    // REUSE-JUSTIFIED: the timer IS shared - `AppWindowLater.Later`. This, `AppTaskHost.Later`, `AppTaskNotifyLink.Later`
    // and `AppAskAllHost.Later` are each ONE class's implementation of its interface's `Later` (`IAssistHost`,
    // `IAppTaskHost`, `IAppNotifyHost`): a clamp and one delegating call inside the mandated shell, own label each.
    public Later = (Ms: number, Then: () => void): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.LaterPort.Later(Math.max(0, Ms), Then);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppAssistHost.Later");
        }
    };

    public ReadHistory = (Done: (Text: string) => void, Missing: () => void, Fail: (Why: string) => void): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Owner.AssistReadHistory(this.Href, Done, Missing, Fail);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppAssistHost.ReadHistory");
        }
    };

    public Post = (Body: string, Done: AppAssistDone): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Owner.AssistPost(Body, Done);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppAssistHost.Post");
        }
    };

    /** ⭐ The streamed question (`AppAssistStreamPost`) - the words appear as they are written. */
    public PostStream = (Body: string, OnText: (Partial: string) => void, Done: AppAssistDone): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Owner.AssistPostStream(Body, OnText, Done);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppAssistHost.PostStream");
        }
    };

    public Send = (Text: string, Then: IComposerSent): string => {
        const Gate: boolean = getCoreUtils().KErrorMode === true;
        if (Gate) { return AppComposer.NoSendWhy(); }
        try {
            const Sent: string = this.Owner.AssistSend(Text, Then);
            return Sent;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppAssistHost." + "Send");
            return AppComposer.NoSendWhy();
        }
    };

    public Fill = (Text: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Owner.AssistFill(Text);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppAssistHost.Fill");
        }
    };

    public Copy = (Text: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Owner.AssistCopy(Text);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppAssistHost.Copy");
        }
    };

    public Answered = (Session: AppAssistSession): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Owner.AssistAnswered(Session);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppAssistHost.Answered");
        }
    };

    /** ⭐ A "Remove from history" ended (`AppAssistForget`). */
    public Forgot = (Session: AppAssistSession, Removed: boolean): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Owner.AssistForgot(Session, Removed);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppAssistHost.Forgot");
        }
    };
}

/** `IAiOutcomeHost` - an outcome's view of the page: the POST, and where a failure is said. */
class AppAiOutcomeLink implements IAiOutcomeHost {
    private Owner: AppMain;

    public constructor(Owner: AppMain) { this.Owner = Owner; }

    public Post = (Body: string, Done: AppAssistDone): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Owner.AssistPost(Body, Done);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppAiOutcomeLink.Post");
        }
    };

    public NotNoted = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Owner.AssistNotNoted();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppAiOutcomeLink.NotNoted");
        }
    };
}

/** `IAppTaskHost` - the task sender's view of the page: the archive proof and the POST. */
class AppTaskHost implements IAppTaskHost {
    private LaterPort: AppWindowLater = new AppWindowLater();
    private Owner: AppMain;

    public constructor(Owner: AppMain) { this.Owner = Owner; }

    /** ⭐ A `retry` refusal's re-send after `Ms` (`IAppTaskHost.Later`). */
    // REUSE-JUSTIFIED: see `AppAssistHost.Later` - this class's `IAppTaskHost.Later` over the shared `AppWindowLater`.
    public Later =(Ms: number, Then: () => void): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.LaterPort.Later(Math.max(0, Ms), Then);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppTaskHost.Later");
        }
    };

    public Phone = (): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            return this.Owner.TaskPhone();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppTaskHost.Phone");
            return "";
        }
    };

    public Key = (): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            return this.Owner.TaskKey();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppTaskHost.Key");
            return "";
        }
    };

    public Post = (Body: string, Done: AppTaskDone): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Owner.TaskPost(Body, Done);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppTaskHost.Post");
        }
    };

    public Confirmed = (Page: string, Task: AppRow): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Owner.TaskConfirmed(Page, Task);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppTaskHost.Confirmed");
        }
    };
}

/** `IAppTaskBoardHost` - the clock, "Reply about this task", and the tab's number. */
class AppTaskBoardLink implements IAppTaskBoardHost {
    private Owner: AppMain;

    public constructor(Owner: AppMain) { this.Owner = Owner; }

    public Now = (): Date => {
        if (getCoreUtils().KErrorMode === true) { return new Date(); }
        try {
            return new Date();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppTaskBoardLink.Now");
            return new Date();
        }
    };

    public ReplyAbout = (Row: AppRow): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Owner.ReplyAbout(Row);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppTaskBoardLink.ReplyAbout");
        }
    };

    public Counted = (Count: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Owner.OnTaskCount(Count);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppTaskBoardLink.Counted");
        }
    };

    public FocusReply = (Href: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Owner.FocusReply(Href);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppTaskBoardLink.FocusReply");
        }
    };
}

/** `ITfHost` - the contact page's task actions speak in the hint under the composer. */
/** `IPfHost` - "Remove" in the page's Kept from AI posts to `/assist` as the owner. ⛔ It sends no message. */
class AppPinFrameLink implements IPfHost {
    private Owner: AppMain;
    private Number: string;
    private Secret: string;

    public constructor(Owner: AppMain, Number: string, Secret: string) {
        this.Owner = Owner;
        this.Number = Number;
        this.Secret = Secret;
    }

    public Post = (Body: string, Done: (Status: number, Text: string) => void): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Owner.AssistPost(Body, Done);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppPinFrameLink.Post");
        }
    };

    /** DOCUMENTED EXCEPTION: returns a value in hand; cannot throw. */
    public Phone = (): string => { return this.Number; };
    /** DOCUMENTED EXCEPTION: returns a value in hand; cannot throw. */
    public Key = (): string => { return this.Secret; };
}

class AppTaskFrameLink implements ITfHost {
    private Owner: AppMain;

    public constructor(Owner: AppMain) { this.Owner = Owner; }

    public Say = (Text: string, Bad: boolean): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Owner.ReactSay(Text, Bad);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppTaskFrameLink.Say");
        }
    };

    public Now = (): Date => {
        if (getCoreUtils().KErrorMode === true) { return new Date(); }
        try {
            return new Date();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppTaskFrameLink.Now");
            return new Date();
        }
    };
}

/**
 * `IAppNotifyHost` - the "Let <name> know?" cards' way back into the page. ⛔ Its `Send` is
 * `AppMain.NotifySend` -> `AppComposer.SendText`, reached only from a card's Send click.
 */
class AppTaskNotifyLink implements IAppNotifyHost {
    private LaterPort: AppWindowLater = new AppWindowLater();
    private Owner: AppMain;

    public constructor(Owner: AppMain) { this.Owner = Owner; }

    /** ⭐ A `retry` refusal's re-ask after `Ms` (`IAppNotifyHost.Later`). */
    // REUSE-JUSTIFIED: see `AppAssistHost.Later` - this class's `IAppNotifyHost.Later` over the shared `AppWindowLater`.
    public Later =(Ms: number, Then: () => void): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.LaterPort.Later(Math.max(0, Ms), Then);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppTaskNotifyLink.Later");
        }
    };

    public Phone = (): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            return this.Owner.TaskPhone();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppTaskNotifyLink.Phone");
            return "";
        }
    };

    public Key = (): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            return this.Owner.TaskKey();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppTaskNotifyLink.Key");
            return "";
        }
    };

    public Post = (Body: string, Done: AppAssistDone): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Owner.AssistPost(Body, Done);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppTaskNotifyLink.Post");
        }
    };

    public Send = (Href: string, Text: string, Then: IComposerSent): string => {
        if (getCoreUtils().KErrorMode === true) { return AppComposer.NoSendWhy(); }
        try {
            return this.Owner.NotifySend(Href, Text, Then);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppTaskNotifyLink.Send");
            return AppComposer.NoSendWhy();
        }
    };

    public Edit = (Href: string, Text: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Owner.NotifyEdit(Href, Text);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppTaskNotifyLink.Edit");
        }
    };

    public Outcome = (Href: string, Id: string, Outcome: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Owner.AssistOutcome(Href, Id, Outcome);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppTaskNotifyLink.Outcome");
        }
    };

    public Now = (): Date => {
        if (getCoreUtils().KErrorMode === true) { return new Date(); }
        try {
            return new Date();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppTaskNotifyLink.Now");
            return new Date();
        }
    };

    public Changed = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Owner.PaintNotes();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppTaskNotifyLink.Changed");
        }
    };

    public Acted = (Id: string, Outcome: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Owner.NoteActed(Id, Outcome);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppTaskNotifyLink.Acted");
        }
    };
}

/** `IAppTaskDecided` - a confirmed close or reopen, from the board and the frame alike. */
class AppTaskDecidedLink implements IAppTaskDecided {
    private Owner: AppMain;

    public constructor(Owner: AppMain) { this.Owner = Owner; }

    public Closed = (Row: AppRow): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Owner.TaskClosed(Row);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppTaskDecidedLink.Closed");
        }
    };

    public Reopened = (Id: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Owner.TaskReopened(Id);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppTaskDecidedLink.Reopened");
        }
    };
}

/**
 * `IComposerSender` for ONE named chat - the composer `AppMain.NotifySend` makes for a card's Send when
 * that chat is not on screen. ⛔ `AppMain.QueueTo`, the one page half of a send. Never a reaction.
 */
class AppSendToDoor implements IComposerSender {
    private Owner: AppMain;
    private Who: AppContact;
    /** ⭐ (2026-10-22) A search hit's face: this door may carry ONE reaction, watched by the hit (null = never reacts). */
    private Watch: IRxPending | null;

    public constructor(Owner: AppMain, Who: AppContact, Watch: IRxPending | null = null) {
        this.Owner = Owner;
        this.Who = Who;
        this.Watch = Watch;
    }

    public Queue = (Text: string, Then: IComposerSent, Translate: string = ""): string => {
        if (getCoreUtils().KErrorMode === true) { return AppComposer.NoSendWhy(); }
        try {
            return this.Owner.QueueTo(this.Who, Text, Then, Translate);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppSendToDoor.Queue");
            return AppComposer.NoSendWhy();
        }
    };

    /** A card never reacts (no watch); a search hit's face does - through the page's ONE `QueueReaction`. */
    public QueueReaction = (MessageId: string, Emoji: string, Then: IComposerSent): string => {
        if (getCoreUtils().KErrorMode === true) { return AppComposer.NoSendWhy(); }
        try {
            if (this.Watch === null) { return AppComposer.NoSendWhy(); }
            return this.Owner.QueueReaction(MessageId, Emoji, Then, this.Who, this.Watch);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppSendToDoor.QueueReaction");
            return AppComposer.NoSendWhy();
        }
    };
}

/** `IAppTrSendPort` over the page (`AppMain`) for one send to `Href`. A class, not a closure. */
class AppTrSendPortMain implements IAppTrSendPort {
    private Owner: AppMain;
    private Href: string;

    public constructor(Owner: AppMain, Href: string) {
        this.Owner = Owner;
        this.Href = Href;
    }

    public Write = (Req: AppSendRequest, Then: IComposerSent): string => {
        if (getCoreUtils().KErrorMode === true) { return AppComposer.NoSendWhy(); }
        try {
            return this.Owner.QueueWrite(this.Href, Req, Then);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppTrSendPortMain.Write");
            return AppComposer.NoSendWhy();
        }
    };

    public Hold = (Then: IComposerSent): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Owner.HoldSend(Then);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppTrSendPortMain.Hold");
        }
    };

    public Release = (): IComposerSent | null => {
        if (getCoreUtils().KErrorMode === true) { return null; }
        try {
            return this.Owner.ReleaseSend();
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppTrSendPortMain.Release");
            return null;
        }
    };

    public Say = (Text: string, Bad: boolean): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Owner.SendSay(Text, Bad);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppTrSendPortMain.Say");
        }
    };
}

/** `IAppTrPage` over the page (`AppMain`). A class, not a closure. */
// REUSE-JUSTIFIED: an interface adapter - it exists so `AppMain`'s private state never crosses into the composer,
// the panel, the bar or the frame; each method is one guarded forward to a DIFFERENT `AppMain` method, so folding them
// would still need one call per method plus a dispatch on a name string (judged an interface pass-through).
class AppTrPageLink implements IAppTrPage {
    private Owner: AppMain;

    public constructor(Owner: AppMain) { this.Owner = Owner; }

    public Resend = (Text: string, Translate: boolean, Then: IAppTrResent): string => {
        if (getCoreUtils().KErrorMode !== false) { return AppComposer.NoSendWhy(); }
        try {
            const Sent: string = true ? this.Owner.TranslateResend(Text, Translate, Then) : "";
            return Sent;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppTrPageLink." + "Resend");
            return AppComposer.NoSendWhy();
        }
    };

    public Say = (Text: string, Bad: boolean): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Owner.TranslateSay(Text, Bad);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppTrPageLink.Say");
        }
    };

    public Tell = (Href: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Owner.TranslateTell(Href);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppTrPageLink.Tell");
        }
    };
}

/** The chat list's live feed talks to the app through this - it can only hand over list news (no sender). */
class AppLiveListLink implements IAppLiveListHost {
    private Owner: AppMain;

    public constructor(Owner: AppMain) { this.Owner = Owner; }

    public OnList = (Items: AppLiveListItem[], Names: Record<string, string>, Built: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Owner.OnLiveList(Items, Names, Built);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppLiveListLink.OnList");
        }
    };
}

/** The three-pane shell's keeper asks the app for markup through this - the list, the tabs, one row's meta line. No sender. */
class AppThreeHost implements IThreeHost {
    private Owner: AppMain;

    public constructor(Owner: AppMain) { this.Owner = Owner; }

    public TabsHtml = (At: string): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            return this.Owner.ThreeTabs(At);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppThreeHost.TabsHtml");
            return "";
        }
    };

    public LeftHtml = (Current: string): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            return this.Owner.ThreeLeft(Current);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppThreeHost.LeftHtml");
            return "";
        }
    };

    public ListHtml = (Current: string): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            return this.Owner.ThreeList(Current);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppThreeHost.ListHtml");
            return "";
        }
    };

    public MetaHtml = (ChatId: string): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            return this.Owner.ThreeMeta(ChatId);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppThreeHost.MetaHtml");
            return "";
        }
    };

    public ListDrawn = (List: IThreeEl): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            this.Owner.ThreeDrawn(List);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppThreeHost.ListDrawn");
        }
    };
}

/** The "Chat settings" dialog resolves identity, translation and the focus's way back through its owning page. ⛔ No sender. */
class AppChatSettingsLink implements IAppChatSettingsHost {
    private Owner: AppMain;
    public constructor(Owner: AppMain) { this.Owner = Owner; }
    public Who = (Selected: AppContact): AppChatArchiveWho => {
        if (getCoreUtils().KErrorMode === true) { return new AppChatArchiveWho(); }
        try { return this.Owner.ChatSettingsWho(Selected); }
        catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppChatSettingsLink.Who"); return new AppChatArchiveWho(); }
    };
    public TranslatorFor = (Selected: AppContact): AppTranslator | null => {
        if (getCoreUtils().KErrorMode === true) { return null; }
        try { return this.Owner.ChatSettingsTranslator(Selected); }
        catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppChatSettingsLink.TranslatorFor"); return null; }
    };
    public SettingChanged = (_Selected: AppContact, _Setting: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try { this.Owner.ChatSettingConfirmed(); }
        catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppChatSettingsLink.SettingChanged"); }
    };
    public TranslationChanged = (Href: string, TurnedOn: boolean): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try { this.Owner.ChatSettingsTranslated(Href, TurnedOn); }
        catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppChatSettingsLink.TranslationChanged"); }
    };
    public Opener = (Selected: AppContact): HTMLElement | null => {
        if (getCoreUtils().KErrorMode === true) { return null; }
        try { return this.Owner.ChatSettingsOpener(Selected); }
        catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppChatSettingsLink.Opener"); return null; }
    };
}

/** One clipboard attempt with its own status target, so overlapping banners cannot redirect answers. */
class AppCodeCopyNote {
    private LineId: string;
    public constructor(LineId: string) { this.LineId = LineId; }
    public Copied = (): void => { this.Say("Copied."); };
    /** ERROR-SUPPRESSED-JUSTIFIED: clipboard refusal is a browser permission answer. */
    public Refused = (): void => { this.Say(AppMain.ByHand); };
    private Say = (Text: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Line: HTMLElement | null = document.getElementById(this.LineId);
            if (Line !== null) { Line.textContent = Text; }
        } catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppCodeCopy.Say"); }
    };
}

/** `IAppSearchActHost` over the page - each a forward to one `AppMain` member. */
// REUSE-JUSTIFIED: an interface adapter (see `AppAssistHost`) - it keeps `AppMain`'s private state out of the search panel.
class AppSearchActHost implements IAppSearchActHost {
    public constructor(private Owner: AppMain) { }

    public Reply = (Hit: AppSearchHit): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try { this.Owner.SearchOpenFor(Hit, AppSearchActRules.Reply); } catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppSearchActHost.Reply"); }
    };

    public Forward = (Hit: AppSearchHit): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try { this.Owner.SearchOpenFor(Hit, AppSearchActRules.Forward); } catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppSearchActHost.Forward"); }
    };

    public Ai = (Hit: AppSearchHit): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try { this.Owner.SearchAi(Hit); } catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppSearchActHost.Ai"); }
    };

    public React = (Hit: AppSearchHit, Emoji: string, Then: IComposerSent, Watch: IRxPending): string => {
        if (getCoreUtils().KErrorMode === true) { return AppComposer.NoSendWhy(); }
        try { return this.Owner.SearchReact(Hit, Emoji, Then, Watch); } catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppSearchActHost.React"); return AppComposer.NoSendWhy(); }
    };

    public Remind = (Hit: AppSearchHit, Heard: IAppTaskHeard): string => {
        if (getCoreUtils().KErrorMode === true) { return AppTaskRules.LostWhy(); }
        try { return this.Owner.SearchRemind(Hit, Heard); } catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppSearchActHost.Remind"); return AppTaskRules.LostWhy(); }
    };

    public Copy = (Text: string, Then: IAssistCopied): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try { new AppAssistCopyJob(nz(Text), Then).Start(); } catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppSearchActHost.Copy"); }
    };

    public Opts = (): AppSearchActOpts => {
        if (getCoreUtils().KErrorMode === true) { return new AppSearchActOpts(); }
        try { return this.Owner.SearchOpts(); } catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppSearchActHost.Opts"); return new AppSearchActOpts(); }
    };

    public Painted = (El: unknown): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try { this.Owner.SearchPainted(El); } catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppSearchActHost.Painted"); }
    };
}

/** A reminder's answer: the row joins the index, then the hit hears it. */
class AppSearchTaskHeard implements IAppTaskHeard {
    public constructor(private Owner: AppMain, private Then: IAppTaskHeard) { }

    public Done = (Task: AppRow | null, Changed?: boolean): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try { this.Owner.SearchTaskAdded(Task); this.Then.Done(Task, Changed); } catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppSearchTaskHeard.Done"); }
    };

    public Failed = (Why: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try { this.Then.Failed(Why); } catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppSearchTaskHeard.Failed"); }
    };
}
